/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */
/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler = (message, violations) => {
    const msg = JSON.stringify({
        type: 'Typewriter JSON Schema Validation Error',
        description: `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
            'Tracking Plan spec.',
        errors: violations,
    }, undefined, 2);
    console.warn(msg);
};
let analytics = () => {
    return window.analytics;
};
/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options) {
    analytics = options.analytics
        ? () => options.analytics || window.analytics
        : analytics;
}
/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message = {}) {
    return Object.assign(Object.assign({}, message), { context: Object.assign(Object.assign({}, (message.context || {})), { typewriter: {
                language: 'typescript',
                version: '7.4.1',
            } }) });
}
/**
 * @typedef AddAgentsModalFormSubmitted
 * @property {string} addTo - The entity that the agents are being added to
 * @property {any[]} selectedAgents - The selected agents to be added
 */
/**
 * @typedef AgentCopilotDropdownItemClicked
 * @property {string} key - The key name of the dropdown action item.
 */
/**
 * @typedef AgentCopilotTextInsertBelowClicked
 * @property {string} key - The key name of the original dropdown action item.
 */
/**
 * @typedef AgentCopilotTextReplaceClicked
 * @property {string} key - The key name of the original dropdown action item.
 */
/**
 * @typedef AgentCopilotTranslateMessageLanguageSelected
 * @property {string} context - The place where the selection happens
 * @property {string} language - The selected language.
 */
/**
 * @typedef AnalyticsBannerClicked
 * @property {string} location - The name of the location
 */
/**
 * @typedef AnalyticsBusinessHoursScheduleRemoved
 * @property {string} dashboard - The name of the dashboard
 * @property {string} [timezone] - The name of the timezone
 */
/**
 * @typedef AnalyticsBusinessHoursScheduleUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {string} [timezone] - The name of the timezone
 */
/**
 * @typedef AnalyticsChartGranularityChanged
 * @property {string} dashboard - The name of the dashboard
 * @property {string} granularity - The new granularity
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsChartVisualizationChanged
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 * @property {string} visualization - The new visualization
 */
/**
 * @typedef AnalyticsCompareClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsCompareContextUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 * @property {string} side - The side of the comparison
 */
/**
 * @typedef AnalyticsComparePeriodUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 * @property {string} side - The side of the comparison
 * @property {string} [timezone] - The name of the timezone
 * @property {string} value - The value of the selected period
 * @property {boolean} [withSchedule] -
 */
/**
 * @typedef AnalyticsContextUpdated
 * @property {string} dashboard - The name of the dashboard
 */
/**
 * @typedef AnalyticsConversationLinkClicked
 * @property {number} csid - The id of the conversation
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsConversationPreviewClicked
 * @property {number} csid - The id of the conversation
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsDashboardViewed
 * @property {string} name - The name of the dashboard
 */
/**
 * @typedef AnalyticsExportClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsExportDownloadClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} fileType - The type of the download
 * @property {string} instrumentType - The type of the instrument
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsExportMyDataButtonPressed
 * @property {number} numberOfDays - The number of days selected
 */
/**
 * @typedef AnalyticsFilterCleared
 * @property {string} dashboard - The name of the dashboard
 * @property {string} type - The type of the filter
 */
/**
 * @typedef AnalyticsFilterOpened
 * @property {string} dashboard - The name of the dashboard
 * @property {string} type - The type of the filter
 */
/**
 * @typedef AnalyticsFilterOperatorUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {string} operator - The operator of the filter
 * @property {string} type - The type of the filter
 */
/**
 * @typedef AnalyticsFilterValueAdded
 * @property {string} dashboard - The name of the dashboard
 * @property {boolean} [isNode] - Whether the value is a node, in the case of nested values
 * @property {string} type - The type of the filter
 * @property {string} value - The value of the filter
 */
/**
 * @typedef AnalyticsFiltersApplied
 * @property {string} dashboard - The name of the dashboard
 * @property {any[]} filters - The filters applied
 */
/**
 * @typedef AnalyticsFiltersCleared
 * @property {string} dashboard - The name of the dashboard
 */
/**
 * @typedef AnalyticsHelperClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsInDepthClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsInsightsClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsInsightsCopyClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 * @property {string} prompt - The name of the AI insight prompt
 */
/**
 * @typedef AnalyticsInsightsFeedbackClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} [feedback] - The feedback value
 * @property {string} panel - The name of the panel
 * @property {string} prompt - The name of the AI insight prompt
 * @property {string} [requestId] - The id of the backend request that generated the insight
 */
/**
 * @typedef AnalyticsInsightsPromptClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 * @property {string} prompt - The name of the AI insight prompt
 */
/**
 * @typedef AnalyticsInsightsRegenerateClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 * @property {string} prompt - The name of the AI insight prompt
 */
/**
 * @typedef AnalyticsLatestUpdatesClicked
 * @property {string} dashboard - The name of the dashboard
 */
/**
 * @typedef AnalyticsPeriodUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {string} [timezone] - The name of the timezone
 * @property {string} value - The value of the selected period
 */
/**
 * @typedef AnalyticsQuickViewCreated
 * @property {string} dashboard - The name of the dashboard
 * @property {any[]} filters - The array of selected filter fields
 * @property {string} period - The selected period identifier
 * @property {boolean} shared - Whether the quick view is shared
 */
/**
 * @typedef AnalyticsQuickViewDeleted
 * @property {boolean} shared - Whether the quick view is shared
 */
/**
 * @typedef AnalyticsQuickViewDuplicated
 * @property {string} dashboard - The name of the dashboard
 * @property {any[]} filters - The array of selected filter fields
 * @property {string} period - The selected period identifier
 * @property {boolean} shared - Whether the quick view is shared
 */
/**
 * @typedef AnalyticsQuickViewFavoriteToggled
 * @property {boolean} favorited - The value of the favorited toggle
 */
/**
 * @typedef AnalyticsQuickViewSharingToggled
 * @property {string} dashboard - The name of the dashboard
 * @property {boolean} shared - Whether the quick view is shared
 */
/**
 * @typedef AnalyticsQuickViewUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {any[]} filters - The array of selected filter fields
 * @property {string} period - The selected period identifier
 * @property {boolean} shared - Whether the quick view is shared
 */
/**
 * @typedef AnalyticsQuickViewViewed
 * @property {string} dashboard - The name of the dashboard
 * @property {boolean} shared - Whether the quick view is shared
 */
/**
 * @typedef AnalyticsRefreshClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} [panel] - The name of the panel
 */
/**
 * @typedef AnalyticsTableLoadAllClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsTableSortUpdated
 * @property {string} [column] - The name of the column
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AnalyticsTimezoneUpdated
 * @property {string} dashboard - The name of the dashboard
 * @property {string} timezone - The name of the timezone
 */
/**
 * @typedef AnalyticsViewConversationsClicked
 * @property {string} dashboard - The name of the dashboard
 * @property {string} panel - The name of the panel
 */
/**
 * @typedef AutocompleteSuggestionMismatchDetected
 * @property {string} conversationId - The ID of the current conversation
 * @property {string} mismatchedUserInput - The word the user typed instead of the suggested one
 * @property {string} seed - The input text that the language model received
 * @property {boolean} suggestionRevealed - Indicates if the suggestion was revealed to the user before the mismatch
 * @property {string} textSuggestion - The text suggestion that is suggested by the language model
 */
/**
 * @typedef AutocompleteSuggestionRemoved
 * @property {string} conversationId - The ID of the current conversation
 * @property {number} escapeKeyPressCount - Number of times the "Escape" key is pressed to remove the autocomplete suggestion in a session
 * @property {string} seed - The input text that the language model received
 * @property {string} textSuggestion - The text suggestion that is suggested by the language model
 */
/**
 * @typedef AutocompleteSuggestionSelected
 * @property {string} conversationId - The ID of the current conversation
 * @property {string} seed - The input text that the language model received
 * @property {number} tabKeyPressCount - Number of times the "Tab" key is pressed to select the autocomplete suggestion in a session
 * @property {string} textSuggestion - The text suggestion that is suggested by the language model
 */
/**
 * @typedef AutocompleteToggleClicked
 * @property {string} conversationId - The ID of the current conversation
 * @property {string} switchedTo - Indicates which state the conversation editor autocomplete feature was switched to
 */
/**
 * @typedef AutomationsFormCancelled
 * @property {string} [mode] - Whether the form was in create or update mode
 * @property {string} [step] - Which step of the form the user was on
 */
/**
 * @typedef AutomationsFormOpened
 * @property {string} mode - Whether the form was opened in create or update mod
 */
/**
 * @typedef AutomationsFormSubmitted
 * @property {string} mode - Whether the form was opened in create or update mode
 * @property {string} [step] - Which step of the form the user was on
 */
/**
 * @typedef BansBanUserClicked
 * @property {string} channel - The channel to ban from
 * @property {boolean} ipChecked - Is the "also ban IP" checkbox checked
 */
/**
 * @typedef BansUnbanUserClicked
 * @property {string} channel - The channel to unban from
 */
/**
 * @typedef BulkActionsUpdateClicked
 * @property {number} conversationsCount - The amount of conversations bulk action is applied on
 * @property {string} [location] - The location of the bulk actions functionality
 * @property {string} modalVersion - The version of the modal that the action is triggered in
 * @property {any[]} selectedActions - The selected actions when the Update button is clicked
 * @property {number} selectedActionsCount - The amount of selected actions
 */
/**
 * @typedef BusinessHoursAddScheduleAudioMessageAdded
 * @property {string} type - The type of the user interaction.
 */
/**
 * @typedef BusinessHoursAddScheduleFormSubmitted
 * @property {string} [countryCode] - The country code of the selected holiday calendar.
 * @property {boolean} [isClosed] - Whether the user set business hours to "closed" on holidays.
 */
/**
 * @typedef BusinessHoursFirstScheduleModalQuestionClicked
 * @property {number} question - The number of the question.
 */
/**
 * @typedef BusinessHoursMigrationWizardAudioMessageAdded
 * @property {string} type - The type of the user interaction.
 */
/**
 * @typedef BusinessHoursMigrationWizardFormCancelled
 * @property {number} step - The active step.
 */
/**
 * @typedef BusinessHoursMigrationWizardFormSubmitted
 * @property {string} [countryCode] - The selected country code.
 * @property {boolean} [hangUpAfterAnnouncement] - The hangUpAfterAnnouncement property value.
 * @property {boolean} [hasIntervalsChanged] - Whether the intervals has changed.
 * @property {boolean} [isClosed] - Whether the user set business hours to "closed" on holidays.
 * @property {number} step - The active step.
 */
/**
 * @typedef BusinessHoursRenameScheduleFormCancelled
 * @property {string} [view] - The view where the modal was opened from.
 */
/**
 * @typedef BusinessHoursRenameScheduleFormSubmitted
 * @property {string} [view] - The view where the modal was opened from.
 */
/**
 * @typedef BusinessHoursScheduleAudioMessageFormCancelled
 * @property {string} openingHourType - The type of the item.
 * @property {string} type - Whether the modal was open in record or upload mode.
 */
/**
 * @typedef BusinessHoursScheduleAudioMessageFormSubmitted
 * @property {string} openingHourType - The type of the item.
 * @property {string} type - Whether the modal was open in record or upload mode.
 */
/**
 * @typedef BusinessHoursScheduleAudioMessageOptionsMenuOpened
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAutoReplyFormCancelled
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAutoReplyFormSubmitted
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAutoReplyOptionsMenuOpened
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAutoReplyOptionsMenuOptionAddClicked
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleEditFormSubmitted
 * @property {string} [countryCode] - The country code of the selected holiday calendar.
 * @property {boolean} [isClosed] - Whether the user set business hours to "closed" on holidays.
 */
/**
 * @typedef BusinessHoursScheduleExceptionOptionsMenuOpened
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked
 * @property {string} openingHourType - The type of the item.
 */
/**
 * @typedef BusinessHoursScheduleImportHolidayFormSubmitted
 * @property {string} countryCode - The country code of the selected holiday calendar.
 * @property {boolean} isClosed - Whether the user set business hours to "closed" on holidays.
 */
/**
 * @typedef BusinessHoursSchedulePreviewButtonClicked
 * @property {string} [view] - The active view when the button was clicked.
 */
/**
 * @typedef BusinessHoursScheduleTabClicked
 * @property {string} view - The type of the view.
 */
/**
 * @typedef BusinessHoursScheduleViewClicked
 * @property {string} tab - The active tab.
 * @property {string} view - The clicked view button.
 */
/**
 * @typedef BusinessHoursSchedulesSwitchClicked
 * @property {string} view - The type of the view.
 */
/**
 * @typedef ChatFormCanceled
 * @property {string} mode - Whether the create or update form was canceled
 */
/**
 * @typedef ChatFormOpened
 * @property {string} mode - Whether the create or update form was opened
 */
/**
 * @typedef ChatFormSubmitted
 * @property {string} mode - Whether the create or update form was opened
 */
/**
 * @typedef ClearAllFiltersClicked
 * @property {string} context - The context of the Clear All Filters button
 */
/**
 * @typedef CloseConversationClicked
 * @property {string} context - The context of the close conversation button
 */
/**
 * @typedef CommandExecuted
 * @property {string} commandName - The name of the executed command.
 * @property {string} [keybinding] - The command keybinding used to perform the action.
 * @property {string} location - The location where the command was executed from.
 */
/**
 * @typedef CompanyModalFormSubmitted
 * @property {string} mode - Whether the modal is for adding or editing a company
 */
/**
 * @typedef ContactsBanUserClicked
 * @property {string} channel - The channel to ban from
 */
/**
 * @typedef ContactsCardViewConversationClicked
 * @property {string} location - Where the click took place
 */
/**
 * @typedef ContactsUnbanUserClicked
 * @property {string} channel - The channel to unban from
 */
/**
 * @typedef ConversationActionsMenuOptionClicked
 * @property {string} option - The selected option
 */
/**
 * @typedef ConversationActivityLogOpened
 * @property {string} context - Where the Activity Log was opened from
 */
/**
 * @typedef TagsItem
 * @property {string} id - The ID of the tag
 * @property {string} name - The name of the tag
 */
/**
 * @typedef ConversationClaimed
 * @property {string} [channel] - The channel of the conversation
 * @property {number} conversationId - ID of the conversation
 * @property {string} [language] - The language of the conversation
 * @property {string} location - From where the conversation is claimed
 * @property {TagsItem[]} [tags] - The tags of the conversation
 * @property {string} type - Type of the claim.
 */
/**
 * @typedef TagsItem1
 * @property {string} id - The ID of the tag
 * @property {string} name - The name of the tag
 */
/**
 * @typedef ConversationClosed
 * @property {string} [channel] - The channel the conversation used
 * @property {string} [direction] - The direction of the conversation
 * @property {string} [language] - The language of the conversation
 * @property {string} location - From where the conversation has been closed
 * @property {TagsItem1[]} [tags] - The tags associated with the conversation
 */
/**
 * @typedef ConversationCsatMenuLanguageSelected
 * @property {string} languageCode - The selected language code
 */
/**
 * @typedef ConversationFollowUp
 * @property {number} conversationId - ID of the conversation
 */
/**
 * @typedef ConversationFollowUpMenuOptionClicked
 * @property {string} option - The selected option
 */
/**
 * @typedef ConversationHeaderTagAdded
 * @property {number} csid - The conversation id
 * @property {string} tag - The name of the tag
 */
/**
 * @typedef ConversationHeaderTagIncludeDeactivatedToggled
 * @property {boolean} include - whether to include deactivated tags
 */
/**
 * @typedef ConversationHeaderTagRemoved
 * @property {number} csid - The conversation id
 * @property {string} tag - The name of the tag
 */
/**
 * @typedef ConversationHeaderTransferToQueueItemSelected
 * @property {string} queue - The name of the selected queue
 */
/**
 * @typedef ConversationOffered
 * @property {string} channel - The channel of the conversation
 * @property {number} conversationId - ID of the conversation
 * @property {string} direction - The direction of the conversation
 * @property {string} offerType - The type of conversation offer
 * @property {string} timeout - The timeout of the offer
 */
/**
 * @typedef TagsItem2
 * @property {string} id - The ID of the tag
 * @property {string} name - The name of the tag
 */
/**
 * @typedef ConversationReplied
 * @property {string} [channel] - The channel the conversation happens on
 * @property {string} [language] - The language of the conversation
 * @property {TagsItem2[]} [tags] - The tags applied to the conversation
 */
/**
 * @typedef ConversationResolvedAsAKnowledgeArticleDraft
 * @property {string} conversationId - ID of the conversation
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 */
/**
 * @typedef ConversationResolvedAsAKnowledgeGap
 * @property {string} conversationId - ID of the conversation
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 * @property {string[]} suggestedArticleIds - The articles being viewed at the time when the knowledge gap was registered
 */
/**
 * @typedef ConversationResolvedByKnowledge
 * @property {string} conversationId - ID of the conversation
 * @property {string[]} helpfulArticleIds - List of article ID's marked as being helpful
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 * @property {string[]} suggestedArticleIds - List of article ID's that were presented to the user for consideration prior to the user choosing a helpful article
 */
/**
 * @typedef ConversationResolvedWithNoKnowledgeArticle
 * @property {string} conversationId - ID of the conversation
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 * @property {string[]} suggestedArticleIds - List of article ID's that were presented to the user for consideration prior to the user choosing a helpful article
 */
/**
 * @typedef ConversationTransferMenuOptionClicked
 * @property {string} option - The selected option
 */
/**
 * @typedef ConversationTransferred
 * @property {number} conversationId - ID of the conversation
 * @property {string} option - Whether it was transferred to agent, queue, or number.
 */
/**
 * @typedef ConversationViewed
 * @property {string} queueId - The id of the queue the conversation belongs to
 */
/**
 * @typedef ConversationSummaryFeedbackNotUseful
 * @property {string} summaryId - The id of the generated summary
 */
/**
 * @typedef ConversationSummaryFeedbackUseful
 * @property {string} summaryId - The id of the generated summary
 */
/**
 * @typedef ConversationSummaryRegenerateSummary
 * @property {string} summaryId - The id of the generated summary
 */
/**
 * @typedef ConversationsBulkActionsClicked
 * @property {string} [location] - The location of the bulk actions functionality
 * @property {string} modalVersion - The version of the modal to open
 */
/**
 * @typedef ConversationsFilterAgentClicked
 * @property {string} id - The id of the agent
 */
/**
 * @typedef ConversationsFilterCleared
 * @property {string} filter - The name of the filter
 */
/**
 * @typedef ConversationsFilterContactClicked
 * @property {string} id - The id of the contact
 */
/**
 * @typedef ConversationsFilterToggled
 * @property {string} filter - The name of the filter
 * @property {string} [value] - The value of the filter
 */
/**
 * @typedef ConversationsItemAssigneeClicked
 * @property {boolean} assigned - Whether or not the clicked link is for an assigned agent
 */
/**
 * @typedef ConversationsSelectClicked
 * @property {number} csid - The conversation ID
 * @property {boolean} selected - The selected state of the conversation
 */
/**
 * @typedef ConversationsTimestampClicked
 * @property {string} context - The context of the clicked timestamp
 */
/**
 * @typedef ConversationsViewConversationsClicked
 * @property {string} context -
 */
/**
 * @typedef CustomAttributeValueUpdated
 * @property {string} attributeId - The id of the updated custom attribute
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {string} entityInstanceId - The id of the entity instance of the updated custom attribute
 * @property {string} type - The type of the custom attribute
 */
/**
 * @typedef DashboardQueueItemFavoriteToggled
 * @property {boolean} value - The value of the toggle
 */
/**
 * @typedef DashboardQueuesTypeChanged
 * @property {string} location - From where the change has been triggered
 * @property {string} type - The type of the queues
 */
/**
 * @typedef EmailFormCancelled
 * @property {string} mode - Whether the form was in create, update, duplicate, or rename mode
 */
/**
 * @typedef EmailFormOpened
 * @property {string} mode - Whether the form was opened in create, update, duplicate, or rename mode
 */
/**
 * @typedef EmailFormSubmitted
 * @property {string} mode - Whether the form was opened in create, update, duplicate, or rename mode
 */
/**
 * @typedef FlowActionAddSaved
 * @property {string} flowType - The type of flow
 * @property {string} nodeType - The type of action
 * @property {any | null} [settings] - The list of node settings applied
 */
/**
 * @typedef FlowActionConditionAdded
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowActionConditionRemoved
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowActionDeleted
 * @property {string} flowType - The type of flow
 * @property {string} nodeType - The type of node
 */
/**
 * @typedef FlowActionEditClicked
 * @property {string} flowType - The type of flow
 * @property {string} nodeType - The type of action
 */
/**
 * @typedef FlowActionEditSaved
 * @property {string} flowType - The type of flow
 * @property {string} nodeType - The type of action
 * @property {any | null} [settings] - The list of node settings applied
 */
/**
 * @typedef FlowActivateClicked
 * @property {string} flowType - The type of flow that was saved
 */
/**
 * @typedef FlowAddActionActionSelected
 * @property {string} flowType - The type of flow
 * @property {string} nodeType - The nodetype to be added
 */
/**
 * @typedef FlowAddActionCancelled
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowAddActionOpened
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowBackToSettingsClicked
 * @property {string} flowType - The type of flow
 * @property {string} [path] - The url path where the button was redirected to
 * @property {boolean} warned - Whether the user was warned of unsaved changes
 */
/**
 * @typedef FlowContextAlignClicked
 * @property {string} flowType -
 */
/**
 * @typedef FlowContextDeleteCancelClicked
 * @property {string} flowType -
 */
/**
 * @typedef FlowContextDeleteClicked
 * @property {string} flowType -
 */
/**
 * @typedef FlowContextDeleteConfirmClicked
 * @property {string} flowType -
 */
/**
 * @typedef FlowContextNodeArrangeClicked
 * @property {string} flowType -
 */
/**
 * @typedef FlowSaveClicked
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowTitleEditClicked
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowZoomInClicked
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowZoomOutClicked
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef FlowZoomResetClicked
 * @property {string} flowType - The type of flow
 */
/**
 * @typedef KnowledgeArticleArchived
 * @property {string} articleId - UUID of the article that has been archived
 */
/**
 * @typedef KnowledgeArticleChangesDiscarded
 * @property {string} articleId - UUID of the article that has had changed discarded
 */
/**
 * @typedef KnowledgeArticleCreated
 * @property {string} articleId - UUID of the article created
 * @property {string} [collectionId] - UUID of the collection that created article is added to
 * @property {string} [parentCategoryId] - UUID of the category that created article is added to
 * @property {string} source - Produce or delivery method that an article has been created from
 */
/**
 * @typedef KnowledgeArticleDestroyed
 * @property {string} articleId - UUID of the article that has been deleted
 */
/**
 * @typedef KnowledgeArticleFeedbackSubmitted
 * @property {string} articleId - ID of the article that has received feedback
 * @property {string} articleLastPublishedAt - Date when article was last published
 * @property {string} conversationId - ID of the conversation
 * @property {string} [knowledgeSource] - Where the event originated from - Elevio or Dixa Knowledge
 * @property {string} source - What type of delivery method did the user give article feedback in (eg internal kb, messenger)
 */
/**
 * @typedef KnowledgeArticleMarkedAsHelpful
 * @property {string} assistType - What type of assist invoked the resolution
 * @property {string} conversationId - ID of the conversastion
 * @property {string[]} helpfulArticleIds - List of article ID's marked as being helpful
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 * @property {string[]} suggestedArticleIds - List of article ID's that were presented to the user for consideration prior to the user choosing a helpful article
 */
/**
 * @typedef KnowledgeArticleMoved
 * @property {string} articleId - ID of the article that has been moved
 * @property {string} source - What type of delivery method did the user move the article in (eg internal kb, messenger)
 */
/**
 * @typedef KnowledgeArticlePublished
 * @property {string} articleId - UUID of the article published
 */
/**
 * @typedef KnowledgeArticleReordered
 * @property {string} articleId - UUID of the article that has been re-ordered
 */
/**
 * @typedef KnowledgeArticleTagAdded
 * @property {string} articleId - UUID of the article the tag was added to
 */
/**
 * @typedef KnowledgeArticleTagRemoved
 * @property {string} articleId - UUID of the article that the tag has been removed from
 */
/**
 * @typedef KnowledgeArticleUnpublished
 * @property {string} articleId - UUID of the article that has been unpublished
 */
/**
 * @typedef KnowledgeArticleUpdated
 * @property {string} articleId - UUID of the updated article
 */
/**
 * @typedef KnowledgeArticleViewed
 * @property {string} articleId - ID of the article that has been viewed
 * @property {string} [collectionId] - ID of the collection that the user is viewing the article in
 * @property {string} [conversationId] - ID of the conversation
 * @property {string} [deliveryId] - Identifier of the delivery container (eg. knowledge base id, messenger id)
 * @property {string} [knowledgeSource] - Where the event originated from - Elevio or Dixa Knowledge
 * @property {string} source - What type of delivery method did the user view the article in (eg internal kb, messenger)
 */
/**
 * @typedef KnowledgeArticlesSearchByTermSubmitted
 * @property {string} [collectionId] - UUID of the collection that is linked to the queueId of the currently viewed conversation
 * @property {string} [deliveryId] - Identifier of the delivery container (eg. knowledge base ID, conversation ID)
 * @property {string} [source] - Product or delivery method that an article has been created from
 */
/**
 * @typedef KnowledgeCategoryCreated
 * @property {string} categoryId - UUID of the category created
 * @property {string} [collectionId] - UUID of the collection the category was created in
 */
/**
 * @typedef KnowledgeCategoryDestroyed
 * @property {string} categoryId - UUID of the category that has been deleted
 * @property {string} [collectionId] - UUID of the collection that the category has been deleted in
 */
/**
 * @typedef KnowledgeCategoryReordered
 * @property {string} categoryId - UUID of the category that has been re-ordered in the knowledge management screen
 */
/**
 * @typedef KnowledgeCategoryUpdated
 * @property {string} categoryId - UUID of the category that has been updated
 * @property {string} [collectionId] - UUID of the collection that the category has been updated in
 */
/**
 * @typedef KnowledgeCollectionCreated
 * @property {string} collectionId - UUID of the collection created
 */
/**
 * @typedef KnowledgeCollectionDestroyed
 * @property {string} collectionId - UUID of the collection that has been deleted
 */
/**
 * @typedef KnowledgeCollectionUpdated
 * @property {string} action - Type of action that has been performed on the resource
 * @property {string} collectionId - UUID of the collection that has been updated
 * @property {string} resourceId - UUID of the resource the collection was linked/unlinked to
 * @property {string} resourceType - Type of resource that was linked or unlinked to the collection
 */
/**
 * @typedef KnowledgeCollectionViewed
 * @property {string} collectionId - UUID of the collection that has been viewed
 * @property {string} source - What type of delivery method did the user view the collection in (eg internal kb, messenger)
 */
/**
 * @typedef KnowledgeInternalKbSearchResultClicked
 * @property {string} articleId - UUID of the article clicked from Internal KB search results
 * @property {string} collectionId - UUID of the collection that the search result originated from
 */
/**
 * @typedef KnowledgeResolutionCancelled
 * @property {string} conversationId - ID of the conversation
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 */
/**
 * @typedef KnowledgeResolutionInitialised
 * @property {string} conversationId - ID of the conversation
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 */
/**
 * @typedef MessengerFormCancelled
 * @property {string} [mode] - The form/modal that was closed/cancelled
 */
/**
 * @typedef MessengerFormOpened
 * @property {string} [mode] - The form/modal that was opened
 */
/**
 * @typedef MessengerFormSubmitted
 * @property {string} mode -
 */
/**
 * @typedef MessengerOptionsMenuOptionClicked
 * @property {string} option - The option that was clicked
 */
/**
 * @typedef ModalConversationCloseConfirmClicked
 * @property {number} csid - The id of the conversation to close
 */
/**
 * @typedef ModalTransferToQueueConfirmClicked
 * @property {number} csid - The id of the conversation to transfer
 * @property {string} queueId - The id of the queue to transfer to
 */
/**
 * @typedef NetworkConnectionStatusChanged
 * @property {string} status - Whether the user went online or offline
 */
/**
 * @typedef NotificationOfferAccepted
 * @property {string} [channel] - The channel of the conversation
 */
/**
 * @typedef NotificationOfferClosed
 * @property {string} [channel] - The channel of the conversation
 */
/**
 * @typedef NotificationOfferRejected
 * @property {string} [channel] - The channel of the conversation
 */
/**
 * @typedef NotificationTransferOfferAccepted
 * @property {string} [channel] - The channel of the conversation
 */
/**
 * @typedef NotificationTransferOfferClosed
 * @property {string} [channel] - The channel of the conversation
 */
/**
 * @typedef NotificationTransferOfferRejected
 * @property {string} [channel] - The channel of the conversation
 */
/**
 * @typedef OrganizationsNavigationOrganizationClicked
 * @property {string} id - The id of the organization clicked
 * @property {string} name - The name of the organization clicked
 * @property {string} subdomain - The subdomain of the organization clicked
 */
/**
 * @typedef PageViewed
 * @property {string} [path] -
 * @property {string} [referrer] -
 * @property {string} [search] -
 * @property {string} [title] -
 * @property {string} [url] -
 */
/**
 * @typedef PartnerIntegrationsGithubCreateNewIssueCanceled
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubCreateNewIssueClicked
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubCreateNewIssueConfirmed
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubLinkIssueClicked
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubUnlinkAllIssuesCanceled
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubUnlinkAllIssuesClicked
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubUnlinkAllIssuesConfirmed
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubUnlinkIssueCanceled
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubUnlinkIssueClicked
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubUnlinkIssueConfirmed
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsGithubViewLinkClicked
 * @property {string} [githubOrganization] - The Github organization.
 */
/**
 * @typedef PartnerIntegrationsJiraCommentsCollapsed
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsJiraCommentsExpanded
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsJiraLinkIssueClicked
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsJiraOpenIssueClicked
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsJiraOpenJiraClicked
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsJiraRemoveAllDanglingClicked
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsJiraRemoveDanglingIssueClicked
 * @property {string} jiraDanglingIssueKey - Key of the removed dangling issue
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsJiraUnlinkAllIssuesCancelled
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsJiraUnlinkAllIssuesClicked
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsJiraUnlinkAllIssuesConfirmed
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsJiraUnlinkIssueCancelled
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsJiraUnlinkIssueClicked
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsJiraUnlinkIssueConfirmed
 * @property {string} jiraInstanceUrl - URL of the Jira instance configured for the widget
 * @property {string} jiraIssueKey - Key of the Jira issue
 */
/**
 * @typedef PartnerIntegrationsKlaviyoProfileUnsubscribeClicked
 * @property {string} [channel] - The channel that got unsubscribed.
 */
/**
 * @typedef PartnerIntegrationsLinearCreateNewIssueCancelled
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsLinearCreateNewIssueClicked
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsLinearCreateNewIssueConfirmed
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 */
/**
 * @typedef PartnerIntegrationsLinearLinkIssueClicked
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 * @property {string} linearIssueKey - The key of the Linear issue
 */
/**
 * @typedef PartnerIntegrationsLinearOpenIssueClicked
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 * @property {string} linearIssueKey - The key of the Linear issue
 */
/**
 * @typedef PartnerIntegrationsLinearOpenLinearClicked
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 * @property {string} linearIssueKey - The key of the Linear issue
 */
/**
 * @typedef PartnerIntegrationsLinearUnlinkIssueClicked
 * @property {string} linearInstanceUrl - The URL of the Linear instance configured for the widget
 * @property {string} linearIssueKey - The key of the Linear issue
 */
/**
 * @typedef PartnerIntegrationsSettingsCreateSubmitted
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsOverviewCreated
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsOverviewViewed
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewBackToOverviewClicked
 * @property {string} from - The page the user visited before clicking on the back button
 * @property {string} [widgetId] - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewDeleteCanceled
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewDeleteConfirmed
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewDeleteRequested
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewOAuthStarted
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewOAuthSucceeded
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsSettingsViewSubmitted
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderCollapseClosed
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderCollapseOpened
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted
 * @property {string} orderId - The id of the widget
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderRefundCanceled
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderRefundConfirmed
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderRefundRequested
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked
 * @property {string} orderId - The id of the order
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetRefreshed
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked
 * @property {string} shopifyId - The id of the shopify integration
 */
/**
 * @typedef PartnerIntegrationsWidgetCollapseClosed
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PartnerIntegrationsWidgetCollapseOpened
 * @property {string} widgetId - The id of the widget
 * @property {string} widgetType - The type of the widget
 */
/**
 * @typedef PhoneRecordingDownloaded
 * @property {string} channel - The channel of the conversation
 * @property {number} createdAt - The Unix timestamp of the creation date of the conversation
 * @property {string} csid - The id of the conversation
 * @property {number} currentTimestamp - The Unix timestamp of the event occurrence
 * @property {string} direction - The direction of the conversation
 * @property {number} progress - The progress of the recording playback in seconds at the time of the event
 * @property {number} recordingDuration - The total duration of the recording in seconds
 */
/**
 * @typedef PhoneRecordingPauseClicked
 * @property {string} channel - The channel of the conversation
 * @property {number} createdAt - The Unix timestamp of the creation date of the conversation
 * @property {string} csid - The id of the conversation
 * @property {number} currentTimestamp - The Unix timestamp of the event occurrence
 * @property {string} direction - The direction of the conversation
 * @property {number} progress - The progress of the recording playback in seconds at the time of the event
 * @property {number} recordingDuration - The total duration of the recording in seconds
 */
/**
 * @typedef PhoneRecordingPlayClicked
 * @property {string} channel - The channel of the conversation
 * @property {number} createdAt - The Unix timestamp of the creation date of the conversation
 * @property {string} csid - The id of the conversation
 * @property {number} currentTimestamp - The Unix timestamp of the event occurrence
 * @property {string} direction - The direction of the conversation
 * @property {number} progress - The progress of the recording playback in seconds at the time of the event
 * @property {number} recordingDuration - The total duration of the recording in seconds
 */
/**
 * @typedef PhoneRecordingPlaybackAbandoned
 * @property {string} channel - The channel of the conversation
 * @property {number} createdAt - The Unix timestamp of the creation date of the conversation
 * @property {string} csid - The id of the conversation
 * @property {number} currentTimestamp - The Unix timestamp of the event occurrence
 * @property {string} direction - The direction of the conversation
 * @property {number} progress - The progress of the recording playback in seconds at the time of the event
 * @property {number} recordingDuration - The total duration of the recording in seconds
 */
/**
 * @typedef PhoneRecordingPlaybackEnded
 * @property {string} channel - The channel of the conversation
 * @property {number} createdAt - The Unix timestamp of the creation date of the conversation
 * @property {string} csid - The id of the conversation
 * @property {number} currentTimestamp - The Unix timestamp of the event occurrence
 * @property {string} direction - The direction of the conversation
 * @property {number} progress - The progress of the recording playback in seconds at the time of the event
 * @property {number} recordingDuration - The total duration of the recording in seconds
 */
/**
 * @typedef PresenceMediaUpdated
 * @property {boolean} enabled - Whether the media channel is turned on or off
 * @property {string} location - Where the toggle is placed
 * @property {string} media - The media channel updated
 */
/**
 * @typedef PresenceUpdated
 * @property {string} location - Where the toggle is placed
 * @property {string} status - The presence status, can be Away or Working
 */
/**
 * @typedef PushNotificationPlatformFormCancelled
 * @property {string} [mode] - The form/modal that was closed/cancelled
 */
/**
 * @typedef PushNotificationPlatformFormOpened
 * @property {string} [mode] -
 */
/**
 * @typedef PushNotificationPlatformFormSubmitted
 * @property {string} mode -
 */
/**
 * @typedef SavedSearchCreated
 * @property {boolean} saveAsNew - Whether the new saved search was created from an existing saved search
 */
/**
 * @typedef SearchContactPreviewClosed
 * @property {string} type - The contact type: "user" or "company"
 */
/**
 * @typedef SearchContactPreviewGoToClicked
 * @property {string} type - The contact type: "user" or "company"
 */
/**
 * @typedef SearchContactPreviewOpened
 * @property {string} type - The contact type: "user" or "company"
 */
/**
 * @typedef SearchContactTypeChanged
 * @property {string} type - The contact type: "user" or "company"
 */
/**
 * @typedef SearchConversationPreviewGoToClicked
 * @property {string} csid - The id of the conversation that was selected
 * @property {string} query - The search query
 */
/**
 * @typedef SearchConversationPreviewOpened
 * @property {string} csid - The id of the conversation that was selected
 * @property {string} query - The search query
 */
/**
 * @typedef SearchFieldBlurred
 * @property {string} location - Where the search field is placed
 */
/**
 * @typedef SearchFieldCleared
 * @property {string} location - Where the search field is placed
 */
/**
 * @typedef SearchFieldFocused
 * @property {string} location - Where the search field is placed
 */
/**
 * @typedef SearchFieldPopulated
 * @property {string} location - Where the search field is placed
 */
/**
 * @typedef SearchFieldSubmitted
 * @property {boolean} [isEmpty] - Whether the search is made with an empty value
 * @property {string} location - Where the search field is placed
 * @property {string} query - The search query
 */
/**
 * @typedef SearchFilterAdded
 * @property {string} location - The location of the filter
 * @property {string} type - The type of the filter
 * @property {string} [value] - The value of the filter
 */
/**
 * @typedef SearchFilterCleared
 * @property {string} location - The location of the filter
 * @property {string} type - The type of the filter
 */
/**
 * @typedef SearchFilterConditionAdded
 * @property {string} [location] - The location from where the condition is added
 * @property {string} type - The type of the filter
 */
/**
 * @typedef SearchFilterConditionRemoved
 * @property {string} type - The type of the filter
 */
/**
 * @typedef SearchFilterOperatorUpdated
 * @property {string} operator - The operator of the filter
 * @property {string} type - The type of the filter
 */
/**
 * @typedef SearchFilterRemoved
 * @property {string} location - The location of the filter
 * @property {string} type - The type of the filter
 * @property {string} [value] - The value of the filter
 */
/**
 * @typedef SearchFilterStrategyUpdated
 * @property {string} strategy - The selected filtering strategy
 */
/**
 * @typedef SearchFilterValueAdded
 * @property {string} [operator] - The operator of the filter
 * @property {string} type - The type of the filter
 * @property {string} [value] - The value of the filter
 */
/**
 * @typedef SearchFilterValueCleared
 * @property {number} [count] - The total number of filter values cleared
 * @property {string} type - The type of the filter
 */
/**
 * @typedef SearchFiltersApplied
 * @property {number} count - The total number of filters applied
 * @property {boolean} hasKeyword - Whether there is a keyword in the search
 */
/**
 * @typedef SearchFiltersCleared
 * @property {number} count - The total number of active filters
 */
/**
 * @typedef SearchFiltersClosed
 * @property {number} count - The total number of active filters
 */
/**
 * @typedef SearchFiltersOpened
 * @property {number} count - The total number of active filters
 */
/**
 * @typedef SearchFiltersValidationFailed
 * @property {Record<string, any>} errors - The list of validation errors
 */
/**
 * @typedef SearchSortingUpdated
 * @property {string} tab - The search tab
 * @property {string} type - The type of sorting
 */
/**
 * @typedef SearchStrictToggled
 * @property {boolean} value - Strict search is either true (enabled) or false (disabled)
 */
/**
 * @typedef SearchTabOpened
 * @property {string} tab - The search tab
 */
/**
 * @typedef SettingsAgentsTabClicked
 * @property {string} tab - The selected tab
 */
/**
 * @typedef SettingsAgentsWorkloadsFormSubmitted
 * @property {Record<string, any>} payload - The payload used as workload limits
 */
/**
 * @typedef SettingsAudioDeleteCancelClicked
 * @property {string} filename - The pretty name of the audio file
 * @property {string} type - Type of audio that is being interacted with
 */
/**
 * @typedef SettingsAudioDeleteClicked
 * @property {string} filename - The pretty name of the audio file
 * @property {string} type - Type of audio that is being interacted with
 */
/**
 * @typedef SettingsAudioDeleteConfirmClicked
 * @property {string} filename - The pretty name of the audio file
 * @property {string} type - Type of audio that is being interacted with
 */
/**
 * @typedef SettingsAudioDeleteWaitMusicClicked
 * @property {string} [filename] - The name of the wait music file
 */
/**
 * @typedef SettingsAudioUploadWaitMusic
 * @property {string} [filename] - The name of the wait music file
 */
/**
 * @typedef SettingsAudioUsageFlowClicked
 * @property {string} filename - The audio file's pretty name
 * @property {string} type - Type of audio that is being interacted with
 */
/**
 * @typedef SettingsAudioUsageLinkClicked
 * @property {string} filename - The audio file's pretty name
 * @property {string} type - Type of audio that is being interacted with
 */
/**
 * @typedef SettingsAudioWaitMusicUsageLinkClicked
 * @property {string} [filename] - The name of the wait music file
 */
/**
 * @typedef SettingsBillingAddCardButtonClicked
 * @property {string} buttonPlacement - The placement of the clicked button
 */
/**
 * @typedef SettingsCommandsAssignKeybindings
 * @property {string} commandName - The name of the command that its keybinding is being unassigned
 * @property {string} newKeybindings - The new keybindings
 * @property {string} oldKeybindings - The old keybindings
 */
/**
 * @typedef SettingsCommandsResetKeybindings
 * @property {string} commandName - The name of the command that its keybinding is being reset
 */
/**
 * @typedef SettingsCommandsUnassignKeybindings
 * @property {string} commandName - The name of the command that its keybinding is being unassigned
 */
/**
 * @typedef SettingsCustomAttributeActivated
 * @property {string} attributeId - The id of the activated custom attribute
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {string} type - The type of the activated custom attribute
 */
/**
 * @typedef SettingsCustomAttributeAddNewAttributeClicked
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 */
/**
 * @typedef SettingsCustomAttributeArchived
 * @property {string} attributeId - The id of the archived custom attribute
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {string} type - The type of the archived custom attribute
 */
/**
 * @typedef SettingsCustomAttributeCreated
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {boolean} isDescriptionEmpty - Whether the custom attribute was created without a description
 * @property {boolean} isIdentifierInferred - Whether the user typed in custom identifier instead of leaving one inferred from the label
 * @property {string} type - The type of the custom attribute
 */
/**
 * @typedef SettingsCustomAttributeDeactivated
 * @property {string} attributeId - The id of the deactivated custom attribute
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {string} type - The type of the deactivated custom attribute
 */
/**
 * @typedef SettingsCustomAttributeReordered
 * @property {string} attributeId - The id of the reordered custom attribute
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {boolean} isFullRecompute - Whether the reorder caused a full order recompute of all attributes in the list
 */
/**
 * @typedef SettingsCustomAttributeUnarchived
 * @property {string} attributeId - The id of the unarchived custom attribute
 * @property {string} entityId - The id of the entity the custom attribute belongs to
 * @property {string} type - The type of the unarchived custom attribute
 */
/**
 * @typedef SettingsCustomAttributeUpdated
 * @property {string} attributeId - The id of the updated custom attribute
 * @property {string} entityId - The id of the entity a custom attribute belongs to
 * @property {boolean} isDescriptionRemoved - Whether the description was removed
 * @property {boolean} isDescriptionUpdated - Whether the description was updated but not removed
 * @property {boolean} isLabelUpdated - Whether the label of a custom attribute is updated
 * @property {string} type - The type of a custom attribute
 */
/**
 * @typedef SettingsIntegrationsApiTokensAdd
 * @property {Record<string, any>} [] -
 */
/**
 * @typedef SettingsIntegrationsApiTokensCopy
 * @property {string} tokenId - The ID of the token that the user clicked to copy
 */
/**
 * @typedef SettingsIntegrationsApiTokensRemove
 * @property {string} tokenId - The ID of the token that the user clicked Remove on
 */
/**
 * @typedef SettingsIntegrationsApiTokensRemoveCancel
 * @property {string} tokenId - The ID of the token where the user canceled the remove token dialog
 */
/**
 * @typedef SettingsIntegrationsApiTokensRemoveConfirm
 * @property {string} tokenId - The ID of the token that the user confirmed to remove
 */
/**
 * @typedef SettingsIntegrationsApiTokensView
 * @property {string} tokenId - The ID of the token that the user clicked to view
 */
/**
 * @typedef SettingsIntegrationsApiTokensViewCancel
 * @property {string} tokenId - The ID of the token that the user viewed and now cancels
 */
/**
 * @typedef SettingsIntegrationsApiTokensViewCopy
 * @property {string} tokenId - The ID of the token that the user clicked to copy
 */
/**
 * @typedef SettingsIntegrationsCardEditCancel
 * @property {string} cardId - The ID of the card that the user is canceling
 * @property {string} cardType - The type of the card that the user is canceling
 */
/**
 * @typedef SettingsIntegrationsCardEditSave
 * @property {string} cardId - The ID of the card that the user is saving changes to
 * @property {string} cardType - The type if the card that the user is saving changes to
 */
/**
 * @typedef SettingsIntegrationsCardEditTest
 * @property {string} cardId - The ID of the card that the user is testing
 * @property {string} cardType - The type if the card that the user is testing
 */
/**
 * @typedef SettingsIntegrationsCardListingAddCard
 * @property {string} cardType - The type of the card that the user wants to add
 */
/**
 * @typedef SettingsIntegrationsCardListingEditCard
 * @property {string} cardId - The ID of the card that the user wants to edit
 * @property {string} cardType - The type of the card that the user wants to edit
 */
/**
 * @typedef SettingsIntegrationsCardListingRemoveCard
 * @property {string} cardId - The ID of the card that the user clicked to open the remove dialog
 * @property {string} cardType - The type of the card that the user clicked to open the remove dialog
 */
/**
 * @typedef SettingsIntegrationsCardListingRemoveCardCancel
 * @property {string} cardId - The ID of the card that the user wanted to remove but canceled in the dialog
 * @property {string} cardType - The type of the card that the user wanted to remove but canceled
 */
/**
 * @typedef SettingsIntegrationsCardListingRemoveCardConfirm
 * @property {string} cardId - The ID of the card that the user confirmed to remove
 * @property {string} cardType - The type of the card that the user confirmed to remove
 */
/**
 * @typedef SettingsIntegrationsCardListingTestCard
 * @property {string} cardId - The ID of the card that the user wants to test
 * @property {string} cardType - The type of the card that the user wants to test
 */
/**
 * @typedef SettingsIntegrationsCardReadDocumentation
 * @property {string} cardRoute - The route where the documentation link was clicked
 * @property {string} cardType - The card type that the user is currently on when clicking on Read documentation
 */
/**
 * @typedef SettingsIntegrationsCardTest
 * @property {string} cardId - The ID of the card that the user is testing
 * @property {string} cardType - The type of the card that the user is testing
 */
/**
 * @typedef SettingsIntegrationsCardTestAddParameter
 * @property {string} cardId - The ID of the card where the user adds a parameter
 * @property {string} cardType - The type of the card where the user adds a parameter
 */
/**
 * @typedef SettingsIntegrationsCardTestCancel
 * @property {string} cardId - The ID of the card where the user clicks on Cancel
 * @property {string} cardType - The type of the card where the user clicks on Cancel
 */
/**
 * @typedef SettingsIntegrationsCardTestRemoveParameter
 * @property {string} cardId - The ID of the card where the user removes a parameter
 * @property {string} cardType - The type of the card where the user removes a parameter
 */
/**
 * @typedef SettingsIntegrationsCustomCardCreated
 * @property {string} [authorizationHeader] - If there was an authorization header added.
 * @property {boolean} [body] - If there was a body added.
 * @property {string} [contentType] - The selected content-type.
 * @property {number} [customHeaders] - The amount of custom headers added.
 * @property {string} [httpMethod] - The selected HTTP method.
 * @property {string} [oAuthStrategy] - The selected OAuth strategy.
 */
/**
 * @typedef SettingsIntegrationsCustomCardEdited
 * @property {string} [authorizationHeader] - If there was an authorization header added.
 * @property {boolean} [body] - If there was a body added.
 * @property {string} [contentType] - The selected content-type.
 * @property {number} [customHeaders] - The amount of custom headers added.
 * @property {string} [httpMethod] - The selected HTTP method.
 * @property {string} [oAuthStrategy] - The selected OAuth strategy.
 */
/**
 * @typedef SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed
 * @property {string} [oAuthProviderId] - The id of the OAuth provider.
 * @property {string} [oAuthStrategy] - The strategy of the OAuth provider.
 */
/**
 * @typedef SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded
 * @property {string} [oAuthProviderId] - The id of the OAuth provider.
 * @property {string} [oAuthStrategy] - The strategy of the OAuth provider.
 */
/**
 * @typedef SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut
 * @property {string} [oAuthProviderId] - The id of the OAuth provider.
 * @property {string} [oAuthStrategy] - The strategy of the OAuth provider.
 */
/**
 * @typedef SettingsIntegrationsCustomCardOauthProviderCreated
 * @property {string} [oAuthProviderId] - The id of the OAuth provider.
 * @property {string} [oAuthStrategy] - The strategy of the OAuth provider.
 */
/**
 * @typedef SettingsIntegrationsCustomCardOauthProviderUpdated
 * @property {string} [oAuthProviderId] - The id of the OAuth provider.
 * @property {string} [oAuthStrategy] - The strategy of the OAuth provider.
 */
/**
 * @typedef SettingsIntegrationsItemClicked
 * @property {string} integrationsId - The ID of the integration that was clicked
 */
/**
 * @typedef SettingsIntegrationsPodioAddValidate
 * @property {string} clientId - The client ID of the Podio integration
 */
/**
 * @typedef SettingsIntegrationsPodioRemove
 * @property {string} clientId - The client ID of the Podio integration
 */
/**
 * @typedef SettingsIntegrationsPodioRemoveCancel
 * @property {string} clientId - The client ID of the Podio integration
 */
/**
 * @typedef SettingsIntegrationsPodioRemoveConfirm
 * @property {string} clientId - The client ID of the Podio integration
 */
/**
 * @typedef SettingsIntegrationsWebformEndpointsAddSave
 * @property {string} webformId - The ID of the webform
 */
/**
 * @typedef SettingsIntegrationsWebformEndpointsRemove
 * @property {string} webformId - The ID of the webform endpoint
 */
/**
 * @typedef SettingsIntegrationsWebformEndpointsRemoveCancel
 * @property {string} webformId - The ID of the webform endpoint
 */
/**
 * @typedef SettingsIntegrationsWebformEndpointsRemoveConfirm
 * @property {string} webformId - The ID of the webform endpoint
 */
/**
 * @typedef SettingsIntegrationsWebhooksAddConfirmDialogCopy
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksEdit
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksEditBack
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksEditSave
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksEnabledOff
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksEnabledOn
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksRemove
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksRemoveCancel
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksRemoveConfirm
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksView
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksViewCopySecret
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksViewEdit
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsIntegrationsWebhooksViewEditBack
 * @property {string} webhookId - The ID of the webhook
 */
/**
 * @typedef SettingsMenuItemClicked
 * @property {string} id - The type of the menu item
 */
/**
 * @typedef SettingsProfileFormSubmitted
 * @property {Record<string, any>} payload - The payload sent to the backend
 */
/**
 * @typedef SettingsQueueAdded
 * @property {boolean} [isDefault] - Whether the queue is default.
 * @property {boolean} [isPersonalOfferPrioritized] - If personal offer is prioritized.
 * @property {boolean} [lastAgentActive] - Whether last agent is active.
 * @property {boolean} [lastAgentOffline] - Whether it should offer to next available agent after timeout.
 * @property {number} [lastAgentWaitingTimeChat] - Last agent waiting time for chat and Dixa messenger.
 * @property {number} [lastAgentWaitingTimeEmail] - Last agent waiting time for email, and contact form.
 * @property {number} [lastAgentWaitingTimePhone] - Last agent waiting time for phone, voicemail, and callbacks.
 * @property {number} [lastAgentWaitingTimeTexts] - Last agent waiting time for texts and social media.
 * @property {boolean} [offerAbandonedConversation] - Whether it should offer abandoned phone & chat conversations.
 * @property {string} [offerAlgorithm] - The offer algorithm.
 * @property {number | null} [offerTimeout] - The offer timeout.
 * @property {boolean} [preferredAgentActive] - Whether preferred agent is active.
 * @property {boolean} [preferredAgentOffline] - Whether it should offer to next available agent after timeout.
 * @property {number} [preferredAgentWaitingTimeChat] - Preferred agent waiting time for chat and Dixa messenger.
 * @property {number} [preferredAgentWaitingTimeEmail] - Preferred agent waiting time for email, and contact form.
 * @property {number} [preferredAgentWaitingTimePhone] - Preferred agent waiting time for phone, voicemail, and callbacks.
 * @property {number} [preferredAgentWaitingTimeTexts] - Preferred agent waiting time for texts and social media.
 * @property {number | null} [priorityLevel] - The priority level.
 * @property {number | null} [wrapUpTimeout] - The wrap-up time.
 */
/**
 * @typedef SettingsQueueAgentSorted
 * @property {string} type - The type of sorting.
 */
/**
 * @typedef SettingsQueueAlertsSaved
 * @property {boolean} [availableAgentsEnabled] - If the available agents enabled.
 * @property {number} [availableAgentsLimit] - The available agents limit.
 * @property {number} [currentLongestWait] - The current longest wait in a queue alert in seconds.
 * @property {boolean} [currentLongestWaitEnabled] - If the current longest wait in a queue alert enabled.
 * @property {number} [maximumWaiting] - The maximum waiting conversations in the queue.
 * @property {boolean} [maximumWaitingEnabled] - If the maximum waiting in queue alert enabled.
 * @property {boolean} [serviceLevelAlertEnabled] - If the service level alert enabled.
 * @property {number} [serviceLevelPercentage] - The service level percentage.
 * @property {number} [serviceLevelTimeLimit] - The service level time limit in seconds.
 */
/**
 * @typedef SettingsQueueSaved
 * @property {boolean} [isDefault] - Whether the queue is default.
 * @property {boolean} [isPersonalOfferPrioritized] - If personal offer is prioritized.
 * @property {boolean} [lastAgentActive] - Whether last agent is active.
 * @property {boolean} [lastAgentOffline] - Whether it should offer to next available agent after timeout.
 * @property {number} [lastAgentWaitingTimeChat] - Last agent waiting time for chat and Dixa messenger.
 * @property {number} [lastAgentWaitingTimeEmail] - Last agent waiting time for email, and contact form.
 * @property {number} [lastAgentWaitingTimePhone] - Last agent waiting time for phone, voicemail, and callbacks.
 * @property {number} [lastAgentWaitingTimeTexts] - Last agent waiting time for texts and social media.
 * @property {boolean} [offerAbandonedConversation] - Whether it should offer abandoned phone & chat conversations.
 * @property {string} [offerAlgorithm] - The offer algorithm.
 * @property {number | null} [offerTimeout] - The offer timeout.
 * @property {string} [personalOffer] - DEPRECIATED Whether the option was unchanged or turned on/off
 * @property {string} [personalOfferOfflineTimeout] - DEPRECIATED Whether the option was unchanged or turned on/off
 * @property {string} [preferredAgent] - DEPRECIATED Whether the option was unchanged or turned on/off
 * @property {boolean} [preferredAgentActive] - Whether preferred agent is active.
 * @property {boolean} [preferredAgentOffline] - Whether it should offer to next available agent after timeout.
 * @property {string} [preferredAgentOfflineTimeout] - DEPRECIATED Whether the option was unchanged or turned on/off
 * @property {number} [preferredAgentWaitingTimeChat] - Preferred agent waiting time for chat and Dixa messenger.
 * @property {number} [preferredAgentWaitingTimeEmail] - Preferred agent waiting time for email, and contact form.
 * @property {number} [preferredAgentWaitingTimePhone] - Preferred agent waiting time for phone, voicemail, and callbacks.
 * @property {number} [preferredAgentWaitingTimeTexts] - Preferred agent waiting time for texts and social media.
 * @property {string} [prioritizePersonalOffer] - DEPRECIATED Whether the option was unchanged or turned on/off
 * @property {number | null} [priorityLevel] - The priority level.
 * @property {number | null} [wrapUpTimeout] - The wrap-up time.
 */
/**
 * @typedef SettingsQueuesArchiveQueueClicked
 * @property {number} [openConversationsCount] - The number of open conversations in the queue being archived
 */
/**
 * @typedef SettingsTagsRemoveTagButtonClicked
 * @property {string} tagName - the name of the tag to be removed
 */
/**
 * @typedef SettingsTagsRemoveTagConfirmed
 * @property {string} tagName - the name of the tag to be removed
 */
/**
 * @typedef SettingsTagsTagActivated
 * @property {string} tagName - The name of enabled tag
 */
/**
 * @typedef SettingsTagsTagDeactivated
 * @property {string} tagName - The name of disabled tag
 */
/**
 * @typedef SettingsTeamModalFormSubmitted
 * @property {string} teamName - The name of the team
 */
/**
 * @typedef SettingsTemplatesAddTemplateButtonClicked
 * @property {string} templateType - The type of the template to be added
 */
/**
 * @typedef SettingsTemplatesEditTemplateButtonClicked
 * @property {string} templateName - The name of the template
 * @property {string} templateType - The type of the template to be added
 */
/**
 * @typedef SettingsTemplatesModalFormSubmitted
 * @property {string} mode - Whether the user is adding a new template or editing an existing one
 * @property {string} templateName - The name of the template
 * @property {string} templateType - The type of the template to be added
 */
/**
 * @typedef SettingsTemplatesOldModalFormSubmitted
 * @property {string} mode - Whether the user is adding a new template or editing an existing one
 * @property {string} templateName - The name of the template
 * @property {string} templateType - The type of the template to be added
 */
/**
 * @typedef SettingsTemplatesRemoveTemplateButtonClicked
 * @property {string} templateName - The name of the template
 * @property {string} templateType - The type of the template to be added
 */
/**
 * @typedef SettingsTemplatesRemoveTemplateConfirmed
 * @property {string} templateName - The name of the template
 * @property {string} templateType - The type of the template to be added
 */
/**
 * @typedef SettingsTemplatesTabClicked
 * @property {string} tab - The selected tab
 */
/**
 * @typedef SharedWorkerTabOrWindowClosed
 * @property {number} numberOfInstances - The amount of open windows or tabs in total.
 */
/**
 * @typedef SharedWorkerTabOrWindowOpened
 * @property {number} numberOfInstances - The amount of open windows or tabs in total.
 */
/**
 * @typedef SidebarNavClicked
 * @property {string} item - The navigation item that was clicked
 */
/**
 * @typedef SimultaneousRingUpdated
 * @property {boolean} enabled -
 * @property {string} location - Where the toggle is placed
 */
/**
 * @typedef SmartConversationReplyButtonClicked
 * @property {string} articleId - The article being viewed when the button was clicked
 * @property {number} conversationId - The conversation being viewed when the button was clicked
 * @property {string} knowledgeSource - Where the event originated from - Elevio or Dixa Knowledge
 */
/**
 * @typedef TagSelectCreateNewTagClicked
 * @property {string} [component] - The select component on which the item is clicked
 * @property {string} tagName - The name of the tag to be created
 */
/**
 * @typedef TagsCreateModalColorChanged
 * @property {string} color - The selected color
 * @property {string} path - On which path the modal is open
 */
/**
 * @typedef TagsCreateModalFormSubmitted
 * @property {string} [path] - On which path the modal is open
 * @property {string} tagName - The name of the tag to be created
 */
/**
 * @typedef TagsCreateModalOpened
 * @property {string} path - On which path the modal is open
 * @property {string} tagName - The name of the tag to be created
 */
/**
 * @typedef TeamAgentActionsMenuItemClicked
 * @property {string} type - The type of the menu item
 */
/**
 * @typedef TeamConversationActionsMenuItemClicked
 * @property {string} type - The type of the menu item
 */
/**
 * @typedef TeamFavoriteToggled
 * @property {boolean} value - The value of the toggle
 */
/**
 * @typedef TeamFilterMenuItemClicked
 * @property {string} type - The type of the menu item
 */
/**
 * @typedef UserModalFormSubmitted
 * @property {Record<string, any>} [company] - The company that the user belongs to
 * @property {string} mode - Whether the modal is for adding or editing a user
 * @property {number} [numberOfEmails] - Total number of emails (primary with additional)
 * @property {number} [numberOfPhoneNumbers] - Total number of phone numbers (primary with additional)
 * @property {string} role - The role of the user
 */
/**
 * @typedef WebsocketActiveConnectionChanged
 * @property {string} newConnectionId - The new connection ID
 * @property {string} oldConnectionId - The old connection ID
 */
/**
 * @typedef WebsocketCloseEventReceived
 * @property {number} code - The code sent by the server
 * @property {string} reason - The reason the connection closed
 * @property {boolean} wasClean - Whether or not the connection was cleanly closed
 */
/**
 * @typedef WebsocketConnectionClosed
 * @property {string} [source] - Where the websocket connection was closed from
 */
/**
 * @typedef WebsocketConnectionCreated
 * @property {string} [source] - Where the websocket connection was created from
 */
/**
 * @typedef WebsocketReconnectAttemptStarted
 * @property {number} count - The count of reconnect attempts made so far
 */
/**
 * When the user submits the form on Add agents modal
 *
 * @param {AddAgentsModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addAgentsModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Add Agents Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on Add Card Modal from Billing settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function addCreditCardModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Add Credit Card Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks an items from the Agent Copilot dropdown in the reply area.
 *
 * @param {AgentCopilotDropdownItemClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agentCopilotDropdownItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Agent Copilot Dropdown Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Replace Text action in a copilot action.
 *
 * @param {AgentCopilotTextInsertBelowClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agentCopilotTextInsertBelowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Agent Copilot Text Insert Below Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Insert Below action in a copilot action.
 *
 * @param {AgentCopilotTextReplaceClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agentCopilotTextReplaceClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Agent Copilot Text Replace Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects a language to translate a message to.
 *
 * @param {AgentCopilotTranslateMessageLanguageSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function agentCopilotTranslateMessageLanguageSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Agent Copilot Translate Message Language Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the banner in old or new Analytics
 *
 * @param {AnalyticsBannerClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsBannerClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Banner Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects a business hours schedule filter on a dashboard
 *
 * @param {AnalyticsBusinessHoursScheduleRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsBusinessHoursScheduleRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Business Hours Schedule Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user removes a business hours schedule filter on a dashboard
 *
 * @param {AnalyticsBusinessHoursScheduleUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsBusinessHoursScheduleUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Business Hours Schedule Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the granularity of a chart
 *
 * @param {AnalyticsChartGranularityChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsChartGranularityChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Chart Granularity Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the visualization of a chart
 *
 * @param {AnalyticsChartVisualizationChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsChartVisualizationChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Chart Visualization Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the compare button in a dashboard
 *
 * @param {AnalyticsCompareClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsCompareClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Compare Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the context in a comparison
 *
 * @param {AnalyticsCompareContextUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsCompareContextUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Compare Context Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the context in a comparison
 *
 * @param {AnalyticsComparePeriodUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsComparePeriodUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Compare Period Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the context on a dashboard
 *
 * @param {AnalyticsContextUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsContextUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Context Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on a conversation link in supported instruments
 *
 * @param {AnalyticsConversationLinkClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsConversationLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Conversation Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the button to preview a conversation in supported instruments
 *
 * @param {AnalyticsConversationPreviewClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsConversationPreviewClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Conversation Preview Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user views a dashboard
 *
 * @param {AnalyticsDashboardViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsDashboardViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Dashboard Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the export button in a dashboard
 *
 * @param {AnalyticsExportClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsExportClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Export Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the export download button in a dashboard
 *
 * @param {AnalyticsExportDownloadClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsExportDownloadClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Export Download Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks Export my data button on Analytics Export Dashboard
 *
 * @param {AnalyticsExportMyDataButtonPressed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsExportMyDataButtonPressed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Export My Data Button Pressed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clears a filter in a dashboard
 *
 * @param {AnalyticsFilterCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsFilterCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Filter Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens a filter in a dashboard
 *
 * @param {AnalyticsFilterOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsFilterOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Filter Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the updates the operator of filter in a dashboard
 *
 * @param {AnalyticsFilterOperatorUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsFilterOperatorUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Filter Operator Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a filter value in a dashboard
 *
 * @param {AnalyticsFilterValueAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsFilterValueAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Filter Value Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user applies some filters in a dashboard
 *
 * @param {AnalyticsFiltersApplied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsFiltersApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Filters Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clears all filters in a dashboard
 *
 * @param {AnalyticsFiltersCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsFiltersCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Filters Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks a helper in a dashboard
 *
 * @param {AnalyticsHelperClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsHelperClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Helper Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks an in-depth button in a dashboard
 *
 * @param {AnalyticsInDepthClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsInDepthClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics In Depth Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the AI insights button in a dashboard
 *
 * @param {AnalyticsInsightsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsInsightsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Insights Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks copy to clipboard on an AI insight in a dashboard
 *
 * @param {AnalyticsInsightsCopyClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsInsightsCopyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Insights Copy Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks a feedback button on an AI insight in a dashboard
 *
 * @param {AnalyticsInsightsFeedbackClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsInsightsFeedbackClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Insights Feedback Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on an AI insight prompt in a dashboard
 *
 * @param {AnalyticsInsightsPromptClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsInsightsPromptClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Insights Prompt Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks regenerate on an AI insight prompt in a dashboard
 *
 * @param {AnalyticsInsightsRegenerateClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsInsightsRegenerateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Insights Regenerate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Latest Updates button
 *
 * @param {AnalyticsLatestUpdatesClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsLatestUpdatesClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Latest Updates Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the period on a dashboard
 *
 * @param {AnalyticsPeriodUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsPeriodUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Period Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user creates a quick view
 *
 * @param {AnalyticsQuickViewCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deletes a quick view
 *
 * @param {AnalyticsQuickViewDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewDeleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Deleted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user duplicates a quick view
 *
 * @param {AnalyticsQuickViewDuplicated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewDuplicated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Duplicated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user favorites or unfavorites a quick view
 *
 * @param {AnalyticsQuickViewFavoriteToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewFavoriteToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Favorite Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user shares or unshares a quick view
 *
 * @param {AnalyticsQuickViewSharingToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewSharingToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Sharing Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates a quick view
 *
 * @param {AnalyticsQuickViewUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user views a quick view
 *
 * @param {AnalyticsQuickViewViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsQuickViewViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Quick View Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks a refresh button in a dashboard
 *
 * @param {AnalyticsRefreshClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsRefreshClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Refresh Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user dismisses the sidenav announcement in Analytics
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsSidenavAnnouncementDismissed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Sidenav Announcement Dismissed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the load all results button on a table
 *
 * @param {AnalyticsTableLoadAllClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsTableLoadAllClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Table Load All Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the sorting on a table
 *
 * @param {AnalyticsTableSortUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsTableSortUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Table Sort Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the timezone on a dashboard
 *
 * @param {AnalyticsTimezoneUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsTimezoneUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics Timezone Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the view conversations button in a panel
 *
 * @param {AnalyticsViewConversationsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function analyticsViewConversationsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Analytics View Conversations Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user types something different than the autocomplete suggestion, invalidating it.
 *
 * @param {AutocompleteSuggestionMismatchDetected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function autocompleteSuggestionMismatchDetected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Autocomplete Suggestion Mismatch Detected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user removes the autocomplete suggestion by hitting the "Escape" key
 *
 * @param {AutocompleteSuggestionRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function autocompleteSuggestionRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Autocomplete Suggestion Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects the autocomplete suggestion by hitting the "Tab" key
 *
 * @param {AutocompleteSuggestionSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function autocompleteSuggestionSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Autocomplete Suggestion Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles the conversation editor autocomplete feature on or off
 *
 * @param {AutocompleteToggleClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function autocompleteToggleClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Autocomplete Toggle Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the See Audit Log button in automations settings page

 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsFlowOptionsMenuOptionAuditLogClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Flow Options Menu Option Audit Log Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the Automation form
 *
 * @param {AutomationsFormCancelled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the create/update Automation form
 *
 * @param {AutomationsFormOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsFormOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Form Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user proceeds on the Automation form
 *
 * @param {AutomationsFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Options Menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Delete in the Automation options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsOptionsMenuOptionDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Options Menu Option Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Duplicate in the Automation options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsOptionsMenuOptionDuplicateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Options Menu Option Duplicate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Edit Flow in the Automation options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsOptionsMenuOptionFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Options Menu Option Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Settings in the Automation options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsOptionsMenuOptionSettingsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Options Menu Option Settings Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the next page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsPaginationNextClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Pagination Next Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the previous page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsPaginationPreviousClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Pagination Previous Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user performs a search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsSearchApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Search Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the search field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsSearchClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Search Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the search field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsSearchOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Search Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles an automation off
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsToggledOff(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Toggled Off', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles an automation on
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function automationsToggledOn(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Automations Toggled On', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Ban User button
 *
 * @param {BansBanUserClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bansBanUserClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bans Ban User Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Unban IP button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bansUnbanIpClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bans Unban Ip Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Unban User button
 *
 * @param {BansUnbanUserClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bansUnbanUserClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bans Unban User Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Update button in the Bulk Actions
 *
 * @param {BulkActionsUpdateClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function bulkActionsUpdateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Bulk Actions Update Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user added an Audio message.
 *
 * @param {BusinessHoursAddScheduleAudioMessageAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursAddScheduleAudioMessageAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Add Schedule Audio Message Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Add new schedule button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursAddScheduleButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Add Schedule Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Add new schedule form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursAddScheduleFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Add Schedule Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Add new schedule form.
 *
 * @param {BusinessHoursAddScheduleFormSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursAddScheduleFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Add Schedule Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Go to Business Hours button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursConflictNotificationButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Conflict Notification Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the close button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursConflictNotificationClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Conflict Notification Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Delete schedule form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursDeleteScheduleFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Delete Schedule Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Delete schedule form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursDeleteScheduleFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Delete Schedule Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Duplicate schedule form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursDuplicateScheduleFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Duplicate Schedule Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Duplicate schedule form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursDuplicateScheduleFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Duplicate Schedule Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Support article link.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursFeatureAnnouncementModalLearnMoreButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Feature Announcement Modal Learn More Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the one of the question toggle.
 *
 * @param {BusinessHoursFirstScheduleModalQuestionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursFirstScheduleModalQuestionClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours First Schedule Modal Question Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Support article link.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursFirstScheduleSupportArticleClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours First Schedule Support Article Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Go to flow on the Schedules listing page.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursGoToFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Go To Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user added an Audio message.
 *
 * @param {BusinessHoursMigrationWizardAudioMessageAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardAudioMessageAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Audio Message Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the clicked the Create new schedule button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardCreateNewScheduleButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Create New Schedule Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Edit hours button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardEditHoursButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Edit Hours Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Migration wizard modal.
 *
 * @param {BusinessHoursMigrationWizardFormCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Migration wizard modal.
 *
 * @param {BusinessHoursMigrationWizardFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Migration wizard Opening hours form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardOpeningHoursFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Opening Hours Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Migration wizard Opening hours form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardOpeningHoursFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Opening Hours Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Start update button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursMigrationWizardStartUpdateButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Migration Wizard Start Update Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the Options Menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Delete in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursOptionsMenuOptionDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Options Menu Option Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Duplicate in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursOptionsMenuOptionDuplicateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Options Menu Option Duplicate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Edit schedule in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursOptionsMenuOptionEditClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Options Menu Option Edit Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Rename in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursOptionsMenuOptionRenameClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Options Menu Option Rename Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Rename schedule form.
 *
 * @param {BusinessHoursRenameScheduleFormCancelled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursRenameScheduleFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Rename Schedule Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Rename schedule form.
 *
 * @param {BusinessHoursRenameScheduleFormSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursRenameScheduleFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Rename Schedule Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When user clicked on the Add exception button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAddExceptionButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Add Exception Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Add exception form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAddExceptionFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Add Exception Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted Add exception form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAddExceptionFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Add Exception Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Audio message modal.
 *
 * @param {BusinessHoursScheduleAudioMessageFormCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAudioMessageFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Audio Message Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Audio message modal.
 *
 * @param {BusinessHoursScheduleAudioMessageFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAudioMessageFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Audio Message Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the Audio message options menu.
 *
 * @param {BusinessHoursScheduleAudioMessageOptionsMenuOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAudioMessageOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Audio Message Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Clear from the options menu.
 *
 * @param {BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Audio Message Options Menu Option Clear Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Record audio message from the options menu.
 *
 * @param {BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Audio Message Options Menu Option Record Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Upload audio message from the options menu.
 *
 * @param {BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Audio Message Options Menu Option Upload Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Audio message modal.
 *
 * @param {BusinessHoursScheduleAutoReplyFormCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAutoReplyFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Auto Reply Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Audio message modal.
 *
 * @param {BusinessHoursScheduleAutoReplyFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAutoReplyFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Auto Reply Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the Auto replies options menu.
 *
 * @param {BusinessHoursScheduleAutoReplyOptionsMenuOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAutoReplyOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Auto Reply Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Add auto-reply template option.
 *
 * @param {BusinessHoursScheduleAutoReplyOptionsMenuOptionAddClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAutoReplyOptionsMenuOptionAddClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Auto Reply Options Menu Option Add Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Clear from the options menu.
 *
 * @param {BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Auto Reply Options Menu Option Clear Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Change button on the overridden item.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleConflictChangeButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Conflict Change Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Review conflicts button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleConflictReviewButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Conflict Review Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Delete exception modal.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleDeleteExceptionFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Delete Exception Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Delete exception modal.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleDeleteExceptionFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Delete Exception Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Edit button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleEditButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Edit Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Edit schedule form.
 *
 * @param {BusinessHoursScheduleEditFormSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleEditFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Edit Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the exception options menu.
 *
 * @param {BusinessHoursScheduleExceptionOptionsMenuOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleExceptionOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Exception Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Delete in the options menu.
 *
 * @param {BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Exception Options Menu Option Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When user clicked on the Exceptions business hours tab.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleExceptionsTabClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Exceptions Tab Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Import holiday form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleImportHolidayFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Import Holiday Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Import holiday form.
 *
 * @param {BusinessHoursScheduleImportHolidayFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleImportHolidayFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Import Holiday Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Import holidays in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleOptionsMenuImportHolidaysClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Options Menu Import Holidays Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Recover deleted holidays in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleOptionsMenuRecoverHolidaysClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Options Menu Recover Holidays Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Rename in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleOptionsMenuRenameClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Options Menu Rename Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selected Edit timezone in the options menu.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleOptionsMenuTimezoneClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Options Menu Timezone Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Preview button.
 *
 * @param {BusinessHoursSchedulePreviewButtonClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursSchedulePreviewButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Preview Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Recover holidays modal.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleRecoverHolidaysFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Recover Holidays Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Recover holidays modal.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleRecoverHolidaysFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Recover Holidays Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancelled the Review conflicts form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleReviewFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Review Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the Review conflicts form.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleReviewFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Review Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the Save schedule button.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleSaveScheduleButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Save Schedule Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When user clicked one of the view tabs.
 *
 * @param {BusinessHoursScheduleTabClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleTabClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule Tab Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked one of the view buttons.
 *
 * @param {BusinessHoursScheduleViewClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursScheduleViewClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedule View Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the view switch button.
 *
 * @param {BusinessHoursSchedulesSwitchClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function businessHoursSchedulesSwitchClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Business Hours Schedules Switch Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the See Audit Log button in chat settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatFlowOptionsMenuOptionAuditLogClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Flow Options Menu Option Audit Log Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the Widget form
 *
 * @param {ChatFormCanceled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatFormCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Form Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the create/rename Widget form
 *
 * @param {ChatFormOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatFormOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Form Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user proceed on the Widget form
 *
 * @param {ChatFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Whether the user opens the Options Menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Delete in the Widget options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatOptionsMenuOptionDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Options Menu Option Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Duplicate in the Widget options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatOptionsMenuOptionDuplicateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Options Menu Option Duplicate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Edit flow in the Widget options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatOptionsMenuOptionFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Options Menu Option Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Rename in the Widget options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatOptionsMenuOptionRenameClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Options Menu Option Rename Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Setup in the Widget options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatOptionsMenuOptionSetupClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Options Menu Option Setup Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the next page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatPaginationNextClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Pagination Next Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the previous page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatPaginationPreviousClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Pagination Previous Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user performs a search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatSearchApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Search Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the search field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatSearchClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Search Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the search field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function chatSearchOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Chat Search Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks Clears All Filters button
 *
 * @param {ClearAllFiltersClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function clearAllFiltersClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Clear All Filters Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks a button to close a conversation
 *
 * @param {CloseConversationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function closeConversationClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Close Conversation Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user executes a command.
 *
 * @param {CommandExecuted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function commandExecuted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Command Executed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on company modal
 *
 * @param {CompanyModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function companyModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Company Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Add New Company button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsAddNewCompanyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Add New Company Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Add New Contact button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsAddNewContactClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Add New Contact Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Ban User button on the Contacts page
 *
 * @param {ContactsBanUserClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsBanUserClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Ban User Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Actions Menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardActionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card Actions Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Compose New Email button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardComposeNewEmailClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card Compose New Email Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the to edit a company
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardEditCompanyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card Edit Company Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the to edit a contact
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardEditContactClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card Edit Contact Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks to make a call in the contact card
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardMakeCallClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card Make Call Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the button to see all assigned conversations
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardSeeAllAssignedConversationsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card See All Assigned Conversations Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the button to see all conversations
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardSeeAllConversationsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card See All Conversations Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks to view the company in the contacts card
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardViewCompanyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card View Company Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks to view the conversation
 *
 * @param {ContactsCardViewConversationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardViewConversationClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card View Conversation Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks to view the user in the contacts card
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsCardViewUserClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Card View User Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the search input is blurred
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsSearchBlurred(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Search Blurred', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the search input
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsSearchClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Search Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the search input is focused
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsSearchFocused(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Search Focused', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the search input
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsSearchOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Search Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Unban User button on the Contacts page
 *
 * @param {ContactsUnbanUserClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsUnbanUserClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts Unban User Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Companies in the dropdown in the contacts page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsViewCompanies(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts View Companies', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Contacts from the dropdown in the contacts page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function contactsViewEndUsers(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Contacts View End Users', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationActionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Actions Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects an option from the Actions menu
 *
 * @param {ConversationActionsMenuOptionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationActionsMenuOptionClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Actions Menu Option Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closed the Activity Log
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationActivityLogClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Activity Log Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the agent has expanded the Flooter.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationActivityLogFlooterExpanded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Activity Log Flooter Expanded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Activity Log
 *
 * @param {ConversationActivityLogOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationActivityLogOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Activity Log Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user downloads an image attachment from the preview modal
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationAttachedImageIsDownloaded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Attached Image Is Downloaded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on an image attachment that opens the preview
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationAttachedImageIsViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Attached Image Is Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user claims the conversation
 *
 * @param {ConversationClaimed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationClaimed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Claimed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the conversatio
 *
 * @param {ConversationClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the CSAT
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationCsatCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Csat Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Cancel CSAT menu option
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationCsatMenuCancelOptionClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Csat Menu Cancel Option Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the language from the CSAT menu
 *
 * @param {ConversationCsatMenuLanguageSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationCsatMenuLanguageSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Csat Menu Language Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the CSAT menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationCsatMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Csat Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a conversation was followed up.
 *
 * @param {ConversationFollowUp} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationFollowUp(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Follow Up', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Follow Up menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationFollowUpMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Follow Up Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects an option from the Follow Up menu
 *
 * @param {ConversationFollowUpMenuOptionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationFollowUpMenuOptionClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Follow Up Menu Option Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens conversation details dropdown in conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderConversationDetailsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Conversation Details Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the more menu in the conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderMoreMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header More Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a tag from tag dropdown in conversation header
 *
 * @param {ConversationHeaderTagAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTagAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Tag Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles Include deactivated tags in tag select dropdown in conversation header
 *
 * @param {ConversationHeaderTagIncludeDeactivatedToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTagIncludeDeactivatedToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Tag Include Deactivated Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens tags select dropdown from conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTagMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Tag Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user removes a tag from conversation header
 *
 * @param {ConversationHeaderTagRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTagRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Tag Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects an agent from transfer to agent dropdown in conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTransferToAgentItemSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Transfer To Agent Item Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the transfer to agent dropdown in conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTransferToAgentMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Transfer To Agent Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on transfer to number button in the conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTransferToNumberButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Transfer To Number Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects a queue from transfer to queue dropdown in conversation header
 *
 * @param {ConversationHeaderTransferToQueueItemSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTransferToQueueItemSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Transfer To Queue Item Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the transfer to queue dropdown in conversation header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationHeaderTransferToQueueMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Header Transfer To Queue Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the internal note tab
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationInternalNoteEditorOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Internal Note Editor Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a conversation was offered to an agent
 *
 * @param {ConversationOffered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationOffered(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Offered', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user replies a conversation
 *
 * @param {ConversationReplied} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationReplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Replied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user chooses to create a draft when they resolve a conversation
 *
 * @param {ConversationResolvedAsAKnowledgeArticleDraft} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationResolvedAsAKnowledgeArticleDraft(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Resolved As A Knowledge Article Draft', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user chooses to register a knowledge gap when they resolve a conversation
 *
 * @param {ConversationResolvedAsAKnowledgeGap} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationResolvedAsAKnowledgeGap(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Resolved As A Knowledge Gap', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user resolves a conversation using the knowledge flow
 *
 * @param {ConversationResolvedByKnowledge} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationResolvedByKnowledge(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Resolved By Knowledge', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user chooses to resolve a conversation without marking any knowledge article as having helped
 *
 * @param {ConversationResolvedWithNoKnowledgeArticle} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationResolvedWithNoKnowledgeArticle(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Resolved With No Knowledge Article', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the accordion item conversation history
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarConversationHistoryClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Conversation History Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user navigates to a conversation listed in the conversation history accordion item in the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarConversationHistoryNavigatedToConversation(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Conversation History Navigated To Conversation', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the accordion item conversation history
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarConversationHistoryOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Conversation History Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User collapsed the Conversation summary card in the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarConversationSummaryClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Conversation Summary Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User expanded the Conversation summary card in the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarConversationSummaryOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Conversation Summary Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens compose email from clicking the customers email in the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarCustomerInfoEmailClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Customer Info Email Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user starts phone call from clicking the customers phone number in the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarCustomerInfoPhoneNumberClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Customer Info Phone Number Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSidebarOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Sidebar Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks an item in the conversation timeline
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationTimelineItemOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Timeline Item Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks a conversation listed in a timeline item
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationTimelineNavigatedToConversation(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Timeline Navigated To Conversation', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Transfer menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationTransferMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Transfer Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects an option from the Transfer To menu
 *
 * @param {ConversationTransferMenuOptionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationTransferMenuOptionClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Transfer Menu Option Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a conversation was transferred.
 *
 * @param {ConversationTransferred} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationTransferred(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Transferred', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user views the conversation
 *
 * @param {ConversationViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversation Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When an agent doesn't find the summary of conversation useful and clicks on thumbs down button.
 *
 * @param {ConversationSummaryFeedbackNotUseful} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSummaryFeedbackNotUseful(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('ConversationSummaryFeedbackNotUseful', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When an agent finds the summary of conversation useful and clicks on thumbs up button.
 *
 * @param {ConversationSummaryFeedbackUseful} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSummaryFeedbackUseful(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('ConversationSummaryFeedbackUseful', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When an agent requests for a new conversation summary
 *
 * @param {ConversationSummaryRegenerateSummary} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationSummaryRegenerateSummary(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('ConversationSummaryRegenerateSummary', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Bulk Actions button
 *
 * @param {ConversationsBulkActionsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsBulkActionsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Bulk Actions Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the clear all checkbox
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsClearAllClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Clear All Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Close Conversation button in the actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsCloseConversationClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Close Conversation Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the "Filter Conversations" button for the agent
 *
 * @param {ConversationsFilterAgentClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsFilterAgentClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Filter Agent Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clears a conversations filter
 *
 * @param {ConversationsFilterCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsFilterCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Filter Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the "Filter Conversations" button for the contact
 *
 * @param {ConversationsFilterContactClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsFilterContactClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Filter Contact Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles a conversations filter
 *
 * @param {ConversationsFilterToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsFilterToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Filter Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Go To Conversations button in the actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsGoToConversationClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Go To Conversation Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the conversation actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsItemActionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Item Actions Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the assignee avatar
 *
 * @param {ConversationsItemAssigneeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsItemAssigneeClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Item Assignee Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the conversation info menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsItemInfoOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Item Info Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the preview conversation button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsItemPreviewClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Item Preview Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Next Page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsNextPageClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Next Page Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Previous Page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsPreviousPageClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Previous Page Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the select all checkbox
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsSelectAllClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Select All Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the select checkbox for a single conversation
 *
 * @param {ConversationsSelectClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsSelectClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Select Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks a timestamp
 *
 * @param {ConversationsTimestampClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsTimestampClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Timestamp Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Transfer To Queue button in the actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsTransferToQueueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations Transfer To Queue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the View Agent button in the actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsViewAgentClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations View Agent Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the View Contact button in the actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsViewContactClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations View Contact Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the View Conversations button in the actions menu
 *
 * @param {ConversationsViewConversationsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function conversationsViewConversationsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Conversations View Conversations Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user copy the Dixa Widget script
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function copyScript(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Copy Script', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects a country from the Country Code Dropdown in Telephony Search User field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function countryCodeSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Country Code Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Whenever the user updates value of a custom attribute
 *
 * @param {CustomAttributeValueUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function customAttributeValueUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Custom Attribute Value Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the next page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dashboardNextPageClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Dashboard Next Page Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the previous page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dashboardPreviousPageClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Dashboard Previous Page Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the dashboard queue item
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dashboardQueueItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Dashboard Queue Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles the favorite queue
 *
 * @param {DashboardQueueItemFavoriteToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dashboardQueueItemFavoriteToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Dashboard Queue Item Favorite Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the queues type
 *
 * @param {DashboardQueuesTypeChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dashboardQueuesTypeChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Dashboard Queues Type Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the tv dashboard button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function dashboardTvDashboardClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Dashboard Tv Dashboard Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a quick response in the conversation input
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function editorQuickResponseAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Editor QuickResponse Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the See Audit Log button in email settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailFlowOptionsMenuOptionAuditLogClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Flow Options Menu Option Audit Log Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the Email form
 *
 * @param {EmailFormCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the create/update/duplicate/rename Email form
 *
 * @param {EmailFormOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailFormOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Form Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user proceeds on the Email form
 *
 * @param {EmailFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Options Menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Delete in the Email options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailOptionsMenuOptionDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Options Menu Option Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Duplicate in the Email options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailOptionsMenuOptionDuplicateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Options Menu Option Duplicate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Edit Email in the Email options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailOptionsMenuOptionEmailClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Options Menu Option Email Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Edit Flow in the Email options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailOptionsMenuOptionFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Options Menu Option Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Rename in the Email options menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailOptionsMenuOptionRenameClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Options Menu Option Rename Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the next page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailPaginationNextClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Pagination Next Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the previous page button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailPaginationPreviousClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Pagination Previous Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user performs a search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailSearchApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Search Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the search field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailSearchClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Search Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the search field
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function emailSearchOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Email Search Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user added an action and saved it.
 *
 * @param {FlowActionAddSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActionAddSaved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Action Add Saved', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a condition to a branch/condition-action
 *
 * @param {FlowActionConditionAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActionConditionAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Action Condition Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a condition to a branch/condition-action
 *
 * @param {FlowActionConditionRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActionConditionRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Action Condition Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deletes a node in a flow
 *
 * @param {FlowActionDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActionDeleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Action Deleted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the edit button on an action
 *
 * @param {FlowActionEditClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActionEditClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Action Edit Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user saves an action
 *
 * @param {FlowActionEditSaved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActionEditSaved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Action Edit Saved', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user saves a flow
 *
 * @param {FlowActivateClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowActivateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Activate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects a specific action to add
 *
 * @param {FlowAddActionActionSelected} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowAddActionActionSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Add Action Action Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the add action modal without making a selection
 *
 * @param {FlowAddActionCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowAddActionCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Add Action Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the add action modal
 *
 * @param {FlowAddActionOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowAddActionOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Add Action Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the go back to settings button in a Flow
 *
 * @param {FlowBackToSettingsClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowBackToSettingsClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Back To Settings Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks "Align" in the context menu
 *
 * @param {FlowContextAlignClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowContextAlignClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Context Align Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks "Cancel" in the confirm modal after clicking the "Delete" option in context menu
 *
 * @param {FlowContextDeleteCancelClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowContextDeleteCancelClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Context Delete Cancel Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks "Delete" in the context menu
 *
 * @param {FlowContextDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowContextDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Context Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks "Confirm" in the confirm modal after clicking the "Delete" option in context menu
 *
 * @param {FlowContextDeleteConfirmClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowContextDeleteConfirmClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Context Delete Confirm Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks "Arrange nodes" in the context menu
 *
 * @param {FlowContextNodeArrangeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowContextNodeArrangeClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Context Node Arrange Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changed the phone number in the phone flow.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowPhoneNumberChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Phone Number Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user saves a flow
 *
 * @param {FlowSaveClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowSaveClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Save Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Flow Title to Edit
 *
 * @param {FlowTitleEditClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowTitleEditClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Title Edit Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user uses zooms in using the zoom control
 *
 * @param {FlowZoomInClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowZoomInClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Zoom In Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user uses zooms out using the zoom control
 *
 * @param {FlowZoomOutClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowZoomOutClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Zoom Out Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user reset the zoom level using the zoom control
 *
 * @param {FlowZoomResetClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function flowZoomResetClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Flow Zoom Reset Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects the option to include an internal note
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function followUpConversationModalInternalNoteAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Follow Up Conversation Modal Internal Note Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects the option to offer the conversation in the queue
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function followUpConversationModalOfferInQueueAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Follow Up Conversation Modal Offer In Queue Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user archives an article
 *
 * @param {KnowledgeArticleArchived} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleArchived(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Archived', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user discards changes made to a work in progress article
 *
 * @param {KnowledgeArticleChangesDiscarded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleChangesDiscarded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Changes Discarded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When an article is created in knowledge, either from content management or other sources (like conversation sidebar)
 *
 * @param {KnowledgeArticleCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deletes an article
 *
 * @param {KnowledgeArticleDestroyed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleDestroyed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Destroyed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user submits feedback on an article
 *
 * @param {KnowledgeArticleFeedbackSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleFeedbackSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Feedback Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user indicates that an article was helpful
 *
 * @param {KnowledgeArticleMarkedAsHelpful} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleMarkedAsHelpful(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Marked As Helpful', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user moves an article to a new collection
 *
 * @param {KnowledgeArticleMoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleMoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Moved', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user publishes an article
 *
 * @param {KnowledgeArticlePublished} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticlePublished(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Published', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When an article is re-ordered in the knowledge management screen
 *
 * @param {KnowledgeArticleReordered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleReordered(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Reordered', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user adds a tag to a knowledge article
 *
 * @param {KnowledgeArticleTagAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleTagAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Tag Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user removes a tag from a knowledge article
 *
 * @param {KnowledgeArticleTagRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleTagRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Tag Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user unpublishes a knowledge article
 *
 * @param {KnowledgeArticleUnpublished} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleUnpublished(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Unpublished', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates an article, either the content or meta
 *
 * @param {KnowledgeArticleUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user views a knowledge article
 *
 * @param {KnowledgeArticleViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticleViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Article Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user searches for knowledge articles
 *
 * @param {KnowledgeArticlesSearchByTermSubmitted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeArticlesSearchByTermSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Articles Search By Term Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user creates a knowledge category
 *
 * @param {KnowledgeCategoryCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCategoryCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Category Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user deletes a knowledge category
 *
 * @param {KnowledgeCategoryDestroyed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCategoryDestroyed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Category Destroyed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a category is re-ordered in the knowledge management screen
 *
 * @param {KnowledgeCategoryReordered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCategoryReordered(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Category Reordered', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user makes a change to a knowledge category
 *
 * @param {KnowledgeCategoryUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCategoryUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Category Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user creates a knowledge collection
 *
 * @param {KnowledgeCollectionCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCollectionCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Collection Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user deletes a knowledge collection
 *
 * @param {KnowledgeCollectionDestroyed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCollectionDestroyed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Collection Destroyed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user makes a change to a collection
 *
 * @param {KnowledgeCollectionUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCollectionUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Collection Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user views the knowledge collection
 *
 * @param {KnowledgeCollectionViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeCollectionViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Collection Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a knowledge user views the dashboard in an Internal KB
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeInternalKbDashboardViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Internal Kb Dashboard Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Knowledge Internal Kb Search Result Clicked
 *
 * @param {KnowledgeInternalKbSearchResultClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeInternalKbSearchResultClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Internal Kb Search Result Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When
 *
 * @param {KnowledgeResolutionCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeResolutionCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Resolution Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a initialises a knowledge conversation resolution flow
 *
 * @param {KnowledgeResolutionInitialised} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function knowledgeResolutionInitialised(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Knowledge Resolution Initialised', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user has been selected and the modal is closed afterwards
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mergeContactsMergeCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Merge Contacts Merge Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a merge is failing for some reason
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mergeContactsMergeFailed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Merge Contacts Merge Failed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a contact has successfully been merged
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mergeContactsMergeSucceeded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Merge Contacts Merge Succeeded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the merge contacts modal is closed
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mergeContactsModalClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Merge Contacts Modal Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the merge contacts modal is opened
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mergeContactsModalOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Merge Contacts Modal Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a contact is selected in the merge contacts modal
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function mergeContactsSourceContactSelected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Merge Contacts Source Contact Selected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the See Audit Log button in messenger settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messengerFlowOptionsMenuOptionAuditLogClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Messenger Flow Options Menu Option Audit Log Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the Messenger modal/form
 *
 * @param {MessengerFormCancelled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messengerFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Messenger Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens one of the Messenger listing modals/forms
 *
 * @param {MessengerFormOpened} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messengerFormOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Messenger Form Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user proceeds on a messenger form
 *
 * @param {MessengerFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messengerFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Messenger Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Options Menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messengerOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Messenger Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects an option in the Messenger options menu
 *
 * @param {MessengerOptionsMenuOptionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function messengerOptionsMenuOptionClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Messenger Options Menu Option Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks cancel in the confirm close conversation modal
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modalConversationCloseCancelClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Modal Conversation Close Cancel Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks confirm in the confirm close conversation modal
 *
 * @param {ModalConversationCloseConfirmClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modalConversationCloseConfirmClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Modal Conversation Close Confirm Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks cancel in the transfer to queue modal
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modalTransferToQueueCancelClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Modal Transfer To Queue Cancel Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks confirm in the transfer to queue modal
 *
 * @param {ModalTransferToQueueConfirmClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function modalTransferToQueueConfirmClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Modal Transfer To Queue Confirm Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user network connection changes
 *
 * @param {NetworkConnectionStatusChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function networkConnectionStatusChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Network Connection Status Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user accepts an offer notification
 *
 * @param {NotificationOfferAccepted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationOfferAccepted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Offer Accepted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes an offer notification
 *
 * @param {NotificationOfferClosed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationOfferClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Offer Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user rejects an offer notification
 *
 * @param {NotificationOfferRejected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationOfferRejected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Offer Rejected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the offer notification times out
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationOfferTimeout(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Offer Timeout', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user accepts a transfer offer notification
 *
 * @param {NotificationTransferOfferAccepted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationTransferOfferAccepted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Transfer Offer Accepted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes a transfer offer notification
 *
 * @param {NotificationTransferOfferClosed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationTransferOfferClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Transfer Offer Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user rejects a transfer offer notification
 *
 * @param {NotificationTransferOfferRejected} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationTransferOfferRejected(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Transfer Offer Rejected', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the transfer offer notification times out
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function notificationTransferOfferTimeout(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Notification Transfer Offer Timeout', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks an organization in the organizations navigation
 *
 * @param {OrganizationsNavigationOrganizationClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function organizationsNavigationOrganizationClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Organizations Navigation Organization Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Page Viewed' track call.
 *
 * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pageViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Page Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the create new modal without confirming/saving.
 *
 * @param {PartnerIntegrationsGithubCreateNewIssueCanceled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubCreateNewIssueCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Create New Issue Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on the create new button.
 *
 * @param {PartnerIntegrationsGithubCreateNewIssueClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubCreateNewIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Create New Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirmed to create a new issue.
 *
 * @param {PartnerIntegrationsGithubCreateNewIssueConfirmed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubCreateNewIssueConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Create New Issue Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on an issue in the search results to link it to the conversation.
 *
 * @param {PartnerIntegrationsGithubLinkIssueClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubLinkIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Link Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * when the user canceled to unlink all issues.
 *
 * @param {PartnerIntegrationsGithubUnlinkAllIssuesCanceled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubUnlinkAllIssuesCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Unlink All Issues Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on the unlink all button.
 *
 * @param {PartnerIntegrationsGithubUnlinkAllIssuesClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubUnlinkAllIssuesClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Unlink All Issues Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirmed to unlink all issues.
 *
 * @param {PartnerIntegrationsGithubUnlinkAllIssuesConfirmed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubUnlinkAllIssuesConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Unlink All Issues Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user canceled to unlink an issue.
 *
 * @param {PartnerIntegrationsGithubUnlinkIssueCanceled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubUnlinkIssueCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Unlink Issue Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on the button to unlink an issue.
 *
 * @param {PartnerIntegrationsGithubUnlinkIssueClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubUnlinkIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Unlink Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirmed to unlink an issue.
 *
 * @param {PartnerIntegrationsGithubUnlinkIssueConfirmed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubUnlinkIssueConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github Unlink Issue Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on a linked issue to open it in Github.
 *
 * @param {PartnerIntegrationsGithubViewLinkClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsGithubViewLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Github View Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user collapses an issue's comments
 *
 * @param {PartnerIntegrationsJiraCommentsCollapsed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraCommentsCollapsed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Comments Collapsed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user expands an issue's comments
 *
 * @param {PartnerIntegrationsJiraCommentsExpanded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraCommentsExpanded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Comments Expanded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user creates a link to a Jira issue
 *
 * @param {PartnerIntegrationsJiraLinkIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraLinkIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Link Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens a Jira issue's details
 *
 * @param {PartnerIntegrationsJiraOpenIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraOpenIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Open Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens Jira from the widget
 *
 * @param {PartnerIntegrationsJiraOpenJiraClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraOpenJiraClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Open Jira Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks remove all dangling links
 *
 * @param {PartnerIntegrationsJiraRemoveAllDanglingClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraRemoveAllDanglingClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Remove All Dangling Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks remove on a dangling link
 *
 * @param {PartnerIntegrationsJiraRemoveDanglingIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraRemoveDanglingIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Remove Dangling Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels removing all dangling links
 *
 * @param {PartnerIntegrationsJiraUnlinkAllIssuesCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraUnlinkAllIssuesCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Unlink All Issues Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks unlink all links
 *
 * @param {PartnerIntegrationsJiraUnlinkAllIssuesClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraUnlinkAllIssuesClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Unlink All Issues Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirms removing all dangling links
 *
 * @param {PartnerIntegrationsJiraUnlinkAllIssuesConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraUnlinkAllIssuesConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Unlink All Issues Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels unlinking an issue
 *
 * @param {PartnerIntegrationsJiraUnlinkIssueCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraUnlinkIssueCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Unlink Issue Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks unlink issue
 *
 * @param {PartnerIntegrationsJiraUnlinkIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraUnlinkIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Unlink Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirms unlinking an issue
 *
 * @param {PartnerIntegrationsJiraUnlinkIssueConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsJiraUnlinkIssueConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Jira Unlink Issue Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user unsubscribed a given channel.
 *
 * @param {PartnerIntegrationsKlaviyoProfileUnsubscribeClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsKlaviyoProfileUnsubscribeClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Klaviyo Profile Unsubscribe Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels to create a new Linear issue
 *
 * @param {PartnerIntegrationsLinearCreateNewIssueCancelled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearCreateNewIssueCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Create New Issue Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks to open a new Linear issue
 *
 * @param {PartnerIntegrationsLinearCreateNewIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearCreateNewIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Create New Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirms to create a new Linear issue
 *
 * @param {PartnerIntegrationsLinearCreateNewIssueConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearCreateNewIssueConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Create New Issue Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user creates a link to a Linear issue
 *
 * @param {PartnerIntegrationsLinearLinkIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearLinkIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Link Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the details of a Linear issue
 *
 * @param {PartnerIntegrationsLinearOpenIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearOpenIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Open Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens Linear from the widget
 *
 * @param {PartnerIntegrationsLinearOpenLinearClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearOpenLinearClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Open Linear Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks unlink issue
 *
 * @param {PartnerIntegrationsLinearUnlinkIssueClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsLinearUnlinkIssueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Linear Unlink Issue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted the creation of a partner integration configuration
 *
 * @param {PartnerIntegrationsSettingsCreateSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsCreateSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings Create Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user created a partner integration settings page from the integration settings overview
 *
 * @param {PartnerIntegrationsSettingsOverviewCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsOverviewCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings Overview Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user viewed a partner integration settings page from the integration settings overview
 *
 * @param {PartnerIntegrationsSettingsOverviewViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsOverviewViewed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings Overview Viewed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on a partner integrations settings page and clicked the "back to the overview" link
 *
 * @param {PartnerIntegrationsSettingsViewBackToOverviewClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewBackToOverviewClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View Back To Overview Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user canceled the deletion request
 *
 * @param {PartnerIntegrationsSettingsViewDeleteCanceled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewDeleteCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View Delete Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirmed the deletion of a partner integrations configuration
 *
 * @param {PartnerIntegrationsSettingsViewDeleteConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewDeleteConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View Delete Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Then the user requested the deletion of a partner integrations configuration
 *
 * @param {PartnerIntegrationsSettingsViewDeleteRequested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewDeleteRequested(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View Delete Requested', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the OAuth button in the widget settings view
 *
 * @param {PartnerIntegrationsSettingsViewOAuthStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewOAuthStarted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View OAuth Started', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked the OAuth button in the widget settings view and the connection was successful
 *
 * @param {PartnerIntegrationsSettingsViewOAuthSucceeded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewOAuthSucceeded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View OAuth Succeeded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted changes to a partner integration configuration
 *
 * @param {PartnerIntegrationsSettingsViewSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsSettingsViewSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Settings View Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closed an order collapse inside the partner integration widget
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderCollapseClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderCollapseClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Collapse Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened an order collapse inside the partner integration widget
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderCollapseOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderCollapseOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Collapse Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user canceled the change of the shipping address of an order
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Edit Shipping Address Modal Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the change shipping address modal for an order
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Edit Shipping Address Modal Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submitted a change of the shipping address for an order
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Edit Shipping Address Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user canceled the refund order option request
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderRefundCanceled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderRefundCanceled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Refund Canceled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirmed the refund order option
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderRefundConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderRefundConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Refund Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user requested the refund order option
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderRefundRequested} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderRefundRequested(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order Refund Requested', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on the "view all orders in Shopify" deeplink
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order View All Orders In Shopify Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on the "view order in Shopify" deeplink
 *
 * @param {PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Order View Order In Shopify Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user refreshed the partner integration widget
 *
 * @param {PartnerIntegrationsShopifyWidgetRefreshed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetRefreshed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget Refreshed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicked on the "view customer in Shopify" deeplink
 *
 * @param {PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Shopify Widget View Customer In Shopify Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closed the partner integration widget in the conversation sidebar
 *
 * @param {PartnerIntegrationsWidgetCollapseClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsWidgetCollapseClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Widget Collapse Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opened the partner integration widget in the conversation sidebar
 *
 * @param {PartnerIntegrationsWidgetCollapseOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function partnerIntegrationsWidgetCollapseOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Partner Integrations Widget Collapse Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Add outbound caller ID from the Actions drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneActionsMenuActionAddOutboundCallerIdClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Actions Menu Action Add Outbound Caller ID Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Change hold music from the Actions drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneActionsMenuActionChangeHoldMusicClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Actions Menu Action Change Hold Music Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the users opens the Actions drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneActionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Actions Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels to verify a phone number
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneAddOutboundCallerIdFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Add Outbound Caller ID Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user verifies a phone number
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneAddOutboundCallerIdFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Add Outbound Caller ID Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the change the hold music form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneChangeHoldMusicFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Change Hold Music Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the hold music
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneChangeHoldMusicFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Change Hold Music Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the Create flow form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneCreateFlowFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Create Flow Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submit the Create flow form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneCreateFlowFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Create Flow Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the See Audit Log button in phone settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionAuditLogClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Audit Log Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Delete from the flow options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Duplicate from the flow options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionDuplicateClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Duplicate Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Edit from the flow options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionEditClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Edit Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Move to another number from the flow options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Move To Another Number Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the flow ellipsis menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Rename from the flow options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFlowOptionsMenuOptionRenameClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Flow Options Menu Option Rename Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the buy number form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the buy number form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFormOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Form Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user buys a phone number
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the ellipsis menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneOptionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Options Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Create flow from the options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneOptionsMenuOptionCreateFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Options Menu Option Create Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Edit from the options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneOptionsMenuOptionEditClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Options Menu Option Edit Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Remove number from the options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneOptionsMenuOptionRemoveNumberClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Options Menu Option Remove Number Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Set default caller ID from the options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneOptionsMenuOptionSetDefaultCallerIdClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Options Menu Option Set Default Caller ID Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user selects Setup from the options drop down menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneOptionsMenuOptionSetupClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Options Menu Option Setup Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user downloads the voice conversation recording
 *
 * @param {PhoneRecordingDownloaded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneRecordingDownloaded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Recording Downloaded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user clicks "pause" on the voice conversation recording
 *
 * @param {PhoneRecordingPauseClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneRecordingPauseClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Recording Pause Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user clicks "play" on the voice conversation recording
 *
 * @param {PhoneRecordingPlayClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneRecordingPlayClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Recording Play Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When a user navigates away from a conversation while the voice conversation recording is playing
 *
 * @param {PhoneRecordingPlaybackAbandoned} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneRecordingPlaybackAbandoned(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Recording Playback Abandoned', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the voice conversation recording plays through to the end
 *
 * @param {PhoneRecordingPlaybackEnded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneRecordingPlaybackEnded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Recording Playback Ended', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user searches for a flow
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function phoneSearchApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Phone Search Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates their availability for a channel
 *
 * @param {PresenceMediaUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function presenceMediaUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Presence Media Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates their status to Away or Working
 *
 * @param {PresenceUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function presenceUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Presence Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user cancels the push notification platform modal/form
 *
 * @param {PushNotificationPlatformFormCancelled} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pushNotificationPlatformFormCancelled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Push Notification Platform Form Cancelled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens one of the push notification platform listing modals/forms
 *
 * @param {PushNotificationPlatformFormOpened} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pushNotificationPlatformFormOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Push Notification Platform Form Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits push notification platform form
 *
 * @param {PushNotificationPlatformFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pushNotificationPlatformFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Push Notification Platform Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user applies a saved search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function savedSearchApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Saved Search Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes a saved search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function savedSearchClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Saved Search Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user creates a saved search
 *
 * @param {SavedSearchCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function savedSearchCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Saved Search Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deletes a saved search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function savedSearchDeleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Saved Search Deleted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates a saved search
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function savedSearchUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Saved Search Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits a csv file
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function scheduledConversationsCreatedSucceeded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Scheduled Conversations Created Succeeded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the import csv button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function scheduledConversationsCsvImportClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Scheduled Conversations Csv Import Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits a csv file
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function scheduledConversationsCsvImported(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Scheduled Conversations Csv Imported', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the users closes the contact preview
 *
 * @param {SearchContactPreviewClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchContactPreviewClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Contact Preview Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user navigates to the full contact view from the search preview
 *
 * @param {SearchContactPreviewGoToClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchContactPreviewGoToClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Contact Preview Go To Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the users clicks on a contact in the search results
 *
 * @param {SearchContactPreviewOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchContactPreviewOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Contact Preview Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the users changes the contact type in the search results
 *
 * @param {SearchContactTypeChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchContactTypeChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Contact Type Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the conversation preview
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchConversationPreviewClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Conversation Preview Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user navigates to the full conversation view from the search preview
 *
 * @param {SearchConversationPreviewGoToClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchConversationPreviewGoToClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Conversation Preview Go To Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on a conversation in the search results
 *
 * @param {SearchConversationPreviewOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchConversationPreviewOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Conversation Preview Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks outside of the search field and it loses focus
 *
 * @param {SearchFieldBlurred} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFieldBlurred(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Field Blurred', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the button to clear the search field
 *
 * @param {SearchFieldCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFieldCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Field Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the search field and it becomes focused
 *
 * @param {SearchFieldFocused} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFieldFocused(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Field Focused', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user types something in the search field
 *
 * @param {SearchFieldPopulated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFieldPopulated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Field Populated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the value in the search field
 *
 * @param {SearchFieldSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFieldSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Field Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a search filter
 *
 * @param {SearchFilterAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clears a search filter
 *
 * @param {SearchFilterCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clears the value of a search filter condition
 *
 * @param {SearchFilterConditionAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterConditionAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Condition Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user removes a search filter condition
 *
 * @param {SearchFilterConditionRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterConditionRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Condition Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the operator of a search filter
 *
 * @param {SearchFilterOperatorUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterOperatorUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Operator Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user removes a search filter
 *
 * @param {SearchFilterRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterRemoved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Removed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates the search filtering strategy
 *
 * @param {SearchFilterStrategyUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterStrategyUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Strategy Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a value to a search filter condition
 *
 * @param {SearchFilterValueAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterValueAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Value Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user adds a value to a search filter condition
 *
 * @param {SearchFilterValueCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFilterValueCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filter Value Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user applies the search filters
 *
 * @param {SearchFiltersApplied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFiltersApplied(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filters Applied', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clears the search filters
 *
 * @param {SearchFiltersCleared} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFiltersCleared(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filters Cleared', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the search filters sidebar
 *
 * @param {SearchFiltersClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFiltersClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filters Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the search filters sidebar
 *
 * @param {SearchFiltersOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFiltersOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filters Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the validation of the search filters fails
 *
 * @param {SearchFiltersValidationFailed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchFiltersValidationFailed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Filters Validation Failed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the note preview
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchNotePreviewClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Note Preview Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user navigates to the full conversation view from the search preview
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchNotePreviewGoToClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Note Preview Go To Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on a note in the search results
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchNotePreviewOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Note Preview Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the search results sorting
 *
 * @param {SearchSortingUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchSortingUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Sorting Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles strict search
 *
 * @param {SearchStrictToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchStrictToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Strict Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens a different search tab
 *
 * @param {SearchTabOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function searchTabOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Search Tab Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Add agent" button on agents settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAgentsAddAgentButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Agents Add Agent Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the edit icon in the agents table on settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAgentsEditButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Agents Edit Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user switches between tabs on agents settings page
 *
 * @param {SettingsAgentsTabClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAgentsTabClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Agents Tab Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on workloads tab on agents settings page
 *
 * @param {SettingsAgentsWorkloadsFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAgentsWorkloadsFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Agents Workloads Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the confirm delete modal
 *
 * @param {SettingsAudioDeleteCancelClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioDeleteCancelClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Delete Cancel Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the confirm delete modal
 *
 * @param {SettingsAudioDeleteClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioDeleteClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Delete Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the confirm delete modal
 *
 * @param {SettingsAudioDeleteConfirmClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioDeleteConfirmClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Delete Confirm Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deletes a wait music file
 *
 * @param {SettingsAudioDeleteWaitMusicClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioDeleteWaitMusicClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Delete Wait Music Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user uploads a wait music file
 *
 * @param {SettingsAudioUploadWaitMusic} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioUploadWaitMusic(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Upload Wait Music', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user interacts with audio usage
 *
 * @param {SettingsAudioUsageFlowClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioUsageFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Usage Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user interacts with audio usage
 *
 * @param {SettingsAudioUsageLinkClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioUsageLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Usage Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the link to see the usage of a wait music file
 *
 * @param {SettingsAudioWaitMusicUsageLinkClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsAudioWaitMusicUsageLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Audio Wait Music Usage Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Add new card" button on settings billing page
 *
 * @param {SettingsBillingAddCardButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsBillingAddCardButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Billing Add Card Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Download" button in invoices table on settings billing page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsBillingDownloadInvoiceButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Billing Download Invoice Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user the form on settings billing page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsBillingFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Billing Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the edit flow in the chat settings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsChatEditFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Chat Edit Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user assigns keybindings to a command
 *
 * @param {SettingsCommandsAssignKeybindings} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCommandsAssignKeybindings(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Commands Assign Keybindings', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user resets all commands to their default keybindings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCommandsResetAllKeybindings(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Commands Reset All Keybindings', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user resets a command's keybindings
 *
 * @param {SettingsCommandsResetKeybindings} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCommandsResetKeybindings(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Commands Reset Keybindings', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user unassigns all commands' keybindings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCommandsUnassignAllKeybindings(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Commands Unassign All Keybindings', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user unassigns a command's keybindings
 *
 * @param {SettingsCommandsUnassignKeybindings} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCommandsUnassignKeybindings(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Commands Unassign Keybindings', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user activated a custom attribute
 *
 * @param {SettingsCustomAttributeActivated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeActivated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Activated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Add new attribute button
 *
 * @param {SettingsCustomAttributeAddNewAttributeClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeAddNewAttributeClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Add New Attribute Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user archives a custom attribute
 *
 * @param {SettingsCustomAttributeArchived} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeArchived(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Archived', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user create a custom attribute
 *
 * @param {SettingsCustomAttributeCreated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deactivates a custom attribute
 *
 * @param {SettingsCustomAttributeDeactivated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeDeactivated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Deactivated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user reorders a custom attribute
 *
 * @param {SettingsCustomAttributeReordered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeReordered(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Reordered', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user unarchives a custom attribute
 *
 * @param {SettingsCustomAttributeUnarchived} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeUnarchived(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Unarchived', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates a custom attribute
 *
 * @param {SettingsCustomAttributeUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsCustomAttributeUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Custom Attribute Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the edit flow in the email settings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsEmailEditFlowClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Email Edit Flow Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Tokens page and clicks the Add button which opens the dialog to add an API token
 *
 * @param {SettingsIntegrationsApiTokensAdd} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensAdd(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Add', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Tokens page and cancels the Add Token dialog
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensAddCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Add Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Tokens page and confirms the Add Token dialog
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensAddConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Add Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and clicks on the Copy Token button
 *
 * @param {SettingsIntegrationsApiTokensCopy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensCopy(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Copy', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and clicks on the link to open the documentation for the Export Messages via Api
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensDocumentationLinkExportMessagesApi(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Documentation Link Export Messages Api', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and clicks on the link to open the documentation for the Integrations API
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Documentation Link Integrations Api', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and clicks on the Remove button which opens a dialog
 *
 * @param {SettingsIntegrationsApiTokensRemove} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensRemove(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Remove', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and cancels the removal dialog for a token
 *
 * @param {SettingsIntegrationsApiTokensRemoveCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensRemoveCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Remove Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and confirms the removal dialog for a token
 *
 * @param {SettingsIntegrationsApiTokensRemoveConfirm} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensRemoveConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens Remove Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and clicks on the View Token button which opens a dialog
 *
 * @param {SettingsIntegrationsApiTokensView} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensView(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens View', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and cancels the view token dialog
 *
 * @param {SettingsIntegrationsApiTokensViewCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensViewCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens View Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the API Token page and clicks Copy token inside the view token dialog
 *
 * @param {SettingsIntegrationsApiTokensViewCopy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsApiTokensViewCopy(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Api Tokens View Copy', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the card edit page and cancels editing an existing card
 *
 * @param {SettingsIntegrationsCardEditCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardEditCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Edit Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the card edit page and saves changes to an existing card
 *
 * @param {SettingsIntegrationsCardEditSave} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardEditSave(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Edit Save', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the card edit page and clicks on Test
 *
 * @param {SettingsIntegrationsCardEditTest} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardEditTest(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Edit Test', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Add card
 *
 * @param {SettingsIntegrationsCardListingAddCard} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardListingAddCard(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Listing Add Card', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Edit card
 *
 * @param {SettingsIntegrationsCardListingEditCard} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardListingEditCard(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Listing Edit Card', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Remove Card
 *
 * @param {SettingsIntegrationsCardListingRemoveCard} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardListingRemoveCard(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Listing Remove Card', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Remove Card but cancels the dialog
 *
 * @param {SettingsIntegrationsCardListingRemoveCardCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardListingRemoveCardCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Listing Remove Card Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Remove Card and confirms the dialog
 *
 * @param {SettingsIntegrationsCardListingRemoveCardConfirm} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardListingRemoveCardConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Listing Remove Card Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Test card
 *
 * @param {SettingsIntegrationsCardListingTestCard} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardListingTestCard(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Listing Test Card', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the documentation link in the header
 *
 * @param {SettingsIntegrationsCardReadDocumentation} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardReadDocumentation(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Read Documentation', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the test card page and clicks on Test
 *
 * @param {SettingsIntegrationsCardTest} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardTest(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Test', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the test card page and adds a parameter
 *
 * @param {SettingsIntegrationsCardTestAddParameter} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardTestAddParameter(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Test Add Parameter', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the test card page and clicks on Cancel
 *
 * @param {SettingsIntegrationsCardTestCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardTestCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Test Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the test card page and removes a parameter
 *
 * @param {SettingsIntegrationsCardTestRemoveParameter} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCardTestRemoveParameter(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Card Test Remove Parameter', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user created a custom card.
 *
 * @param {SettingsIntegrationsCustomCardCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user edited a custom card.
 *
 * @param {SettingsIntegrationsCustomCardEdited} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardEdited(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Edited', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the authentication of the OAuth provider failed.
 *
 * @param {SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardOauthProviderAuthenticationFailed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Oauth Provider Authentication Failed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the authentication of the OAuth provider succeeded.
 *
 * @param {SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Oauth Provider Authentication Succeeded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the authentication of the OAuth provider timed out.
 *
 * @param {SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Oauth Provider Authentication Timed Out', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user created a new OAuth provider.
 *
 * @param {SettingsIntegrationsCustomCardOauthProviderCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardOauthProviderCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Oauth Provider Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updated an existing OAuth provider.
 *
 * @param {SettingsIntegrationsCustomCardOauthProviderUpdated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsCustomCardOauthProviderUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Custom Card Oauth Provider Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on one of the integrations
 *
 * @param {SettingsIntegrationsItemClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Podio page and clicks to add a new Podio integration
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsPodioAdd(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Podio Add', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Podio Add page and validates the Podio credentials
 *
 * @param {SettingsIntegrationsPodioAddValidate} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsPodioAddValidate(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Podio Add Validate', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Podio page and clicks to remove an integration which opens the removal modal
 *
 * @param {SettingsIntegrationsPodioRemove} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsPodioRemove(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Podio Remove', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Podio page and cancels the removal modal
 *
 * @param {SettingsIntegrationsPodioRemoveCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsPodioRemoveCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Podio Remove Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Podio page and confirms the removal of an integration
 *
 * @param {SettingsIntegrationsPodioRemoveConfirm} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsPodioRemoveConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Podio Remove Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform page and clicks on Add Webform Endpoint
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsAdd(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Add', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform Add Webform Endpoint modal and clicks Cancel
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsAddCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Add Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform Add Webform Endpoint modal and clicks Save
 *
 * @param {SettingsIntegrationsWebformEndpointsAddSave} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsAddSave(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Add Save', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform and clicks on the documentation link in the header
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsReadDocumentationLink(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Read Documentation Link', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform and clicks on Remove which opens a modal
 *
 * @param {SettingsIntegrationsWebformEndpointsRemove} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsRemove(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Remove', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform and cancels the removal modal
 *
 * @param {SettingsIntegrationsWebformEndpointsRemoveCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsRemoveCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Remove Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webform and confirms the removal modal
 *
 * @param {SettingsIntegrationsWebformEndpointsRemoveConfirm} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebformEndpointsRemoveConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webform Endpoints Remove Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on the Add webhook button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksAdd(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Add', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks add webhooks page and cancels the form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksAddCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Add Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks add webhooks page and saves the form
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksAddConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Add Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and created a new webhook and copies the webhook token in the confirmation dialog
 *
 * @param {SettingsIntegrationsWebhooksAddConfirmDialogCopy} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksAddConfirmDialogCopy(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Add Confirm Dialog Copy', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on the documentation link
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksDocumentationLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Documentation Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on Edit
 *
 * @param {SettingsIntegrationsWebhooksEdit} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksEdit(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Edit', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks edit page and clicks on Back to webhooks
 *
 * @param {SettingsIntegrationsWebhooksEditBack} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksEditBack(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Edit Back', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks edit page and clicks on Save
 *
 * @param {SettingsIntegrationsWebhooksEditSave} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksEditSave(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Edit Save', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on the Enabled switch to turn the webhook OFF
 *
 * @param {SettingsIntegrationsWebhooksEnabledOff} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksEnabledOff(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Enabled Off', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on the Enabled switch to turn the webhook ON
 *
 * @param {SettingsIntegrationsWebhooksEnabledOn} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksEnabledOn(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Enabled On', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on the Remove button which opens a dialog
 *
 * @param {SettingsIntegrationsWebhooksRemove} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksRemove(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Remove', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and cancels the Remove dialog
 *
 * @param {SettingsIntegrationsWebhooksRemoveCancel} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksRemoveCancel(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Remove Cancel', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and confirms the Remove dialog
 *
 * @param {SettingsIntegrationsWebhooksRemoveConfirm} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksRemoveConfirm(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks Remove Confirm', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and clicks on the a webhook to see the details
 *
 * @param {SettingsIntegrationsWebhooksView} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksView(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks View', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and views a webhook and clicks on the copy secret button
 *
 * @param {SettingsIntegrationsWebhooksViewCopySecret} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksViewCopySecret(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks View Copy Secret', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and views a webhook and clicks on the edit button
 *
 * @param {SettingsIntegrationsWebhooksViewEdit} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksViewEdit(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks View Edit', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user is on the Settings/Webhooks page and views a webhook and clicks on the back button to go to the list
 *
 * @param {SettingsIntegrationsWebhooksViewEditBack} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsIntegrationsWebhooksViewEditBack(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Integrations Webhooks View Edit Back', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the settings menu item
 *
 * @param {SettingsMenuItemClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsMenuItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Menu Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on organization settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsOrganizationFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Organization Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes organization logo
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsOrganizationLogoChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Organization Logo Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on profile settings page
 *
 * @param {SettingsProfileFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsProfileFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Profile Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user added a queue
 *
 * @param {SettingsQueueAdded} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueAdded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Added', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user performed a search.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueAgentDeleted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Agent Deleted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When an agent was deleted.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueAgentSearchSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Agent Search Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When sorting was applied.
 *
 * @param {SettingsQueueAgentSorted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueAgentSorted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Agent Sorted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the queue settings alerts form was saved.
 *
 * @param {SettingsQueueAlertsSaved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueAlertsSaved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Alerts Saved', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user saved a queue
 *
 * @param {SettingsQueueSaved} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueSaved(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Saved', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the Add team button was clicked.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueTeamsAddTeamButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Teams Add Team Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the Add team form was submitted.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueTeamsAddTeamFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Teams Add Team Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the Delete team button was clicked.
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueueTeamsDeleteTeamButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queue Teams Delete Team Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Add Queue button in the queue settings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueuesAddQueueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queues Add Queue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the users clicks the archive queue button in the queue settings
 *
 * @param {SettingsQueuesArchiveQueueClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueuesArchiveQueueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queues Archive Queue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the edit button in the queue settings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueuesEditQueueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queues Edit Queue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the users clicks the unarchive queue button in the queue settings
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsQueuesUnarchiveQueueClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Queues Unarchive Queue Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on Add Tag button on tags settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTagsAddTagButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Tags Add Tag Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on delete icon on tags settings page
 *
 * @param {SettingsTagsRemoveTagButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTagsRemoveTagButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Tags Remove Tag Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user presses confirm button on delete team modal
 *
 * @param {SettingsTagsRemoveTagConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTagsRemoveTagConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Tags Remove Tag Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user activates a tag on tags settings page
 *
 * @param {SettingsTagsTagActivated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTagsTagActivated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Tags Tag Activated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user deactivates a tag on tags settings page
 *
 * @param {SettingsTagsTagDeactivated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTagsTagDeactivated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Tags Tag Deactivated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Add team" button on team settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTeamAddTeamButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Team Add Team Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Add agents" button on team details settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTeamDetailsAddAgentsButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Team Details Add Agents Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Edit" icon in the table on team settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTeamEditTeamButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Team Edit Team Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on team modal
 *
 * @param {SettingsTeamModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTeamModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Team Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on "Remove" icon in the table on team settings page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTeamRemoveTeamButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Team Remove Team Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user presses confirm button on delete team modal
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTeamRemoveTeamConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Team Remove Team Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the add button in one of the tabs on templates settings page
 *
 * @param {SettingsTemplatesAddTemplateButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesAddTemplateButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Add Template Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the edit icon in one of the tabs on templates settings page
 *
 * @param {SettingsTemplatesEditTemplateButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesEditTemplateButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Edit Template Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on template modal on templates settings page
 *
 * @param {SettingsTemplatesModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on template old modal on templates settings page
 *
 * @param {SettingsTemplatesOldModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesOldModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Old Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the delete icon in one of the tabs on templates settings page
 *
 * @param {SettingsTemplatesRemoveTemplateButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesRemoveTemplateButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Remove Template Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on confirm button on remove template confirm modal on templates settings page
 *
 * @param {SettingsTemplatesRemoveTemplateConfirmed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesRemoveTemplateConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Remove Template Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user switches between tabs on templates settings page
 *
 * @param {SettingsTemplatesTabClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function settingsTemplatesTabClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Settings Templates Tab Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens and closes a tab or window if there are any instances left and when the focus changes between different instances
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sharedWorkerTabOrWindowChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Shared Worker Tab Or Window Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user closes the agent interface. Including every tab and window.
 *
 * @param {SharedWorkerTabOrWindowClosed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sharedWorkerTabOrWindowClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Shared Worker Tab Or Window Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the agent interface. Including every tab and window.
 *
 * @param {SharedWorkerTabOrWindowOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sharedWorkerTabOrWindowOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Shared Worker Tab Or Window Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on add agent icon on sidebar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sidebarAddAgentButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Sidebar Add Agent Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the sidebar is collapsed
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sidebarCollapsed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Sidebar Collapsed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the sidebar is expanded
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sidebarExpanded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Sidebar Expanded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on a navigation link in the sidebar
 *
 * @param {SidebarNavClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sidebarNavClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Sidebar Nav Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user aborts signing out
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signOutAborted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Sign Out Aborted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user confirms signing out
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function signOutConfirmed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Sign Out Confirmed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user updates their simultaneous ring status
 *
 * @param {SimultaneousRingUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function simultaneousRingUpdated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Simultaneous Ring Updated', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the "Smart Conversation Reply" button from the Elevio or Dixa knowledge sidebar card
 *
 * @param {SmartConversationReplyButtonClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function smartConversationReplyButtonClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Smart Conversation Reply Button Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks on the inline tag creation item on the list to create a tag with the searched value
 *
 * @param {TagSelectCreateNewTagClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function tagSelectCreateNewTagClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Tag Select Create New Tag Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user changes the tag color on Create new tag modal
 *
 * @param {TagsCreateModalColorChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function tagsCreateModalColorChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Tags Create Modal Color Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on Create new tag modal
 *
 * @param {TagsCreateModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function tagsCreateModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Tags Create Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the Create new tag modal
 *
 * @param {TagsCreateModalOpened} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function tagsCreateModalOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Tags Create Modal Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the agent actions menu item
 *
 * @param {TeamAgentActionsMenuItemClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamAgentActionsMenuItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Agent Actions Menu Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the agent actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamAgentActionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Agent Actions Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user collapsed the agent item
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamAgentCollapsed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Agent Collapsed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user expands the agent item
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamAgentExpanded(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Agent Expanded', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the Assigned Agents Only button
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamAssignedAgentsOnlyClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Assigned Agents Only Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the conversation actions menu item
 *
 * @param {TeamConversationActionsMenuItemClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamConversationActionsMenuItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Conversation Actions Menu Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the conversation actions menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamConversationActionsMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Conversation Actions Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the status link in the conversation
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamConversationStatusLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Conversation Status Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the title link in the conversation
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamConversationTitleLinkClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Conversation Title Link Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user toggles the favorite agent
 *
 * @param {TeamFavoriteToggled} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamFavoriteToggled(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Favorite Toggled', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the filter menu item
 *
 * @param {TeamFilterMenuItemClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamFilterMenuItemClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Filter Menu Item Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user opens the filter agents menu
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamFilterMenuOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Filter Menu Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the next page on the Team page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamNextPageClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Next Page Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user clicks the previous page on the Team page
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function teamPreviousPageClicked(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Team Previous Page Clicked', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When Beamer is opened from the topbar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function topbarBeamerOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Topbar Beamer Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the email dropdown in the topbar is opened
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function topbarEmailOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Topbar Email Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the notifications dropdown is opened from the topbar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function topbarNotificationsOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Topbar Notifications Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the phones dropdown in the topbar is opened
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function topbarPhonesOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Topbar Phones Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the queues dropdown is opened from the topbar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function topbarQueuesOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Topbar Queues Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the support menu is opened from the topbar
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function topbarSupportOpened(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Topbar Support Opened', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the user submits the form on user modal
 *
 * @param {UserModalFormSubmitted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userModalFormSubmitted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('User Modal Form Submitted', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the active websocket connection changes
 *
 * @param {WebsocketActiveConnectionChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function websocketActiveConnectionChanged(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Websocket Active Connection Changed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the websocket receives a close event
 *
 * @param {WebsocketCloseEventReceived} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function websocketCloseEventReceived(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Websocket Close Event Received', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the websocket connection is created
 *
 * @param {WebsocketConnectionClosed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function websocketConnectionClosed(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Websocket Connection Closed', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the websocket connection is closed
 *
 * @param {WebsocketConnectionCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function websocketConnectionCreated(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Websocket Connection Created', props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * When the websocket reconnect attempt starts
 *
 * @param {WebsocketReconnectAttemptStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function websocketReconnectAttemptStarted(props, options, callback) {
    const a = analytics();
    if (a) {
        a.track('Websocket Reconnect Attempt Started', props || {}, withTypewriterContext(options), callback);
    }
}
const clientAPI = {
    /**
     * Updates the run-time configuration of this Typewriter client.
     *
     * @param {TypewriterOptions} options - the options to upsert
     *
     * @typedef {Object} TypewriterOptions
     * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setTypewriterOptions,
    /**
     * When the user submits the form on Add agents modal
     *
     * @param {AddAgentsModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    addAgentsModalFormSubmitted,
    /**
     * When the user submits the form on Add Card Modal from Billing settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    addCreditCardModalFormSubmitted,
    /**
     * When the user clicks an items from the Agent Copilot dropdown in the reply area.
     *
     * @param {AgentCopilotDropdownItemClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    agentCopilotDropdownItemClicked,
    /**
     * When the user clicks the Replace Text action in a copilot action.
     *
     * @param {AgentCopilotTextInsertBelowClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    agentCopilotTextInsertBelowClicked,
    /**
     * When the user clicks the Insert Below action in a copilot action.
     *
     * @param {AgentCopilotTextReplaceClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    agentCopilotTextReplaceClicked,
    /**
     * When the user selects a language to translate a message to.
     *
     * @param {AgentCopilotTranslateMessageLanguageSelected} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    agentCopilotTranslateMessageLanguageSelected,
    /**
     * When the user clicks on the banner in old or new Analytics
     *
     * @param {AnalyticsBannerClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsBannerClicked,
    /**
     * When the user selects a business hours schedule filter on a dashboard
     *
     * @param {AnalyticsBusinessHoursScheduleRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsBusinessHoursScheduleRemoved,
    /**
     * When the user removes a business hours schedule filter on a dashboard
     *
     * @param {AnalyticsBusinessHoursScheduleUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsBusinessHoursScheduleUpdated,
    /**
     * When the user changes the granularity of a chart
     *
     * @param {AnalyticsChartGranularityChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsChartGranularityChanged,
    /**
     * When the user changes the visualization of a chart
     *
     * @param {AnalyticsChartVisualizationChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsChartVisualizationChanged,
    /**
     * When the user clicks the compare button in a dashboard
     *
     * @param {AnalyticsCompareClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsCompareClicked,
    /**
     * When the user updates the context in a comparison
     *
     * @param {AnalyticsCompareContextUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsCompareContextUpdated,
    /**
     * When the user updates the context in a comparison
     *
     * @param {AnalyticsComparePeriodUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsComparePeriodUpdated,
    /**
     * When the user updates the context on a dashboard
     *
     * @param {AnalyticsContextUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsContextUpdated,
    /**
     * When the user clicks on a conversation link in supported instruments
     *
     * @param {AnalyticsConversationLinkClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsConversationLinkClicked,
    /**
     * When the user clicks on the button to preview a conversation in supported instruments
     *
     * @param {AnalyticsConversationPreviewClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsConversationPreviewClicked,
    /**
     * When the user views a dashboard
     *
     * @param {AnalyticsDashboardViewed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsDashboardViewed,
    /**
     * When the user clicks the export button in a dashboard
     *
     * @param {AnalyticsExportClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsExportClicked,
    /**
     * When the user clicks the export download button in a dashboard
     *
     * @param {AnalyticsExportDownloadClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsExportDownloadClicked,
    /**
     * When the user clicks Export my data button on Analytics Export Dashboard
     *
     * @param {AnalyticsExportMyDataButtonPressed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsExportMyDataButtonPressed,
    /**
     * When the user clears a filter in a dashboard
     *
     * @param {AnalyticsFilterCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsFilterCleared,
    /**
     * When the user opens a filter in a dashboard
     *
     * @param {AnalyticsFilterOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsFilterOpened,
    /**
     * When the updates the operator of filter in a dashboard
     *
     * @param {AnalyticsFilterOperatorUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsFilterOperatorUpdated,
    /**
     * When the user adds a filter value in a dashboard
     *
     * @param {AnalyticsFilterValueAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsFilterValueAdded,
    /**
     * When the user applies some filters in a dashboard
     *
     * @param {AnalyticsFiltersApplied} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsFiltersApplied,
    /**
     * When the user clears all filters in a dashboard
     *
     * @param {AnalyticsFiltersCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsFiltersCleared,
    /**
     * When the user clicks a helper in a dashboard
     *
     * @param {AnalyticsHelperClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsHelperClicked,
    /**
     * When the user clicks an in-depth button in a dashboard
     *
     * @param {AnalyticsInDepthClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsInDepthClicked,
    /**
     * When the user clicks the AI insights button in a dashboard
     *
     * @param {AnalyticsInsightsClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsInsightsClicked,
    /**
     * When the user clicks copy to clipboard on an AI insight in a dashboard
     *
     * @param {AnalyticsInsightsCopyClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsInsightsCopyClicked,
    /**
     * When the user clicks a feedback button on an AI insight in a dashboard
     *
     * @param {AnalyticsInsightsFeedbackClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsInsightsFeedbackClicked,
    /**
     * When the user clicks on an AI insight prompt in a dashboard
     *
     * @param {AnalyticsInsightsPromptClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsInsightsPromptClicked,
    /**
     * When the user clicks regenerate on an AI insight prompt in a dashboard
     *
     * @param {AnalyticsInsightsRegenerateClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsInsightsRegenerateClicked,
    /**
     * When the user clicks the Latest Updates button
     *
     * @param {AnalyticsLatestUpdatesClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsLatestUpdatesClicked,
    /**
     * When the user updates the period on a dashboard
     *
     * @param {AnalyticsPeriodUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsPeriodUpdated,
    /**
     * When the user creates a quick view
     *
     * @param {AnalyticsQuickViewCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewCreated,
    /**
     * When the user deletes a quick view
     *
     * @param {AnalyticsQuickViewDeleted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewDeleted,
    /**
     * When the user duplicates a quick view
     *
     * @param {AnalyticsQuickViewDuplicated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewDuplicated,
    /**
     * When the user favorites or unfavorites a quick view
     *
     * @param {AnalyticsQuickViewFavoriteToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewFavoriteToggled,
    /**
     * When the user shares or unshares a quick view
     *
     * @param {AnalyticsQuickViewSharingToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewSharingToggled,
    /**
     * When the user updates a quick view
     *
     * @param {AnalyticsQuickViewUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewUpdated,
    /**
     * When the user views a quick view
     *
     * @param {AnalyticsQuickViewViewed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsQuickViewViewed,
    /**
     * When the user clicks a refresh button in a dashboard
     *
     * @param {AnalyticsRefreshClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsRefreshClicked,
    /**
     * When the user dismisses the sidenav announcement in Analytics
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsSidenavAnnouncementDismissed,
    /**
     * When the user clicks the load all results button on a table
     *
     * @param {AnalyticsTableLoadAllClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsTableLoadAllClicked,
    /**
     * When the user updates the sorting on a table
     *
     * @param {AnalyticsTableSortUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsTableSortUpdated,
    /**
     * When the user updates the timezone on a dashboard
     *
     * @param {AnalyticsTimezoneUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsTimezoneUpdated,
    /**
     * When the user clicks the view conversations button in a panel
     *
     * @param {AnalyticsViewConversationsClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    analyticsViewConversationsClicked,
    /**
     * When the user types something different than the autocomplete suggestion, invalidating it.
     *
     * @param {AutocompleteSuggestionMismatchDetected} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    autocompleteSuggestionMismatchDetected,
    /**
     * When the user removes the autocomplete suggestion by hitting the "Escape" key
     *
     * @param {AutocompleteSuggestionRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    autocompleteSuggestionRemoved,
    /**
     * When the user selects the autocomplete suggestion by hitting the "Tab" key
     *
     * @param {AutocompleteSuggestionSelected} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    autocompleteSuggestionSelected,
    /**
     * When the user toggles the conversation editor autocomplete feature on or off
     *
     * @param {AutocompleteToggleClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    autocompleteToggleClicked,
    /**
     * When the user clicks the See Audit Log button in automations settings page
    
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsFlowOptionsMenuOptionAuditLogClicked,
    /**
     * When the user cancels the Automation form
     *
     * @param {AutomationsFormCancelled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsFormCancelled,
    /**
     * When the user opens the create/update Automation form
     *
     * @param {AutomationsFormOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsFormOpened,
    /**
     * When the user proceeds on the Automation form
     *
     * @param {AutomationsFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsFormSubmitted,
    /**
     * When the user opens the Options Menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsOptionsMenuOpened,
    /**
     * When the user selects Delete in the Automation options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsOptionsMenuOptionDeleteClicked,
    /**
     * When the user selects Duplicate in the Automation options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsOptionsMenuOptionDuplicateClicked,
    /**
     * When the user selects Edit Flow in the Automation options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsOptionsMenuOptionFlowClicked,
    /**
     * When the user selects Settings in the Automation options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsOptionsMenuOptionSettingsClicked,
    /**
     * When the user clicks the next page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsPaginationNextClicked,
    /**
     * When the user clicks the previous page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsPaginationPreviousClicked,
    /**
     * When the user performs a search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsSearchApplied,
    /**
     * When the user closes the search field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsSearchClosed,
    /**
     * When the user opens the search field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsSearchOpened,
    /**
     * When the user toggles an automation off
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsToggledOff,
    /**
     * When the user toggles an automation on
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    automationsToggledOn,
    /**
     * When the user clicks the Ban User button
     *
     * @param {BansBanUserClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    bansBanUserClicked,
    /**
     * When the user clicks the Unban IP button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    bansUnbanIpClicked,
    /**
     * When the user clicks the Unban User button
     *
     * @param {BansUnbanUserClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    bansUnbanUserClicked,
    /**
     * When the user clicks the Update button in the Bulk Actions
     *
     * @param {BulkActionsUpdateClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    bulkActionsUpdateClicked,
    /**
     * When the user added an Audio message.
     *
     * @param {BusinessHoursAddScheduleAudioMessageAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursAddScheduleAudioMessageAdded,
    /**
     * When the user clicked the Add new schedule button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursAddScheduleButtonClicked,
    /**
     * When the user cancelled the Add new schedule form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursAddScheduleFormCancelled,
    /**
     * When the user submitted the Add new schedule form.
     *
     * @param {BusinessHoursAddScheduleFormSubmitted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursAddScheduleFormSubmitted,
    /**
     * When the user clicked the Go to Business Hours button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursConflictNotificationButtonClicked,
    /**
     * When the user clicked the close button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursConflictNotificationClosed,
    /**
     * When the user cancelled the Delete schedule form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursDeleteScheduleFormCancelled,
    /**
     * When the user submitted the Delete schedule form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursDeleteScheduleFormSubmitted,
    /**
     * When the user cancelled the Duplicate schedule form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursDuplicateScheduleFormCancelled,
    /**
     * When the user submitted the Duplicate schedule form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursDuplicateScheduleFormSubmitted,
    /**
     * When the user clicked the Support article link.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursFeatureAnnouncementModalLearnMoreButtonClicked,
    /**
     * When the user clicked the one of the question toggle.
     *
     * @param {BusinessHoursFirstScheduleModalQuestionClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursFirstScheduleModalQuestionClicked,
    /**
     * When the user clicked the Support article link.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursFirstScheduleSupportArticleClicked,
    /**
     * When the user clicked the Go to flow on the Schedules listing page.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursGoToFlowClicked,
    /**
     * When the user added an Audio message.
     *
     * @param {BusinessHoursMigrationWizardAudioMessageAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardAudioMessageAdded,
    /**
     * When the clicked the Create new schedule button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardCreateNewScheduleButtonClicked,
    /**
     * When the user clicked the Edit hours button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardEditHoursButtonClicked,
    /**
     * When the user cancelled the Migration wizard modal.
     *
     * @param {BusinessHoursMigrationWizardFormCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardFormCancelled,
    /**
     * When the user submitted the Migration wizard modal.
     *
     * @param {BusinessHoursMigrationWizardFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardFormSubmitted,
    /**
     * When the user cancelled the Migration wizard Opening hours form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardOpeningHoursFormCancelled,
    /**
     * When the user submitted the Migration wizard Opening hours form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardOpeningHoursFormSubmitted,
    /**
     * When the user clicked the Start update button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursMigrationWizardStartUpdateButtonClicked,
    /**
     * When the user opened the Options Menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursOptionsMenuOpened,
    /**
     * When the user selected Delete in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursOptionsMenuOptionDeleteClicked,
    /**
     * When the user selected Duplicate in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursOptionsMenuOptionDuplicateClicked,
    /**
     * When the user selected Edit schedule in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursOptionsMenuOptionEditClicked,
    /**
     * When the user selected Rename in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursOptionsMenuOptionRenameClicked,
    /**
     * When the user cancelled the Rename schedule form.
     *
     * @param {BusinessHoursRenameScheduleFormCancelled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursRenameScheduleFormCancelled,
    /**
     * When the user submitted the Rename schedule form.
     *
     * @param {BusinessHoursRenameScheduleFormSubmitted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursRenameScheduleFormSubmitted,
    /**
     * When user clicked on the Add exception button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAddExceptionButtonClicked,
    /**
     * When the user cancelled the Add exception form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAddExceptionFormCancelled,
    /**
     * When the user submitted Add exception form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAddExceptionFormSubmitted,
    /**
     * When the user cancelled the Audio message modal.
     *
     * @param {BusinessHoursScheduleAudioMessageFormCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAudioMessageFormCancelled,
    /**
     * When the user submitted the Audio message modal.
     *
     * @param {BusinessHoursScheduleAudioMessageFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAudioMessageFormSubmitted,
    /**
     * When the user opened the Audio message options menu.
     *
     * @param {BusinessHoursScheduleAudioMessageOptionsMenuOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAudioMessageOptionsMenuOpened,
    /**
     * When the user selected Clear from the options menu.
     *
     * @param {BusinessHoursScheduleAudioMessageOptionsMenuOptionClearClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAudioMessageOptionsMenuOptionClearClicked,
    /**
     * When the user selected Record audio message from the options menu.
     *
     * @param {BusinessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAudioMessageOptionsMenuOptionRecordClicked,
    /**
     * When the user selected Upload audio message from the options menu.
     *
     * @param {BusinessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAudioMessageOptionsMenuOptionUploadClicked,
    /**
     * When the user cancelled the Audio message modal.
     *
     * @param {BusinessHoursScheduleAutoReplyFormCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAutoReplyFormCancelled,
    /**
     * When the user submitted the Audio message modal.
     *
     * @param {BusinessHoursScheduleAutoReplyFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAutoReplyFormSubmitted,
    /**
     * When the user opened the Auto replies options menu.
     *
     * @param {BusinessHoursScheduleAutoReplyOptionsMenuOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAutoReplyOptionsMenuOpened,
    /**
     * When the user selected Add auto-reply template option.
     *
     * @param {BusinessHoursScheduleAutoReplyOptionsMenuOptionAddClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAutoReplyOptionsMenuOptionAddClicked,
    /**
     * When the user selected Clear from the options menu.
     *
     * @param {BusinessHoursScheduleAutoReplyOptionsMenuOptionClearClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleAutoReplyOptionsMenuOptionClearClicked,
    /**
     * When the user clicked the Change button on the overridden item.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleConflictChangeButtonClicked,
    /**
     * When the user clicked the Review conflicts button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleConflictReviewButtonClicked,
    /**
     * When the user cancelled the Delete exception modal.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleDeleteExceptionFormCancelled,
    /**
     * When the user submitted the Delete exception modal.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleDeleteExceptionFormSubmitted,
    /**
     * When the user clicked the Edit button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleEditButtonClicked,
    /**
     * When the user submitted the Edit schedule form.
     *
     * @param {BusinessHoursScheduleEditFormSubmitted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleEditFormSubmitted,
    /**
     * When the user opened the exception options menu.
     *
     * @param {BusinessHoursScheduleExceptionOptionsMenuOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleExceptionOptionsMenuOpened,
    /**
     * When the user selected Delete in the options menu.
     *
     * @param {BusinessHoursScheduleExceptionOptionsMenuOptionDeleteClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked,
    /**
     * When user clicked on the Exceptions business hours tab.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleExceptionsTabClicked,
    /**
     * When the user cancelled the Import holiday form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleImportHolidayFormCancelled,
    /**
     * When the user submitted the Import holiday form.
     *
     * @param {BusinessHoursScheduleImportHolidayFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleImportHolidayFormSubmitted,
    /**
     * When the user selected Import holidays in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleOptionsMenuImportHolidaysClicked,
    /**
     * When the user opened the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleOptionsMenuOpened,
    /**
     * When the user selected Recover deleted holidays in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleOptionsMenuRecoverHolidaysClicked,
    /**
     * When the user selected Rename in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleOptionsMenuRenameClicked,
    /**
     * When the user selected Edit timezone in the options menu.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleOptionsMenuTimezoneClicked,
    /**
     * When the user clicked the Preview button.
     *
     * @param {BusinessHoursSchedulePreviewButtonClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursSchedulePreviewButtonClicked,
    /**
     * When the user cancelled the Recover holidays modal.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleRecoverHolidaysFormCancelled,
    /**
     * When the user submitted the Recover holidays modal.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleRecoverHolidaysFormSubmitted,
    /**
     * When the user cancelled the Review conflicts form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleReviewFormCancelled,
    /**
     * When the user submitted the Review conflicts form.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleReviewFormSubmitted,
    /**
     * When the user clicked the Save schedule button.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleSaveScheduleButtonClicked,
    /**
     * When user clicked one of the view tabs.
     *
     * @param {BusinessHoursScheduleTabClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleTabClicked,
    /**
     * When the user clicked one of the view buttons.
     *
     * @param {BusinessHoursScheduleViewClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursScheduleViewClicked,
    /**
     * When the user clicked the view switch button.
     *
     * @param {BusinessHoursSchedulesSwitchClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    businessHoursSchedulesSwitchClicked,
    /**
     * When the user clicks the See Audit Log button in chat settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatFlowOptionsMenuOptionAuditLogClicked,
    /**
     * When the user cancels the Widget form
     *
     * @param {ChatFormCanceled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatFormCanceled,
    /**
     * When the user opens the create/rename Widget form
     *
     * @param {ChatFormOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatFormOpened,
    /**
     * When the user proceed on the Widget form
     *
     * @param {ChatFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatFormSubmitted,
    /**
     * Whether the user opens the Options Menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatOptionsMenuOpened,
    /**
     * When the user selects Delete in the Widget options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatOptionsMenuOptionDeleteClicked,
    /**
     * When the user selects Duplicate in the Widget options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatOptionsMenuOptionDuplicateClicked,
    /**
     * When the user selects Edit flow in the Widget options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatOptionsMenuOptionFlowClicked,
    /**
     * When the user selects Rename in the Widget options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatOptionsMenuOptionRenameClicked,
    /**
     * When the user selects Setup in the Widget options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatOptionsMenuOptionSetupClicked,
    /**
     * When the user clicks the next page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatPaginationNextClicked,
    /**
     * When the user clicks the previous page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatPaginationPreviousClicked,
    /**
     * When the user performs a search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatSearchApplied,
    /**
     * When the user closes the search field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatSearchClosed,
    /**
     * When the user opens the search field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    chatSearchOpened,
    /**
     * When the user clicks Clears All Filters button
     *
     * @param {ClearAllFiltersClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    clearAllFiltersClicked,
    /**
     * When the user clicks a button to close a conversation
     *
     * @param {CloseConversationClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    closeConversationClicked,
    /**
     * When the user executes a command.
     *
     * @param {CommandExecuted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    commandExecuted,
    /**
     * When the user submits the form on company modal
     *
     * @param {CompanyModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    companyModalFormSubmitted,
    /**
     * When the user clicks the Add New Company button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsAddNewCompanyClicked,
    /**
     * When the user clicks the Add New Contact button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsAddNewContactClicked,
    /**
     * When the user clicks the Ban User button on the Contacts page
     *
     * @param {ContactsBanUserClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsBanUserClicked,
    /**
     * When the user opens the Actions Menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardActionsMenuOpened,
    /**
     * When the user clicks the Compose New Email button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardComposeNewEmailClicked,
    /**
     * When the user clicks the to edit a company
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardEditCompanyClicked,
    /**
     * When the user clicks the to edit a contact
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardEditContactClicked,
    /**
     * When the user clicks to make a call in the contact card
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardMakeCallClicked,
    /**
     * When the user clicks the button to see all assigned conversations
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardSeeAllAssignedConversationsClicked,
    /**
     * When the user clicks the button to see all conversations
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardSeeAllConversationsClicked,
    /**
     * When the user clicks to view the company in the contacts card
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardViewCompanyClicked,
    /**
     * When the user clicks to view the conversation
     *
     * @param {ContactsCardViewConversationClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardViewConversationClicked,
    /**
     * When the user clicks to view the user in the contacts card
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsCardViewUserClicked,
    /**
     * When the search input is blurred
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsSearchBlurred,
    /**
     * When the user closes the search input
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsSearchClosed,
    /**
     * When the search input is focused
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsSearchFocused,
    /**
     * When the user opens the search input
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsSearchOpened,
    /**
     * When the user clicks the Unban User button on the Contacts page
     *
     * @param {ContactsUnbanUserClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsUnbanUserClicked,
    /**
     * When the user selects Companies in the dropdown in the contacts page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsViewCompanies,
    /**
     * When the user selects Contacts from the dropdown in the contacts page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    contactsViewEndUsers,
    /**
     * When the user opens the Actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationActionsMenuOpened,
    /**
     * When the user selects an option from the Actions menu
     *
     * @param {ConversationActionsMenuOptionClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationActionsMenuOptionClicked,
    /**
     * When the user closed the Activity Log
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationActivityLogClosed,
    /**
     * When the agent has expanded the Flooter.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationActivityLogFlooterExpanded,
    /**
     * When the user opens the Activity Log
     *
     * @param {ConversationActivityLogOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationActivityLogOpened,
    /**
     * When the user downloads an image attachment from the preview modal
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationAttachedImageIsDownloaded,
    /**
     * When the user clicks on an image attachment that opens the preview
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationAttachedImageIsViewed,
    /**
     * When the user claims the conversation
     *
     * @param {ConversationClaimed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationClaimed,
    /**
     * When the user closes the conversatio
     *
     * @param {ConversationClosed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationClosed,
    /**
     * When the user cancels the CSAT
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationCsatCancelled,
    /**
     * When the user clicks the Cancel CSAT menu option
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationCsatMenuCancelOptionClicked,
    /**
     * When the user changes the language from the CSAT menu
     *
     * @param {ConversationCsatMenuLanguageSelected} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationCsatMenuLanguageSelected,
    /**
     * When the user opens the CSAT menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationCsatMenuOpened,
    /**
     * When a conversation was followed up.
     *
     * @param {ConversationFollowUp} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationFollowUp,
    /**
     * When the user opens the Follow Up menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationFollowUpMenuOpened,
    /**
     * When the user selects an option from the Follow Up menu
     *
     * @param {ConversationFollowUpMenuOptionClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationFollowUpMenuOptionClicked,
    /**
     * When the user opens conversation details dropdown in conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderConversationDetailsMenuOpened,
    /**
     * When the user opens the more menu in the conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderMoreMenuOpened,
    /**
     * When the user adds a tag from tag dropdown in conversation header
     *
     * @param {ConversationHeaderTagAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTagAdded,
    /**
     * When the user toggles Include deactivated tags in tag select dropdown in conversation header
     *
     * @param {ConversationHeaderTagIncludeDeactivatedToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTagIncludeDeactivatedToggled,
    /**
     * When the user opens tags select dropdown from conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTagMenuOpened,
    /**
     * When the user removes a tag from conversation header
     *
     * @param {ConversationHeaderTagRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTagRemoved,
    /**
     * When the user selects an agent from transfer to agent dropdown in conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTransferToAgentItemSelected,
    /**
     * When the user opens the transfer to agent dropdown in conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTransferToAgentMenuOpened,
    /**
     * When the user clicks on transfer to number button in the conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTransferToNumberButtonClicked,
    /**
     * When the user selects a queue from transfer to queue dropdown in conversation header
     *
     * @param {ConversationHeaderTransferToQueueItemSelected} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTransferToQueueItemSelected,
    /**
     * When the user opens the transfer to queue dropdown in conversation header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationHeaderTransferToQueueMenuOpened,
    /**
     * When the user opens the internal note tab
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationInternalNoteEditorOpened,
    /**
     * When a conversation was offered to an agent
     *
     * @param {ConversationOffered} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationOffered,
    /**
     * When the user replies a conversation
     *
     * @param {ConversationReplied} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationReplied,
    /**
     * When a user chooses to create a draft when they resolve a conversation
     *
     * @param {ConversationResolvedAsAKnowledgeArticleDraft} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationResolvedAsAKnowledgeArticleDraft,
    /**
     * When a user chooses to register a knowledge gap when they resolve a conversation
     *
     * @param {ConversationResolvedAsAKnowledgeGap} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationResolvedAsAKnowledgeGap,
    /**
     * When a user resolves a conversation using the knowledge flow
     *
     * @param {ConversationResolvedByKnowledge} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationResolvedByKnowledge,
    /**
     * When a user chooses to resolve a conversation without marking any knowledge article as having helped
     *
     * @param {ConversationResolvedWithNoKnowledgeArticle} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationResolvedWithNoKnowledgeArticle,
    /**
     * When the user closes the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarClosed,
    /**
     * When the user closes the accordion item conversation history
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarConversationHistoryClosed,
    /**
     * When the user navigates to a conversation listed in the conversation history accordion item in the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarConversationHistoryNavigatedToConversation,
    /**
     * When the user opens the accordion item conversation history
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarConversationHistoryOpened,
    /**
     * User collapsed the Conversation summary card in the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarConversationSummaryClosed,
    /**
     * User expanded the Conversation summary card in the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarConversationSummaryOpened,
    /**
     * When the user opens compose email from clicking the customers email in the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarCustomerInfoEmailClicked,
    /**
     * When the user starts phone call from clicking the customers phone number in the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarCustomerInfoPhoneNumberClicked,
    /**
     * When the user opens the sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSidebarOpened,
    /**
     * When the user clicks an item in the conversation timeline
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationTimelineItemOpened,
    /**
     * When the user clicks a conversation listed in a timeline item
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationTimelineNavigatedToConversation,
    /**
     * When the user opens the Transfer menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationTransferMenuOpened,
    /**
     * When the user selects an option from the Transfer To menu
     *
     * @param {ConversationTransferMenuOptionClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationTransferMenuOptionClicked,
    /**
     * When a conversation was transferred.
     *
     * @param {ConversationTransferred} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationTransferred,
    /**
     * When the user views the conversation
     *
     * @param {ConversationViewed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationViewed,
    /**
     * When an agent doesn't find the summary of conversation useful and clicks on thumbs down button.
     *
     * @param {ConversationSummaryFeedbackNotUseful} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSummaryFeedbackNotUseful,
    /**
     * When an agent finds the summary of conversation useful and clicks on thumbs up button.
     *
     * @param {ConversationSummaryFeedbackUseful} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSummaryFeedbackUseful,
    /**
     * When an agent requests for a new conversation summary
     *
     * @param {ConversationSummaryRegenerateSummary} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationSummaryRegenerateSummary,
    /**
     * When the user clicks the Bulk Actions button
     *
     * @param {ConversationsBulkActionsClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsBulkActionsClicked,
    /**
     * When the user clicks the clear all checkbox
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsClearAllClicked,
    /**
     * When the user clicks the Close Conversation button in the actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsCloseConversationClicked,
    /**
     * When the user clicks the "Filter Conversations" button for the agent
     *
     * @param {ConversationsFilterAgentClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsFilterAgentClicked,
    /**
     * When the user clears a conversations filter
     *
     * @param {ConversationsFilterCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsFilterCleared,
    /**
     * When the user clicks the "Filter Conversations" button for the contact
     *
     * @param {ConversationsFilterContactClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsFilterContactClicked,
    /**
     * When the user toggles a conversations filter
     *
     * @param {ConversationsFilterToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsFilterToggled,
    /**
     * When the user clicks the Go To Conversations button in the actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsGoToConversationClicked,
    /**
     * When the user opens the conversation actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsItemActionsMenuOpened,
    /**
     * When the user clicks the assignee avatar
     *
     * @param {ConversationsItemAssigneeClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsItemAssigneeClicked,
    /**
     * When the user opens the conversation info menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsItemInfoOpened,
    /**
     * When the user clicks the preview conversation button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsItemPreviewClicked,
    /**
     * When the user clicks the Next Page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsNextPageClicked,
    /**
     * When the user clicks the Previous Page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsPreviousPageClicked,
    /**
     * When the user clicks the select all checkbox
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsSelectAllClicked,
    /**
     * When the user clicks the select checkbox for a single conversation
     *
     * @param {ConversationsSelectClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsSelectClicked,
    /**
     * When the user clicks a timestamp
     *
     * @param {ConversationsTimestampClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsTimestampClicked,
    /**
     * When the user clicks the Transfer To Queue button in the actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsTransferToQueueClicked,
    /**
     * When the user clicks the View Agent button in the actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsViewAgentClicked,
    /**
     * When the user clicks the View Contact button in the actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsViewContactClicked,
    /**
     * When the user clicks the View Conversations button in the actions menu
     *
     * @param {ConversationsViewConversationsClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    conversationsViewConversationsClicked,
    /**
     * When the user copy the Dixa Widget script
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    copyScript,
    /**
     * When the user selects a country from the Country Code Dropdown in Telephony Search User field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    countryCodeSelected,
    /**
     * Whenever the user updates value of a custom attribute
     *
     * @param {CustomAttributeValueUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    customAttributeValueUpdated,
    /**
     * When the user clicks the next page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    dashboardNextPageClicked,
    /**
     * When the user clicks the previous page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    dashboardPreviousPageClicked,
    /**
     * When the user clicks the dashboard queue item
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    dashboardQueueItemClicked,
    /**
     * When the user toggles the favorite queue
     *
     * @param {DashboardQueueItemFavoriteToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    dashboardQueueItemFavoriteToggled,
    /**
     * When the user changes the queues type
     *
     * @param {DashboardQueuesTypeChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    dashboardQueuesTypeChanged,
    /**
     * When the user clicks the tv dashboard button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    dashboardTvDashboardClicked,
    /**
     * When the user adds a quick response in the conversation input
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    editorQuickResponseAdded,
    /**
     * When the user clicks the See Audit Log button in email settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailFlowOptionsMenuOptionAuditLogClicked,
    /**
     * When the user cancels the Email form
     *
     * @param {EmailFormCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailFormCancelled,
    /**
     * When the user opens the create/update/duplicate/rename Email form
     *
     * @param {EmailFormOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailFormOpened,
    /**
     * When the user proceeds on the Email form
     *
     * @param {EmailFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailFormSubmitted,
    /**
     * When the user opens the Options Menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailOptionsMenuOpened,
    /**
     * When the user selects Delete in the Email options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailOptionsMenuOptionDeleteClicked,
    /**
     * When the user selects Duplicate in the Email options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailOptionsMenuOptionDuplicateClicked,
    /**
     * When the user selects Edit Email in the Email options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailOptionsMenuOptionEmailClicked,
    /**
     * When the user selects Edit Flow in the Email options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailOptionsMenuOptionFlowClicked,
    /**
     * When the user selects Rename in the Email options menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailOptionsMenuOptionRenameClicked,
    /**
     * When the user clicks the next page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailPaginationNextClicked,
    /**
     * When the user clicks the previous page button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailPaginationPreviousClicked,
    /**
     * When the user performs a search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailSearchApplied,
    /**
     * When the user closes the search field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailSearchClosed,
    /**
     * When the user opens the search field
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    emailSearchOpened,
    /**
     * When the user added an action and saved it.
     *
     * @param {FlowActionAddSaved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActionAddSaved,
    /**
     * When the user adds a condition to a branch/condition-action
     *
     * @param {FlowActionConditionAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActionConditionAdded,
    /**
     * When the user adds a condition to a branch/condition-action
     *
     * @param {FlowActionConditionRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActionConditionRemoved,
    /**
     * When the user deletes a node in a flow
     *
     * @param {FlowActionDeleted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActionDeleted,
    /**
     * When the user clicks the edit button on an action
     *
     * @param {FlowActionEditClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActionEditClicked,
    /**
     * When the user saves an action
     *
     * @param {FlowActionEditSaved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActionEditSaved,
    /**
     * When the user saves a flow
     *
     * @param {FlowActivateClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowActivateClicked,
    /**
     * When the user selects a specific action to add
     *
     * @param {FlowAddActionActionSelected} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowAddActionActionSelected,
    /**
     * When the user closes the add action modal without making a selection
     *
     * @param {FlowAddActionCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowAddActionCancelled,
    /**
     * When the user opens the add action modal
     *
     * @param {FlowAddActionOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowAddActionOpened,
    /**
     * When the user clicks the go back to settings button in a Flow
     *
     * @param {FlowBackToSettingsClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowBackToSettingsClicked,
    /**
     * When the user clicks "Align" in the context menu
     *
     * @param {FlowContextAlignClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowContextAlignClicked,
    /**
     * When the user clicks "Cancel" in the confirm modal after clicking the "Delete" option in context menu
     *
     * @param {FlowContextDeleteCancelClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowContextDeleteCancelClicked,
    /**
     * When the user clicks "Delete" in the context menu
     *
     * @param {FlowContextDeleteClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowContextDeleteClicked,
    /**
     * When the user clicks "Confirm" in the confirm modal after clicking the "Delete" option in context menu
     *
     * @param {FlowContextDeleteConfirmClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowContextDeleteConfirmClicked,
    /**
     * When the user clicks "Arrange nodes" in the context menu
     *
     * @param {FlowContextNodeArrangeClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowContextNodeArrangeClicked,
    /**
     * When the user changed the phone number in the phone flow.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowPhoneNumberChanged,
    /**
     * When the user saves a flow
     *
     * @param {FlowSaveClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowSaveClicked,
    /**
     * When the user clicks the Flow Title to Edit
     *
     * @param {FlowTitleEditClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowTitleEditClicked,
    /**
     * When the user uses zooms in using the zoom control
     *
     * @param {FlowZoomInClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowZoomInClicked,
    /**
     * When the user uses zooms out using the zoom control
     *
     * @param {FlowZoomOutClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowZoomOutClicked,
    /**
     * When the user reset the zoom level using the zoom control
     *
     * @param {FlowZoomResetClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    flowZoomResetClicked,
    /**
     * When the user selects the option to include an internal note
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    followUpConversationModalInternalNoteAdded,
    /**
     * When the user selects the option to offer the conversation in the queue
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    followUpConversationModalOfferInQueueAdded,
    /**
     * When a user archives an article
     *
     * @param {KnowledgeArticleArchived} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleArchived,
    /**
     * When a user discards changes made to a work in progress article
     *
     * @param {KnowledgeArticleChangesDiscarded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleChangesDiscarded,
    /**
     * When an article is created in knowledge, either from content management or other sources (like conversation sidebar)
     *
     * @param {KnowledgeArticleCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleCreated,
    /**
     * When the user deletes an article
     *
     * @param {KnowledgeArticleDestroyed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleDestroyed,
    /**
     * When a user submits feedback on an article
     *
     * @param {KnowledgeArticleFeedbackSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleFeedbackSubmitted,
    /**
     * When a user indicates that an article was helpful
     *
     * @param {KnowledgeArticleMarkedAsHelpful} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleMarkedAsHelpful,
    /**
     * When the user moves an article to a new collection
     *
     * @param {KnowledgeArticleMoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleMoved,
    /**
     * When a user publishes an article
     *
     * @param {KnowledgeArticlePublished} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticlePublished,
    /**
     * When an article is re-ordered in the knowledge management screen
     *
     * @param {KnowledgeArticleReordered} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleReordered,
    /**
     * When a user adds a tag to a knowledge article
     *
     * @param {KnowledgeArticleTagAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleTagAdded,
    /**
     * When a user removes a tag from a knowledge article
     *
     * @param {KnowledgeArticleTagRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleTagRemoved,
    /**
     * When a user unpublishes a knowledge article
     *
     * @param {KnowledgeArticleUnpublished} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleUnpublished,
    /**
     * When the user updates an article, either the content or meta
     *
     * @param {KnowledgeArticleUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleUpdated,
    /**
     * When a user views a knowledge article
     *
     * @param {KnowledgeArticleViewed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticleViewed,
    /**
     * When a user searches for knowledge articles
     *
     * @param {KnowledgeArticlesSearchByTermSubmitted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeArticlesSearchByTermSubmitted,
    /**
     * When a user creates a knowledge category
     *
     * @param {KnowledgeCategoryCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCategoryCreated,
    /**
     * When a user deletes a knowledge category
     *
     * @param {KnowledgeCategoryDestroyed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCategoryDestroyed,
    /**
     * When a category is re-ordered in the knowledge management screen
     *
     * @param {KnowledgeCategoryReordered} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCategoryReordered,
    /**
     * When a user makes a change to a knowledge category
     *
     * @param {KnowledgeCategoryUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCategoryUpdated,
    /**
     * When a user creates a knowledge collection
     *
     * @param {KnowledgeCollectionCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCollectionCreated,
    /**
     * When a user deletes a knowledge collection
     *
     * @param {KnowledgeCollectionDestroyed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCollectionDestroyed,
    /**
     * When a user makes a change to a collection
     *
     * @param {KnowledgeCollectionUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCollectionUpdated,
    /**
     * When a user views the knowledge collection
     *
     * @param {KnowledgeCollectionViewed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeCollectionViewed,
    /**
     * When a knowledge user views the dashboard in an Internal KB
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeInternalKbDashboardViewed,
    /**
     * Knowledge Internal Kb Search Result Clicked
     *
     * @param {KnowledgeInternalKbSearchResultClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeInternalKbSearchResultClicked,
    /**
     * When
     *
     * @param {KnowledgeResolutionCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeResolutionCancelled,
    /**
     * When a initialises a knowledge conversation resolution flow
     *
     * @param {KnowledgeResolutionInitialised} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    knowledgeResolutionInitialised,
    /**
     * When a user has been selected and the modal is closed afterwards
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    mergeContactsMergeCancelled,
    /**
     * When a merge is failing for some reason
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    mergeContactsMergeFailed,
    /**
     * When a contact has successfully been merged
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    mergeContactsMergeSucceeded,
    /**
     * When the merge contacts modal is closed
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    mergeContactsModalClosed,
    /**
     * When the merge contacts modal is opened
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    mergeContactsModalOpened,
    /**
     * When a contact is selected in the merge contacts modal
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    mergeContactsSourceContactSelected,
    /**
     * When the user clicks the See Audit Log button in messenger settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    messengerFlowOptionsMenuOptionAuditLogClicked,
    /**
     * When the user cancels the Messenger modal/form
     *
     * @param {MessengerFormCancelled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    messengerFormCancelled,
    /**
     * When the user opens one of the Messenger listing modals/forms
     *
     * @param {MessengerFormOpened} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    messengerFormOpened,
    /**
     * When the user proceeds on a messenger form
     *
     * @param {MessengerFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    messengerFormSubmitted,
    /**
     * When the user opens the Options Menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    messengerOptionsMenuOpened,
    /**
     * When the user selects an option in the Messenger options menu
     *
     * @param {MessengerOptionsMenuOptionClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    messengerOptionsMenuOptionClicked,
    /**
     * When the user clicks cancel in the confirm close conversation modal
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    modalConversationCloseCancelClicked,
    /**
     * When the user clicks confirm in the confirm close conversation modal
     *
     * @param {ModalConversationCloseConfirmClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    modalConversationCloseConfirmClicked,
    /**
     * When the user clicks cancel in the transfer to queue modal
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    modalTransferToQueueCancelClicked,
    /**
     * When the user clicks confirm in the transfer to queue modal
     *
     * @param {ModalTransferToQueueConfirmClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    modalTransferToQueueConfirmClicked,
    /**
     * When the user network connection changes
     *
     * @param {NetworkConnectionStatusChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    networkConnectionStatusChanged,
    /**
     * When the user accepts an offer notification
     *
     * @param {NotificationOfferAccepted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationOfferAccepted,
    /**
     * When the user closes an offer notification
     *
     * @param {NotificationOfferClosed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationOfferClosed,
    /**
     * When the user rejects an offer notification
     *
     * @param {NotificationOfferRejected} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationOfferRejected,
    /**
     * When the offer notification times out
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationOfferTimeout,
    /**
     * When the user accepts a transfer offer notification
     *
     * @param {NotificationTransferOfferAccepted} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationTransferOfferAccepted,
    /**
     * When the user closes a transfer offer notification
     *
     * @param {NotificationTransferOfferClosed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationTransferOfferClosed,
    /**
     * When the user rejects a transfer offer notification
     *
     * @param {NotificationTransferOfferRejected} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationTransferOfferRejected,
    /**
     * When the transfer offer notification times out
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    notificationTransferOfferTimeout,
    /**
     * When the user clicks an organization in the organizations navigation
     *
     * @param {OrganizationsNavigationOrganizationClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    organizationsNavigationOrganizationClicked,
    /**
     * Fires a 'Page Viewed' track call.
     *
     * @param {PageViewed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    pageViewed,
    /**
     * When the user closes the create new modal without confirming/saving.
     *
     * @param {PartnerIntegrationsGithubCreateNewIssueCanceled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubCreateNewIssueCanceled,
    /**
     * When the user clicked on the create new button.
     *
     * @param {PartnerIntegrationsGithubCreateNewIssueClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubCreateNewIssueClicked,
    /**
     * When the user confirmed to create a new issue.
     *
     * @param {PartnerIntegrationsGithubCreateNewIssueConfirmed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubCreateNewIssueConfirmed,
    /**
     * When the user clicked on an issue in the search results to link it to the conversation.
     *
     * @param {PartnerIntegrationsGithubLinkIssueClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubLinkIssueClicked,
    /**
     * when the user canceled to unlink all issues.
     *
     * @param {PartnerIntegrationsGithubUnlinkAllIssuesCanceled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubUnlinkAllIssuesCanceled,
    /**
     * When the user clicked on the unlink all button.
     *
     * @param {PartnerIntegrationsGithubUnlinkAllIssuesClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubUnlinkAllIssuesClicked,
    /**
     * When the user confirmed to unlink all issues.
     *
     * @param {PartnerIntegrationsGithubUnlinkAllIssuesConfirmed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubUnlinkAllIssuesConfirmed,
    /**
     * When the user canceled to unlink an issue.
     *
     * @param {PartnerIntegrationsGithubUnlinkIssueCanceled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubUnlinkIssueCanceled,
    /**
     * When the user clicked on the button to unlink an issue.
     *
     * @param {PartnerIntegrationsGithubUnlinkIssueClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubUnlinkIssueClicked,
    /**
     * When the user confirmed to unlink an issue.
     *
     * @param {PartnerIntegrationsGithubUnlinkIssueConfirmed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubUnlinkIssueConfirmed,
    /**
     * When the user clicked on a linked issue to open it in Github.
     *
     * @param {PartnerIntegrationsGithubViewLinkClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsGithubViewLinkClicked,
    /**
     * When the user collapses an issue's comments
     *
     * @param {PartnerIntegrationsJiraCommentsCollapsed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraCommentsCollapsed,
    /**
     * When the user expands an issue's comments
     *
     * @param {PartnerIntegrationsJiraCommentsExpanded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraCommentsExpanded,
    /**
     * When the user creates a link to a Jira issue
     *
     * @param {PartnerIntegrationsJiraLinkIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraLinkIssueClicked,
    /**
     * When the user opens a Jira issue's details
     *
     * @param {PartnerIntegrationsJiraOpenIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraOpenIssueClicked,
    /**
     * When the user opens Jira from the widget
     *
     * @param {PartnerIntegrationsJiraOpenJiraClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraOpenJiraClicked,
    /**
     * When the user clicks remove all dangling links
     *
     * @param {PartnerIntegrationsJiraRemoveAllDanglingClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraRemoveAllDanglingClicked,
    /**
     * When the user clicks remove on a dangling link
     *
     * @param {PartnerIntegrationsJiraRemoveDanglingIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraRemoveDanglingIssueClicked,
    /**
     * When the user cancels removing all dangling links
     *
     * @param {PartnerIntegrationsJiraUnlinkAllIssuesCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraUnlinkAllIssuesCancelled,
    /**
     * When the user clicks unlink all links
     *
     * @param {PartnerIntegrationsJiraUnlinkAllIssuesClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraUnlinkAllIssuesClicked,
    /**
     * When the user confirms removing all dangling links
     *
     * @param {PartnerIntegrationsJiraUnlinkAllIssuesConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraUnlinkAllIssuesConfirmed,
    /**
     * When the user cancels unlinking an issue
     *
     * @param {PartnerIntegrationsJiraUnlinkIssueCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraUnlinkIssueCancelled,
    /**
     * When the user clicks unlink issue
     *
     * @param {PartnerIntegrationsJiraUnlinkIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraUnlinkIssueClicked,
    /**
     * When the user confirms unlinking an issue
     *
     * @param {PartnerIntegrationsJiraUnlinkIssueConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsJiraUnlinkIssueConfirmed,
    /**
     * When the user unsubscribed a given channel.
     *
     * @param {PartnerIntegrationsKlaviyoProfileUnsubscribeClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsKlaviyoProfileUnsubscribeClicked,
    /**
     * When the user cancels to create a new Linear issue
     *
     * @param {PartnerIntegrationsLinearCreateNewIssueCancelled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearCreateNewIssueCancelled,
    /**
     * When the user clicks to open a new Linear issue
     *
     * @param {PartnerIntegrationsLinearCreateNewIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearCreateNewIssueClicked,
    /**
     * When the user confirms to create a new Linear issue
     *
     * @param {PartnerIntegrationsLinearCreateNewIssueConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearCreateNewIssueConfirmed,
    /**
     * When the user creates a link to a Linear issue
     *
     * @param {PartnerIntegrationsLinearLinkIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearLinkIssueClicked,
    /**
     * When the user opens the details of a Linear issue
     *
     * @param {PartnerIntegrationsLinearOpenIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearOpenIssueClicked,
    /**
     * When the user opens Linear from the widget
     *
     * @param {PartnerIntegrationsLinearOpenLinearClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearOpenLinearClicked,
    /**
     * When the user clicks unlink issue
     *
     * @param {PartnerIntegrationsLinearUnlinkIssueClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsLinearUnlinkIssueClicked,
    /**
     * When the user submitted the creation of a partner integration configuration
     *
     * @param {PartnerIntegrationsSettingsCreateSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsCreateSubmitted,
    /**
     * When the user created a partner integration settings page from the integration settings overview
     *
     * @param {PartnerIntegrationsSettingsOverviewCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsOverviewCreated,
    /**
     * When the user viewed a partner integration settings page from the integration settings overview
     *
     * @param {PartnerIntegrationsSettingsOverviewViewed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsOverviewViewed,
    /**
     * When the user is on a partner integrations settings page and clicked the "back to the overview" link
     *
     * @param {PartnerIntegrationsSettingsViewBackToOverviewClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewBackToOverviewClicked,
    /**
     * When the user canceled the deletion request
     *
     * @param {PartnerIntegrationsSettingsViewDeleteCanceled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewDeleteCanceled,
    /**
     * When the user confirmed the deletion of a partner integrations configuration
     *
     * @param {PartnerIntegrationsSettingsViewDeleteConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewDeleteConfirmed,
    /**
     * Then the user requested the deletion of a partner integrations configuration
     *
     * @param {PartnerIntegrationsSettingsViewDeleteRequested} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewDeleteRequested,
    /**
     * When the user clicked the OAuth button in the widget settings view
     *
     * @param {PartnerIntegrationsSettingsViewOAuthStarted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewOAuthStarted,
    /**
     * When the user clicked the OAuth button in the widget settings view and the connection was successful
     *
     * @param {PartnerIntegrationsSettingsViewOAuthSucceeded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewOAuthSucceeded,
    /**
     * When the user submitted changes to a partner integration configuration
     *
     * @param {PartnerIntegrationsSettingsViewSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsSettingsViewSubmitted,
    /**
     * When the user closed an order collapse inside the partner integration widget
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderCollapseClosed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderCollapseClosed,
    /**
     * When the user opened an order collapse inside the partner integration widget
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderCollapseOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderCollapseOpened,
    /**
     * When the user canceled the change of the shipping address of an order
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalCanceled,
    /**
     * When the user opened the change shipping address modal for an order
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderEditShippingAddressModalOpened,
    /**
     * When the user submitted a change of the shipping address for an order
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderEditShippingAddressSubmitted,
    /**
     * When the user canceled the refund order option request
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderRefundCanceled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderRefundCanceled,
    /**
     * When the user confirmed the refund order option
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderRefundConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderRefundConfirmed,
    /**
     * When the user requested the refund order option
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderRefundRequested} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderRefundRequested,
    /**
     * When the user clicked on the "view all orders in Shopify" deeplink
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderViewAllOrdersInShopifyClicked,
    /**
     * When the user clicked on the "view order in Shopify" deeplink
     *
     * @param {PartnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetOrderViewOrderInShopifyClicked,
    /**
     * When the user refreshed the partner integration widget
     *
     * @param {PartnerIntegrationsShopifyWidgetRefreshed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetRefreshed,
    /**
     * When the user clicked on the "view customer in Shopify" deeplink
     *
     * @param {PartnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsShopifyWidgetViewCustomerInShopifyClicked,
    /**
     * When the user closed the partner integration widget in the conversation sidebar
     *
     * @param {PartnerIntegrationsWidgetCollapseClosed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsWidgetCollapseClosed,
    /**
     * When the user opened the partner integration widget in the conversation sidebar
     *
     * @param {PartnerIntegrationsWidgetCollapseOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    partnerIntegrationsWidgetCollapseOpened,
    /**
     * When the user selects Add outbound caller ID from the Actions drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneActionsMenuActionAddOutboundCallerIdClicked,
    /**
     * When the user selects Change hold music from the Actions drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneActionsMenuActionChangeHoldMusicClicked,
    /**
     * When the users opens the Actions drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneActionsMenuOpened,
    /**
     * When the user cancels to verify a phone number
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneAddOutboundCallerIdFormCancelled,
    /**
     * When the user verifies a phone number
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneAddOutboundCallerIdFormSubmitted,
    /**
     * When the user cancels the change the hold music form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneChangeHoldMusicFormCancelled,
    /**
     * When the user changes the hold music
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneChangeHoldMusicFormSubmitted,
    /**
     * When the user cancels the Create flow form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneCreateFlowFormCancelled,
    /**
     * When the user submit the Create flow form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneCreateFlowFormSubmitted,
    /**
     * When the user clicks the See Audit Log button in phone settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionAuditLogClicked,
    /**
     * When the user selects Delete from the flow options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionDeleteClicked,
    /**
     * When the user selects Duplicate from the flow options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionDuplicateClicked,
    /**
     * When the user selects Edit from the flow options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionEditClicked,
    /**
     * When the user selects Move to another number from the flow options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionMoveToAnotherNumberClicked,
    /**
     * When the user opens the flow ellipsis menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionOpened,
    /**
     * When the user selects Rename from the flow options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFlowOptionsMenuOptionRenameClicked,
    /**
     * When the user cancels the buy number form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFormCancelled,
    /**
     * When the user opens the buy number form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFormOpened,
    /**
     * When the user buys a phone number
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneFormSubmitted,
    /**
     * When the user opens the ellipsis menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneOptionsMenuOpened,
    /**
     * When the user selects Create flow from the options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneOptionsMenuOptionCreateFlowClicked,
    /**
     * When the user selects Edit from the options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneOptionsMenuOptionEditClicked,
    /**
     * When the user selects Remove number from the options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneOptionsMenuOptionRemoveNumberClicked,
    /**
     * When the user selects Set default caller ID from the options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneOptionsMenuOptionSetDefaultCallerIdClicked,
    /**
     * When the user selects Setup from the options drop down menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneOptionsMenuOptionSetupClicked,
    /**
     * When a user downloads the voice conversation recording
     *
     * @param {PhoneRecordingDownloaded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneRecordingDownloaded,
    /**
     * When a user clicks "pause" on the voice conversation recording
     *
     * @param {PhoneRecordingPauseClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneRecordingPauseClicked,
    /**
     * When a user clicks "play" on the voice conversation recording
     *
     * @param {PhoneRecordingPlayClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneRecordingPlayClicked,
    /**
     * When a user navigates away from a conversation while the voice conversation recording is playing
     *
     * @param {PhoneRecordingPlaybackAbandoned} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneRecordingPlaybackAbandoned,
    /**
     * When the voice conversation recording plays through to the end
     *
     * @param {PhoneRecordingPlaybackEnded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneRecordingPlaybackEnded,
    /**
     * When the user searches for a flow
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    phoneSearchApplied,
    /**
     * When the user updates their availability for a channel
     *
     * @param {PresenceMediaUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    presenceMediaUpdated,
    /**
     * When the user updates their status to Away or Working
     *
     * @param {PresenceUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    presenceUpdated,
    /**
     * When the user cancels the push notification platform modal/form
     *
     * @param {PushNotificationPlatformFormCancelled} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    pushNotificationPlatformFormCancelled,
    /**
     * When the user opens one of the push notification platform listing modals/forms
     *
     * @param {PushNotificationPlatformFormOpened} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    pushNotificationPlatformFormOpened,
    /**
     * When the user submits push notification platform form
     *
     * @param {PushNotificationPlatformFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    pushNotificationPlatformFormSubmitted,
    /**
     * When the user applies a saved search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    savedSearchApplied,
    /**
     * When the user closes a saved search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    savedSearchClosed,
    /**
     * When the user creates a saved search
     *
     * @param {SavedSearchCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    savedSearchCreated,
    /**
     * When the user deletes a saved search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    savedSearchDeleted,
    /**
     * When the user updates a saved search
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    savedSearchUpdated,
    /**
     * When the user submits a csv file
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    scheduledConversationsCreatedSucceeded,
    /**
     * When the user clicks the import csv button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    scheduledConversationsCsvImportClicked,
    /**
     * When the user submits a csv file
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    scheduledConversationsCsvImported,
    /**
     * When the users closes the contact preview
     *
     * @param {SearchContactPreviewClosed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchContactPreviewClosed,
    /**
     * When the user navigates to the full contact view from the search preview
     *
     * @param {SearchContactPreviewGoToClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchContactPreviewGoToClicked,
    /**
     * When the users clicks on a contact in the search results
     *
     * @param {SearchContactPreviewOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchContactPreviewOpened,
    /**
     * When the users changes the contact type in the search results
     *
     * @param {SearchContactTypeChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchContactTypeChanged,
    /**
     * When the user closes the conversation preview
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchConversationPreviewClosed,
    /**
     * When the user navigates to the full conversation view from the search preview
     *
     * @param {SearchConversationPreviewGoToClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchConversationPreviewGoToClicked,
    /**
     * When the user clicks on a conversation in the search results
     *
     * @param {SearchConversationPreviewOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchConversationPreviewOpened,
    /**
     * When the user clicks outside of the search field and it loses focus
     *
     * @param {SearchFieldBlurred} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFieldBlurred,
    /**
     * When the user clicks the button to clear the search field
     *
     * @param {SearchFieldCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFieldCleared,
    /**
     * When the user clicks on the search field and it becomes focused
     *
     * @param {SearchFieldFocused} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFieldFocused,
    /**
     * When the user types something in the search field
     *
     * @param {SearchFieldPopulated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFieldPopulated,
    /**
     * When the user submits the value in the search field
     *
     * @param {SearchFieldSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFieldSubmitted,
    /**
     * When the user adds a search filter
     *
     * @param {SearchFilterAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterAdded,
    /**
     * When the user clears a search filter
     *
     * @param {SearchFilterCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterCleared,
    /**
     * When the user clears the value of a search filter condition
     *
     * @param {SearchFilterConditionAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterConditionAdded,
    /**
     * When the user removes a search filter condition
     *
     * @param {SearchFilterConditionRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterConditionRemoved,
    /**
     * When the user updates the operator of a search filter
     *
     * @param {SearchFilterOperatorUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterOperatorUpdated,
    /**
     * When the user removes a search filter
     *
     * @param {SearchFilterRemoved} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterRemoved,
    /**
     * When the user updates the search filtering strategy
     *
     * @param {SearchFilterStrategyUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterStrategyUpdated,
    /**
     * When the user adds a value to a search filter condition
     *
     * @param {SearchFilterValueAdded} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterValueAdded,
    /**
     * When the user adds a value to a search filter condition
     *
     * @param {SearchFilterValueCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFilterValueCleared,
    /**
     * When the user applies the search filters
     *
     * @param {SearchFiltersApplied} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFiltersApplied,
    /**
     * When the user clears the search filters
     *
     * @param {SearchFiltersCleared} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFiltersCleared,
    /**
     * When the user closes the search filters sidebar
     *
     * @param {SearchFiltersClosed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFiltersClosed,
    /**
     * When the user opens the search filters sidebar
     *
     * @param {SearchFiltersOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFiltersOpened,
    /**
     * When the validation of the search filters fails
     *
     * @param {SearchFiltersValidationFailed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchFiltersValidationFailed,
    /**
     * When the user closes the note preview
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchNotePreviewClosed,
    /**
     * When the user navigates to the full conversation view from the search preview
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchNotePreviewGoToClicked,
    /**
     * When the user clicks on a note in the search results
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchNotePreviewOpened,
    /**
     * When the user changes the search results sorting
     *
     * @param {SearchSortingUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchSortingUpdated,
    /**
     * When the user toggles strict search
     *
     * @param {SearchStrictToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchStrictToggled,
    /**
     * When the user opens a different search tab
     *
     * @param {SearchTabOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    searchTabOpened,
    /**
     * When the user clicks on "Add agent" button on agents settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAgentsAddAgentButtonClicked,
    /**
     * When the user clicks on the edit icon in the agents table on settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAgentsEditButtonClicked,
    /**
     * When the user switches between tabs on agents settings page
     *
     * @param {SettingsAgentsTabClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAgentsTabClicked,
    /**
     * When the user submits the form on workloads tab on agents settings page
     *
     * @param {SettingsAgentsWorkloadsFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAgentsWorkloadsFormSubmitted,
    /**
     * When the user opens the confirm delete modal
     *
     * @param {SettingsAudioDeleteCancelClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioDeleteCancelClicked,
    /**
     * When the user opens the confirm delete modal
     *
     * @param {SettingsAudioDeleteClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioDeleteClicked,
    /**
     * When the user opens the confirm delete modal
     *
     * @param {SettingsAudioDeleteConfirmClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioDeleteConfirmClicked,
    /**
     * When the user deletes a wait music file
     *
     * @param {SettingsAudioDeleteWaitMusicClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioDeleteWaitMusicClicked,
    /**
     * When the user uploads a wait music file
     *
     * @param {SettingsAudioUploadWaitMusic} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioUploadWaitMusic,
    /**
     * When the user interacts with audio usage
     *
     * @param {SettingsAudioUsageFlowClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioUsageFlowClicked,
    /**
     * When the user interacts with audio usage
     *
     * @param {SettingsAudioUsageLinkClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioUsageLinkClicked,
    /**
     * When the user clicks the link to see the usage of a wait music file
     *
     * @param {SettingsAudioWaitMusicUsageLinkClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsAudioWaitMusicUsageLinkClicked,
    /**
     * When the user clicks on "Add new card" button on settings billing page
     *
     * @param {SettingsBillingAddCardButtonClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsBillingAddCardButtonClicked,
    /**
     * When the user clicks on "Download" button in invoices table on settings billing page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsBillingDownloadInvoiceButtonClicked,
    /**
     * When the user the form on settings billing page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsBillingFormSubmitted,
    /**
     * When the user clicks the edit flow in the chat settings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsChatEditFlowClicked,
    /**
     * When the user assigns keybindings to a command
     *
     * @param {SettingsCommandsAssignKeybindings} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCommandsAssignKeybindings,
    /**
     * When the user resets all commands to their default keybindings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCommandsResetAllKeybindings,
    /**
     * When the user resets a command's keybindings
     *
     * @param {SettingsCommandsResetKeybindings} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCommandsResetKeybindings,
    /**
     * When the user unassigns all commands' keybindings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCommandsUnassignAllKeybindings,
    /**
     * When the user unassigns a command's keybindings
     *
     * @param {SettingsCommandsUnassignKeybindings} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCommandsUnassignKeybindings,
    /**
     * When the user activated a custom attribute
     *
     * @param {SettingsCustomAttributeActivated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeActivated,
    /**
     * When the user clicks the Add new attribute button
     *
     * @param {SettingsCustomAttributeAddNewAttributeClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeAddNewAttributeClicked,
    /**
     * When the user archives a custom attribute
     *
     * @param {SettingsCustomAttributeArchived} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeArchived,
    /**
     * When the user create a custom attribute
     *
     * @param {SettingsCustomAttributeCreated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeCreated,
    /**
     * When the user deactivates a custom attribute
     *
     * @param {SettingsCustomAttributeDeactivated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeDeactivated,
    /**
     * When the user reorders a custom attribute
     *
     * @param {SettingsCustomAttributeReordered} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeReordered,
    /**
     * When the user unarchives a custom attribute
     *
     * @param {SettingsCustomAttributeUnarchived} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeUnarchived,
    /**
     * When the user updates a custom attribute
     *
     * @param {SettingsCustomAttributeUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsCustomAttributeUpdated,
    /**
     * When the user clicks the edit flow in the email settings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsEmailEditFlowClicked,
    /**
     * When the user is on the API Tokens page and clicks the Add button which opens the dialog to add an API token
     *
     * @param {SettingsIntegrationsApiTokensAdd} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensAdd,
    /**
     * When the user is on the API Tokens page and cancels the Add Token dialog
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensAddCancel,
    /**
     * When the user is on the API Tokens page and confirms the Add Token dialog
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensAddConfirm,
    /**
     * When the user is on the API Token page and clicks on the Copy Token button
     *
     * @param {SettingsIntegrationsApiTokensCopy} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensCopy,
    /**
     * When the user is on the API Token page and clicks on the link to open the documentation for the Export Messages via Api
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensDocumentationLinkExportMessagesApi,
    /**
     * When the user is on the API Token page and clicks on the link to open the documentation for the Integrations API
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensDocumentationLinkIntegrationsApi,
    /**
     * When the user is on the API Token page and clicks on the Remove button which opens a dialog
     *
     * @param {SettingsIntegrationsApiTokensRemove} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensRemove,
    /**
     * When the user is on the API Token page and cancels the removal dialog for a token
     *
     * @param {SettingsIntegrationsApiTokensRemoveCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensRemoveCancel,
    /**
     * When the user is on the API Token page and confirms the removal dialog for a token
     *
     * @param {SettingsIntegrationsApiTokensRemoveConfirm} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensRemoveConfirm,
    /**
     * When the user is on the API Token page and clicks on the View Token button which opens a dialog
     *
     * @param {SettingsIntegrationsApiTokensView} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensView,
    /**
     * When the user is on the API Token page and cancels the view token dialog
     *
     * @param {SettingsIntegrationsApiTokensViewCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensViewCancel,
    /**
     * When the user is on the API Token page and clicks Copy token inside the view token dialog
     *
     * @param {SettingsIntegrationsApiTokensViewCopy} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsApiTokensViewCopy,
    /**
     * When the user is on the card edit page and cancels editing an existing card
     *
     * @param {SettingsIntegrationsCardEditCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardEditCancel,
    /**
     * When the user is on the card edit page and saves changes to an existing card
     *
     * @param {SettingsIntegrationsCardEditSave} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardEditSave,
    /**
     * When the user is on the card edit page and clicks on Test
     *
     * @param {SettingsIntegrationsCardEditTest} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardEditTest,
    /**
     * When the user clicks on Add card
     *
     * @param {SettingsIntegrationsCardListingAddCard} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardListingAddCard,
    /**
     * When the user clicks on Edit card
     *
     * @param {SettingsIntegrationsCardListingEditCard} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardListingEditCard,
    /**
     * When the user clicks on Remove Card
     *
     * @param {SettingsIntegrationsCardListingRemoveCard} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardListingRemoveCard,
    /**
     * When the user clicks on Remove Card but cancels the dialog
     *
     * @param {SettingsIntegrationsCardListingRemoveCardCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardListingRemoveCardCancel,
    /**
     * When the user clicks on Remove Card and confirms the dialog
     *
     * @param {SettingsIntegrationsCardListingRemoveCardConfirm} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardListingRemoveCardConfirm,
    /**
     * When the user clicks on Test card
     *
     * @param {SettingsIntegrationsCardListingTestCard} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardListingTestCard,
    /**
     * When the user clicks on the documentation link in the header
     *
     * @param {SettingsIntegrationsCardReadDocumentation} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardReadDocumentation,
    /**
     * When the user is on the test card page and clicks on Test
     *
     * @param {SettingsIntegrationsCardTest} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardTest,
    /**
     * When the user is on the test card page and adds a parameter
     *
     * @param {SettingsIntegrationsCardTestAddParameter} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardTestAddParameter,
    /**
     * When the user is on the test card page and clicks on Cancel
     *
     * @param {SettingsIntegrationsCardTestCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardTestCancel,
    /**
     * When the user is on the test card page and removes a parameter
     *
     * @param {SettingsIntegrationsCardTestRemoveParameter} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCardTestRemoveParameter,
    /**
     * When the user created a custom card.
     *
     * @param {SettingsIntegrationsCustomCardCreated} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardCreated,
    /**
     * When the user edited a custom card.
     *
     * @param {SettingsIntegrationsCustomCardEdited} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardEdited,
    /**
     * When the authentication of the OAuth provider failed.
     *
     * @param {SettingsIntegrationsCustomCardOauthProviderAuthenticationFailed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardOauthProviderAuthenticationFailed,
    /**
     * When the authentication of the OAuth provider succeeded.
     *
     * @param {SettingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardOauthProviderAuthenticationSucceeded,
    /**
     * When the authentication of the OAuth provider timed out.
     *
     * @param {SettingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardOauthProviderAuthenticationTimedOut,
    /**
     * When the user created a new OAuth provider.
     *
     * @param {SettingsIntegrationsCustomCardOauthProviderCreated} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardOauthProviderCreated,
    /**
     * When the user updated an existing OAuth provider.
     *
     * @param {SettingsIntegrationsCustomCardOauthProviderUpdated} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsCustomCardOauthProviderUpdated,
    /**
     * When the user clicks on one of the integrations
     *
     * @param {SettingsIntegrationsItemClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsItemClicked,
    /**
     * When the user is on the Settings/Podio page and clicks to add a new Podio integration
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsPodioAdd,
    /**
     * When the user is on the Settings/Podio Add page and validates the Podio credentials
     *
     * @param {SettingsIntegrationsPodioAddValidate} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsPodioAddValidate,
    /**
     * When the user is on the Settings/Podio page and clicks to remove an integration which opens the removal modal
     *
     * @param {SettingsIntegrationsPodioRemove} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsPodioRemove,
    /**
     * When the user is on the Settings/Podio page and cancels the removal modal
     *
     * @param {SettingsIntegrationsPodioRemoveCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsPodioRemoveCancel,
    /**
     * When the user is on the Settings/Podio page and confirms the removal of an integration
     *
     * @param {SettingsIntegrationsPodioRemoveConfirm} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsPodioRemoveConfirm,
    /**
     * When the user is on the Settings/Webform page and clicks on Add Webform Endpoint
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsAdd,
    /**
     * When the user is on the Settings/Webform Add Webform Endpoint modal and clicks Cancel
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsAddCancel,
    /**
     * When the user is on the Settings/Webform Add Webform Endpoint modal and clicks Save
     *
     * @param {SettingsIntegrationsWebformEndpointsAddSave} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsAddSave,
    /**
     * When the user is on the Settings/Webform and clicks on the documentation link in the header
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsReadDocumentationLink,
    /**
     * When the user is on the Settings/Webform and clicks on Remove which opens a modal
     *
     * @param {SettingsIntegrationsWebformEndpointsRemove} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsRemove,
    /**
     * When the user is on the Settings/Webform and cancels the removal modal
     *
     * @param {SettingsIntegrationsWebformEndpointsRemoveCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsRemoveCancel,
    /**
     * When the user is on the Settings/Webform and confirms the removal modal
     *
     * @param {SettingsIntegrationsWebformEndpointsRemoveConfirm} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebformEndpointsRemoveConfirm,
    /**
     * When the user is on the Settings/Webhooks page and clicks on the Add webhook button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksAdd,
    /**
     * When the user is on the Settings/Webhooks add webhooks page and cancels the form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksAddCancel,
    /**
     * When the user is on the Settings/Webhooks add webhooks page and saves the form
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksAddConfirm,
    /**
     * When the user is on the Settings/Webhooks page and created a new webhook and copies the webhook token in the confirmation dialog
     *
     * @param {SettingsIntegrationsWebhooksAddConfirmDialogCopy} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksAddConfirmDialogCopy,
    /**
     * When the user is on the Settings/Webhooks page and clicks on the documentation link
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksDocumentationLinkClicked,
    /**
     * When the user is on the Settings/Webhooks page and clicks on Edit
     *
     * @param {SettingsIntegrationsWebhooksEdit} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksEdit,
    /**
     * When the user is on the Settings/Webhooks edit page and clicks on Back to webhooks
     *
     * @param {SettingsIntegrationsWebhooksEditBack} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksEditBack,
    /**
     * When the user is on the Settings/Webhooks edit page and clicks on Save
     *
     * @param {SettingsIntegrationsWebhooksEditSave} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksEditSave,
    /**
     * When the user is on the Settings/Webhooks page and clicks on the Enabled switch to turn the webhook OFF
     *
     * @param {SettingsIntegrationsWebhooksEnabledOff} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksEnabledOff,
    /**
     * When the user is on the Settings/Webhooks page and clicks on the Enabled switch to turn the webhook ON
     *
     * @param {SettingsIntegrationsWebhooksEnabledOn} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksEnabledOn,
    /**
     * When the user is on the Settings/Webhooks page and clicks on the Remove button which opens a dialog
     *
     * @param {SettingsIntegrationsWebhooksRemove} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksRemove,
    /**
     * When the user is on the Settings/Webhooks page and cancels the Remove dialog
     *
     * @param {SettingsIntegrationsWebhooksRemoveCancel} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksRemoveCancel,
    /**
     * When the user is on the Settings/Webhooks page and confirms the Remove dialog
     *
     * @param {SettingsIntegrationsWebhooksRemoveConfirm} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksRemoveConfirm,
    /**
     * When the user is on the Settings/Webhooks page and clicks on the a webhook to see the details
     *
     * @param {SettingsIntegrationsWebhooksView} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksView,
    /**
     * When the user is on the Settings/Webhooks page and views a webhook and clicks on the copy secret button
     *
     * @param {SettingsIntegrationsWebhooksViewCopySecret} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksViewCopySecret,
    /**
     * When the user is on the Settings/Webhooks page and views a webhook and clicks on the edit button
     *
     * @param {SettingsIntegrationsWebhooksViewEdit} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksViewEdit,
    /**
     * When the user is on the Settings/Webhooks page and views a webhook and clicks on the back button to go to the list
     *
     * @param {SettingsIntegrationsWebhooksViewEditBack} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsIntegrationsWebhooksViewEditBack,
    /**
     * When the user clicks the settings menu item
     *
     * @param {SettingsMenuItemClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsMenuItemClicked,
    /**
     * When the user submits the form on organization settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsOrganizationFormSubmitted,
    /**
     * When the user changes organization logo
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsOrganizationLogoChanged,
    /**
     * When the user submits the form on profile settings page
     *
     * @param {SettingsProfileFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsProfileFormSubmitted,
    /**
     * When the user added a queue
     *
     * @param {SettingsQueueAdded} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueAdded,
    /**
     * When the user performed a search.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueAgentDeleted,
    /**
     * When an agent was deleted.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueAgentSearchSubmitted,
    /**
     * When sorting was applied.
     *
     * @param {SettingsQueueAgentSorted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueAgentSorted,
    /**
     * When the queue settings alerts form was saved.
     *
     * @param {SettingsQueueAlertsSaved} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueAlertsSaved,
    /**
     * When the user saved a queue
     *
     * @param {SettingsQueueSaved} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueSaved,
    /**
     * When the Add team button was clicked.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueTeamsAddTeamButtonClicked,
    /**
     * When the Add team form was submitted.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueTeamsAddTeamFormSubmitted,
    /**
     * When the Delete team button was clicked.
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueueTeamsDeleteTeamButtonClicked,
    /**
     * When the user clicks the Add Queue button in the queue settings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueuesAddQueueClicked,
    /**
     * When the users clicks the archive queue button in the queue settings
     *
     * @param {SettingsQueuesArchiveQueueClicked} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueuesArchiveQueueClicked,
    /**
     * When the user clicks the edit button in the queue settings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueuesEditQueueClicked,
    /**
     * When the users clicks the unarchive queue button in the queue settings
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsQueuesUnarchiveQueueClicked,
    /**
     * When the user clicks on Add Tag button on tags settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTagsAddTagButtonClicked,
    /**
     * When the user clicks on delete icon on tags settings page
     *
     * @param {SettingsTagsRemoveTagButtonClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTagsRemoveTagButtonClicked,
    /**
     * When the user presses confirm button on delete team modal
     *
     * @param {SettingsTagsRemoveTagConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTagsRemoveTagConfirmed,
    /**
     * When the user activates a tag on tags settings page
     *
     * @param {SettingsTagsTagActivated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTagsTagActivated,
    /**
     * When the user deactivates a tag on tags settings page
     *
     * @param {SettingsTagsTagDeactivated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTagsTagDeactivated,
    /**
     * When the user clicks on "Add team" button on team settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTeamAddTeamButtonClicked,
    /**
     * When the user clicks on "Add agents" button on team details settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTeamDetailsAddAgentsButtonClicked,
    /**
     * When the user clicks on "Edit" icon in the table on team settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTeamEditTeamButtonClicked,
    /**
     * When the user submits the form on team modal
     *
     * @param {SettingsTeamModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTeamModalFormSubmitted,
    /**
     * When the user clicks on "Remove" icon in the table on team settings page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTeamRemoveTeamButtonClicked,
    /**
     * When the user presses confirm button on delete team modal
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTeamRemoveTeamConfirmed,
    /**
     * When the user clicks on the add button in one of the tabs on templates settings page
     *
     * @param {SettingsTemplatesAddTemplateButtonClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesAddTemplateButtonClicked,
    /**
     * When the user clicks on the edit icon in one of the tabs on templates settings page
     *
     * @param {SettingsTemplatesEditTemplateButtonClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesEditTemplateButtonClicked,
    /**
     * When the user submits the form on template modal on templates settings page
     *
     * @param {SettingsTemplatesModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesModalFormSubmitted,
    /**
     * When the user submits the form on template old modal on templates settings page
     *
     * @param {SettingsTemplatesOldModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesOldModalFormSubmitted,
    /**
     * When the user clicks on the delete icon in one of the tabs on templates settings page
     *
     * @param {SettingsTemplatesRemoveTemplateButtonClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesRemoveTemplateButtonClicked,
    /**
     * When the user clicks on confirm button on remove template confirm modal on templates settings page
     *
     * @param {SettingsTemplatesRemoveTemplateConfirmed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesRemoveTemplateConfirmed,
    /**
     * When the user switches between tabs on templates settings page
     *
     * @param {SettingsTemplatesTabClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    settingsTemplatesTabClicked,
    /**
     * When the user opens and closes a tab or window if there are any instances left and when the focus changes between different instances
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sharedWorkerTabOrWindowChanged,
    /**
     * When the user closes the agent interface. Including every tab and window.
     *
     * @param {SharedWorkerTabOrWindowClosed} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sharedWorkerTabOrWindowClosed,
    /**
     * When the user opens the agent interface. Including every tab and window.
     *
     * @param {SharedWorkerTabOrWindowOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sharedWorkerTabOrWindowOpened,
    /**
     * When the user clicks on add agent icon on sidebar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sidebarAddAgentButtonClicked,
    /**
     * When the sidebar is collapsed
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sidebarCollapsed,
    /**
     * When the sidebar is expanded
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sidebarExpanded,
    /**
     * When the user clicks on a navigation link in the sidebar
     *
     * @param {SidebarNavClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    sidebarNavClicked,
    /**
     * When the user aborts signing out
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    signOutAborted,
    /**
     * When the user confirms signing out
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    signOutConfirmed,
    /**
     * When the user updates their simultaneous ring status
     *
     * @param {SimultaneousRingUpdated} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    simultaneousRingUpdated,
    /**
     * When the user clicks the "Smart Conversation Reply" button from the Elevio or Dixa knowledge sidebar card
     *
     * @param {SmartConversationReplyButtonClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    smartConversationReplyButtonClicked,
    /**
     * When the user clicks on the inline tag creation item on the list to create a tag with the searched value
     *
     * @param {TagSelectCreateNewTagClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    tagSelectCreateNewTagClicked,
    /**
     * When the user changes the tag color on Create new tag modal
     *
     * @param {TagsCreateModalColorChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    tagsCreateModalColorChanged,
    /**
     * When the user submits the form on Create new tag modal
     *
     * @param {TagsCreateModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    tagsCreateModalFormSubmitted,
    /**
     * When the user opens the Create new tag modal
     *
     * @param {TagsCreateModalOpened} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    tagsCreateModalOpened,
    /**
     * When the user clicks the agent actions menu item
     *
     * @param {TeamAgentActionsMenuItemClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamAgentActionsMenuItemClicked,
    /**
     * When the user opens the agent actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamAgentActionsMenuOpened,
    /**
     * When the user collapsed the agent item
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamAgentCollapsed,
    /**
     * When the user expands the agent item
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamAgentExpanded,
    /**
     * When the user clicks the Assigned Agents Only button
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamAssignedAgentsOnlyClicked,
    /**
     * When the user clicks the conversation actions menu item
     *
     * @param {TeamConversationActionsMenuItemClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamConversationActionsMenuItemClicked,
    /**
     * When the user opens the conversation actions menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamConversationActionsMenuOpened,
    /**
     * When the user clicks the status link in the conversation
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamConversationStatusLinkClicked,
    /**
     * When the user clicks the title link in the conversation
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamConversationTitleLinkClicked,
    /**
     * When the user toggles the favorite agent
     *
     * @param {TeamFavoriteToggled} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamFavoriteToggled,
    /**
     * When the user clicks the filter menu item
     *
     * @param {TeamFilterMenuItemClicked} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamFilterMenuItemClicked,
    /**
     * When the user opens the filter agents menu
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamFilterMenuOpened,
    /**
     * When the user clicks the next page on the Team page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamNextPageClicked,
    /**
     * When the user clicks the previous page on the Team page
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    teamPreviousPageClicked,
    /**
     * When Beamer is opened from the topbar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    topbarBeamerOpened,
    /**
     * When the email dropdown in the topbar is opened
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    topbarEmailOpened,
    /**
     * When the notifications dropdown is opened from the topbar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    topbarNotificationsOpened,
    /**
     * When the phones dropdown in the topbar is opened
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    topbarPhonesOpened,
    /**
     * When the queues dropdown is opened from the topbar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    topbarQueuesOpened,
    /**
     * When the support menu is opened from the topbar
     *
     * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    topbarSupportOpened,
    /**
     * When the user submits the form on user modal
     *
     * @param {UserModalFormSubmitted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    userModalFormSubmitted,
    /**
     * When the active websocket connection changes
     *
     * @param {WebsocketActiveConnectionChanged} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    websocketActiveConnectionChanged,
    /**
     * When the websocket receives a close event
     *
     * @param {WebsocketCloseEventReceived} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    websocketCloseEventReceived,
    /**
     * When the websocket connection is created
     *
     * @param {WebsocketConnectionClosed} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    websocketConnectionClosed,
    /**
     * When the websocket connection is closed
     *
     * @param {WebsocketConnectionCreated} [props] - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    websocketConnectionCreated,
    /**
     * When the websocket reconnect attempt starts
     *
     * @param {WebsocketReconnectAttemptStarted} props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 		call is fired.
     */
    websocketReconnectAttemptStarted,
};
export default new Proxy(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && target.hasOwnProperty(method)) {
            return target[method];
        }
        return () => {
            console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
    a) Re-generate your typewriter client: \`npx typewriter\`
    b) Add it to your Tracking Plan: https://app.segment.com/dixahq/protocols/tracking-plans/rs_1eP1qBRQ0EMkSYOn0hUYH6RH8O9`);
            const a = analytics();
            if (a) {
                a.track('Unknown Analytics Call Fired', {
                    method,
                }, withTypewriterContext());
            }
        };
    },
});
